import React, { useState, useEffect, useRef } from 'react';
import { FileText, Globe, Eye, X, Send, CheckCircle, Upload, XCircle } from 'lucide-react';
import apiService from '../config';
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../StoreContext/LanguageContext';
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';
import SendTrackingModal from '../CommonModel/SendTrackingModal';

export const Section23 = ({ onBack, onUpdated }) => {

    const { language, translations } = useLanguage();
    const [projectId, setProjectId] = useState(null);
    const [projectName, setProjectName] = useState(null);
    const [proposalId, setProposalId] = useState(null);
    const notificationContentRef = useRef(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [showSignaturePad, setShowSignaturePad] = useState(false);
    const [pdfForSigning, setPdfForSigning] = useState(null);
    const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
    // Proposal
    const [proposalData, setProposalData] = useState({});
    const [ProposalLoading, setProposalLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    
    const [showTrackingModal, setShowTrackingModal] = useState(false);
    const [trackingRole, setTrackingRole] = useState('');

    const [formData, setFormData] = useState({
        // Read-only fields (fetch but don't update)
        acquisition_proposal_no: '',
        acquisition_proposal_date: '',
        propsal_publication_date: '',
        propsal_publication_no: '',

        // Editable fields
        project_description: '',
        project_social_benfit: '',
        administrative_order_no: '',
        administrative_order_date: '',
        propsal_proceeding_no: '',
        propsal_proceeding_date: '',
        acquisition_authority_no: '',
        acquisition_authority_date: '',
        // displacement_reason: '',
        section_23_rehabilitation_plan_summary: '',
        appointed_administrator: '',
        project_name: '',
        section_19_bhusampadan_no: '', section_19_office_name: '',
        section_19_branch_name: '',
        section_23_content: '',
        section_23_tip: '',
        section_23_bhusampadan_no: '',
        section_23_office_name: '',
        section_23_branch_name: '',
        section_23_notification: '',
        section_23_email: '',
        section_23_address: '',
        section_23_mobile_no: '',
        section_23_date: '',
        section_23_nature_of_land: '',
        section_23_no1_content: '',
        section_23_no2_content: '',
        section_23_no3_a_content: '',
        section_23_no3_b_content: '',
        section_23_no7_content: '',
        section_23_no8_a_content: '',
        section_23_no8_b_content: '',
        section_23_no11_content: '',
        section_23_no12_2_default_content: '',
        section_23_no12_2_b_content: '',
        section_23_no12_2_b_table_ids: '',
        section_23_no12_2_c_content: '',
        section_23_no12_2_d_content: '',
        section_23_no12_2_e_content: '',
        section_23_no12_3_content: '',
        section_23_no12_4_content: '',
        section_23_no12_5_content: '',
        section_23_no12_6_content: '',
        section_23_no13_a_1_content: '',
        section_23_no13_a_2_content: '',
        section_23_no13_b_content: '',
        section_23_no13_c_content: '',
        section_23_no13_d_content: '',
        section_23_no13_e_content: '',
        section_23_no14_content: '',
        section_23_no15_content: '',
        section_23_no16_content: '',
        section_23_no17_content: '',
        section_23_no18_content: '',
        section_23_no19_content: '',
        section_23_last_content: '',
        section_23_3_publication_no12: '',
        // 4
        dslr_office_name: '',
        surveyor_joint_end_date: '',
        section_23_5_acquisition_area_letter_no: '',
        section_23_5_acquisition_area_compliance_report_date: '',
        section_23_9_21Gazette_date: '',
        section_23_9_21tehsil_office_date: '',
        section_23_9_21given_notice_date: '',
        section_23_9_21objections_representations_statements_no: '',
        section_23_9_21inquiry_date: '',
        section_23_9_21present_lanholders: '',
        section_23_9_21inquiry_completion_date: '',
        section_23_9_21disposal_objections_date: '',
    });

    // Define which fields are editable
    const editableFields = [
        'administrative_order_no',
        'administrative_order_date',
        'propsal_proceeding_no',
        'propsal_proceeding_date',
        'acquisition_authority_no',
        'acquisition_authority_date',
        'section_23_content',
        'section_23_tip',
        'section_23_bhusampadan_no',
        'section_23_office_name',
        'section_23_branch_name',
        'section_23_notification',
        'section_23_email',
        'section_23_address',
        'section_23_mobile_no',
        'section_23_date',
        'section_23_nature_of_land',
        'section_23_no1_content',
        'section_23_no2_content',
        'section_23_no3_a_content',
        'section_23_no3_b_content',
        'section_23_no7_content',
        'section_23_no8_a_content',
        'section_23_no8_b_content',
        'section_23_no11_content',
        'section_23_no12_2_default_content',
        'section_23_no12_2_b_content',
        'section_23_no12_2_b_table_ids',
        'section_23_no12_2_c_content',
        'section_23_no12_2_d_content',
        'section_23_no12_2_e_content',
        'section_23_no12_3_content',
        'section_23_no12_4_content',
        'section_23_no12_5_content',
        'section_23_no12_6_content',
        'section_23_no13_a_1_content',
        'section_23_no13_a_2_content',
        'section_23_no13_b_content',
        'section_23_no13_c_content',
        'section_23_no13_d_content',
        'section_23_no13_e_content',
        'section_23_no14_content',
        'section_23_no15_content',
        'section_23_no16_content',
        'section_23_no17_content',
        'section_23_no18_content',
        'section_23_no19_content',
        'section_23_last_content',
        'section_23_3_publication_no12',
        // 4
        'dslr_office_name',
        'surveyor_joint_end_date',
        'section_23_5_acquisition_area_letter_no',
        'section_23_5_acquisition_area_compliance_report_date',
        'section_23_9_21Gazette_date',
        'section_23_9_21tehsil_office_date',
        'section_23_9_21given_notice_date',
        'section_23_9_21objections_representations_statements_no',
        'section_23_9_21inquiry_date',
        'section_23_9_21present_lanholders',
        'section_23_9_21inquiry_completion_date',
        'section_23_9_21disposal_objections_date',
    ];
    const [selected12BIds, setSelected12BIds] = useState([]); //Direct Purchase Id
    const [selected12CIds, setSelected12CIds] = useState([]); //Direct Purchase Id
    const [selected12DIds, setSelected12DIds] = useState([]); //Direct Purchase Id

    // Land Acqusition data
    const [groupedData, setGroupedData] = useState([]);
    const [landData, setLandData] = useState([]);
    const [landLoadingRecords, setLandLoadingRecords] = useState([]);

    // general objections
    const [generalObjectionData, setGeneralObjectionData] = useState([]);
    // Compensation
    const [ownersCompensationData, setOwnerCompensationData] = useState([]);
    const [allOwnerCompensationData, setAllOwnerCompensationData] = useState([]);
    // Owner Market Value
    const [ownerMarketValueData, setOwnerMarketValueData] = useState([]);

    // Tracking
    const [trackingData, setTrackingData] = useState([]);

    // Punarvarshan
    const [punarvarshanData, setPunarvarshanData] = useState([]);

    // Direct Purchase
    const [directPurchaseData, setDirectPurchaseData] = useState([]);

    // Approval
    const [approval, setApproval] = useState(null);

    const [selectedDocument, setSelectedDocument] = useState(null);


    // Samanvay
    const [showSendToSamanvayModal, setshowSendToSamanvayModal] = useState(false);
    const [selectedDocumentSamanvay, setselectedDocumentSamanvay] = useState(null);
    const [remarksSamanvay, setremarksSamanvay] = useState('Approved');
    const [sendingToSamanvay, setsendingToSamanvay] = useState(false);
    const [usersSamanvay, setusersSamanvay] = useState([]);
    const [loadingusersSamanvay, setLoadingusersSamanvay] = useState(false);
    const [selectedUserSamanvay, setselectedUserSamanvay] = useState('');
    // Collector
    const [showSendToCollectorModal, setshowSendToCollectorModal] = useState(false);
    const [selectedDocumentCollector, setselectedDocumentCollector] = useState(null);
    const [remarksCollector, setremarksCollector] = useState('Approved');
    const [sendingToCollector, setsendingToCollector] = useState(false);
    const [usersCollectorAll, setusersCollectorAll] = useState([]);
    const [loadingusersCollector, setLoadingusersCollector] = useState(false);
    const [selectedUserCollector, setselectedUserCollector] = useState('');
    const [isApproved, setIsApproved] = useState("");
    // LAO
    const [showSendToLAOModal, setshowSendToLAOModal] = useState(false);
    const [selectedDocumentLAO, setselectedDocumentLAO] = useState(null);
    const [remarksLAO, setremarksLAO] = useState('Approved');
    const [sendingToLAO, setsendingToLAO] = useState(false);
    // const [usersLAO, setusersLAO] = useState([]);
    const [loadingusersLAO, setLoadingusersLAO] = useState(false);
    const [selectedUserLAO, setselectedUserLAO] = useState('');
    // Button Status
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [collectorEditCompletedbuttonDisabled, setCollectorEditCompletedbuttonDisabled] = useState(false);
    // Documents Viewer state
    const [showDocumentViewer, setShowDocumentViewer] = useState(false);
    const [fileUrlToView, setFileUrlToView] = useState('');
    const [isPDFToView, setIsPDFToView] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);

    // LAO Name and Designation
    const [usersLAO, setusersLAO] = useState([]);
    const laoName = usersLAO?.[0]?.full_name || 'N/A';
    const laoDesi = usersLAO?.[0]?.designation || 'N/A';
    console.log('User Name:', laoName);
    console.log('User Designation:', laoDesi);

    const [uploadingDataEntry, setUploadingDataEntry] = useState(false);
    const [uploadedDataEntryFileUrl, setUploadedDataEntryFileUrl] = useState('');

    // ADD THESE NEW STATE VARIABLES HERE:
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        title: '',
        message: '',
        type: 'success'
    });
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        type: 'warning'
    });

    const ROLES = {
        COLLECTOR: 1,
        LAO: 3,
        SAMANVAY: 6,
        DATA_ENTRY: 14
    };

    const [currentType, setCurrentType] = useState('');

    const [proposalDistrict, setProposalDistrict] = useState('');
const [proposalTaluka,   setProposalTaluka]   = useState('');
const [proposalVillage,  setProposalVillage]  = useState('');

useEffect(() => {
  try {
    const selProposalStr = localStorage.getItem('selectedProposal');
    if (selProposalStr) {
      const proposal = JSON.parse(selProposalStr);
      setProposalDistrict(proposal.dist_name   || proposal.distName   || '');
      setProposalTaluka(proposal.taluka_name  || proposal.talukaName  || '');
      setProposalVillage(proposal.village_name || proposal.villageName || '');
    }
  } catch (err) {
    console.error('Error reading selectedProposal:', err);
  }
}, []);

    useEffect(() => {
        const storedType = localStorage.getItem('section23Type');
        console.log("🎯 Section23 Initializing with type:", storedType);
        if (storedType) {
            setCurrentType(storedType);
        }
    }, []);

    // Project Id
    useEffect(() => {
        const getProjectInfo = () => {
            const currentProjectData = localStorage.getItem('currentProjectData');
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return {
                        id: projectData.project_id || projectData.id,
                        name: projectData.project_name || projectData.name
                    };
                } catch (e) {
                    console.error('Error parsing current project data (currentProjectData):', e);
                }
            }

            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selected project (selectedProject):', e);
                }
            }

            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const projectId = user.data?.project_id || user.project_id;
                    const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
                    return {
                        id: projectId,
                        name: projectName
                    };
                } catch (e) {
                    console.error('Error parsing user data (userData):', e);
                }
            }
            return { id: null, name: null };
        };

        const projectInfo = getProjectInfo();
        setProjectId(projectInfo.id);
        setProjectName(projectInfo.name);
        console.log('Current Project Info:', projectInfo);
    }, []);

    // Proposal id
    useEffect(() => {
        const getProposalInfo = () => {
            const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

            if (currentProposal) {
                try {
                    return {
                        proposalId: currentProposal?.data?.default_proposal ||
                            currentProposal?.data?.proposal_id ||
                            currentProposal?.default_proposal ||
                            currentProposal?.proposal_id ||
                            null
                    }
                } catch (e) {
                    console.error('Error parsing current project data (getProposalInfo):', e);
                }
            }
            return { proposalId: null };
        };

        const proposalInfo = getProposalInfo();
        setProposalId(proposalInfo.proposalId);
        console.log('Current Project-Proposal Info:', proposalInfo);
    }, []);

    useEffect(() => {
        if (projectId && proposalId) {
            fetchProposalData();
            fetchOwnersData();
            fetchGeneralObjections();
            fetchCompensationOwners();
            fetchusersLAO();
            fetchTrackingDetails();
            fetchOwnerMatketValueData();
            fetchPunarvarshanData();
            fetchDirectPurchaseData();
            fetchButtonStatus();

            // ✅ Pre-load existing uploaded document URL so View button shows on reload
            (async () => {
                try {
                    const fileResponse = await apiService.getSectionFile(projectId, proposalId, "section23");
                    if (fileResponse?.status === 200 && fileResponse.data?.length > 0) {
                        setUploadedDataEntryFileUrl(fileResponse.data[0].file_path);
                    }
                } catch (err) {
                    // No file yet, that's fine
                }
            })();

            if (userRole === ROLES.LAO || ROLES.COLLECTOR) {
                fetchusersSamanvay();
            }
            if (userRole === ROLES.SAMANVAY) {
                fetchUsersAllCollector();
            }

        }
        // ...
    }, [projectId, proposalId]);
    // Proposal
    const fetchProposalData = async () => {
        setProposalLoading(true);
        try {
            const response = await apiService.getProposalPublish(projectId, proposalId);
            if (response.status === 200 && response.data) {
                const data = response.data;
                setProposalData(data);
                setFormData(data);
            } else {
                console.log('No proposal data found');
            }

        } catch (err) {
            console.error('Error fetching proposal data:', err);
            alert('Failed to fetch proposal data');
        } finally {
            setProposalLoading(false);
        }
    };

    // Land Acquisition Owners
    const fetchOwnersData = async () => {

        // Add validation to ensure both IDs are valid numbers
        if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        try {
            setLandLoadingRecords(true);

            const result = await apiService.get("getAllOwner", {
                projectId: projectId,
                proposalId: proposalId,
                isActive: 1
            });

            // Land Acquisition Owners data
            if (result.status === 200 && Array.isArray(result.landAcquisition)) {
                const grouped = {};
                const groupedLand = {};

                result.landAcquisition.forEach(item => {
                    // Only include if owners array exists and has data
                    if (Array.isArray(item.owners) && item.owners.length > 0) {
                        const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
                        if (!grouped[key]) {
                            grouped[key] = [];
                        }

                        // Push each owner as a separate record
                        item.owners.forEach(owner => {
                            grouped[key].push({
                                survey_no: owner.survey_no,
                                owner_name: owner.owner_name,
                                land_holding_type: owner.land_holding_type,
                                aqr_area: owner.owner_aqr_area,
                                total_area: parseFloat(item.total_area || 0),
                                owner_irrigable_area: owner.owner_irrigable_area || 0,
                                owner_non_irrigable_area: owner.owner_non_irrigable_area || 0
                            });
                        });
                    }

                    // Irrigable
                    const landKey = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
                    if (!groupedLand[landKey]) {
                        groupedLand[landKey] = [];
                    }

                    groupedLand[landKey].push({
                        survey_no: item.survey_no,
                        irrigable_area: item.irrigable_area,
                        non_irrigable_area: item.non_irrigable_area,
                        total_area: parseFloat(item.total_area || 0),
                        land_holding_type: item.land_holding_type,
                        landholder_name: item.landholder_name,
                    })

                });

                // Convert to array for rendering
                const groupedArray = Object.entries(grouped).map(([key, records]) => {
                    const [dist, taluka, village] = key.split('-');

                    // Owner
                    const ownerTotalIrrigable = records.reduce(
                        (sum, r) => sum + parseFloat(r.owner_irrigable_area || 0),
                        0
                    );

                    const ownerTotalNonIrrigable = records.reduce(
                        (sum, r) => sum + parseFloat(r.owner_non_irrigable_area || 0),
                        0
                    );

                    const total = records.reduce((sum, r) => sum + parseFloat(r.aqr_area || 0), 0);
                    const irrigableNonIrrigableTotal = ownerTotalIrrigable + ownerTotalNonIrrigable;
                    return { dist, taluka, village, records, total, ownerTotalIrrigable, ownerTotalNonIrrigable, irrigableNonIrrigableTotal };
                });

                const holderData = Object.entries(groupedLand).map(([key, records]) => {
                    const [dist, taluka, village] = key.split('-');
                    const irrigableTotal = records.reduce((sum, r) => sum + parseFloat(r.irrigable_area || 0), 0);
                    const nonIrrigableTotal = records.reduce((sum, r) => sum + parseFloat(r.non_irrigable_area || 0), 0);
                    const finalTotal = records.reduce((sum, r) => sum + parseFloat(r.total_area || 0), 0);
                    return { dist, taluka, village, records, irrigableTotal, nonIrrigableTotal, finalTotal };
                });

                setGroupedData(groupedArray);
                setLandData(holderData);
            }

        } catch (error) {
            console.error('Error fetching Prathmik Adhisuchna data:', error);
            // alert('❌ Error fetching proposal data.');
        } finally {
            setLandLoadingRecords(false);
        }
    };

    // General Objections
    const fetchGeneralObjections = async () => {

        try {
            const result = await apiService.getAllGeneralObjections(projectId, proposalId);

            let dataArray = null;

            if (Array.isArray(result.data)) {
                dataArray = result.data;
            } else if (Array.isArray(result)) {
                // Sometimes the result itself is the array
                dataArray = result;
            } else if (result.response && Array.isArray(result.response.data)) {
                // Sometimes it's nested in response
                dataArray = result.response.data;
            }

            if (dataArray) {
                setGeneralObjectionData(dataArray);
            } else {
                console.warn("❌ Could not find data array in response");
                setGeneralObjectionData([]);
            }

        } catch (error) {
            console.error('Error fetching Prathmik Adhisuchna data:', error);
            // alert('❌ Error fetching proposal data.');
        } finally {
            setLandLoadingRecords(false);
        }
    };

    // Compenstation
    const fetchCompensationOwners = async () => {
        if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        try {
            const response = await apiService.getOwnerCompensationSection23(projectId, proposalId);

            if (response && (response.status === 200 || response.data)) {
                let dataArray = [];

                // Handle different response structures
                if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    dataArray = response.data.data;
                } else if (response.data && Array.isArray(response.data)) {
                    dataArray = response.data;
                } else if (Array.isArray(response)) {
                    dataArray = response;
                } else if (response.data && !Array.isArray(response.data)) {
                    dataArray = [response.data];
                } else if (response && !response.data) {
                    dataArray = [response];
                }

                // Process all compensation data (trees, wells, and borewells)
                const processedCompensationData = processCompensationData(dataArray);
                setOwnerCompensationData(processedCompensationData);

                const allCompensationAmount = finalCompensationData(dataArray);
                setAllOwnerCompensationData(allCompensationAmount);
            } else {
                setOwnerCompensationData([]);
                setAllOwnerCompensationData([]);
            }
        } catch (error) {
            console.error('Error loading all compensation data:', error);
            setOwnerCompensationData([]);
            setAllOwnerCompensationData([]);
        }
    };

    const processCompensationData = (dataArray) => {
        const compensationRows = [];
        let serialNumber = 1;

        dataArray.forEach(owner => {
            const ownerGroup = {
                ownerId: owner.land_owner_id,
                gatNo: owner.survey_no || '',
                ownerName: owner.owner_name || '',
                trees: [],
                wells: [],
                borewells: [],
                pipelines: [],
                structures: [], // For home, tinshed, etc.
                totalTreeAmount: 0,
                totalWellAmount: 0,
                totalBorewellAmount: 0,
                totalPipelineAmount: 0,
                totalStructureAmount: 0
            };

            // Process Trees (existing code)
            if (owner.tree && Array.isArray(owner.tree) && owner.tree.length > 0) {
                owner.tree.forEach(treeItem => {
                    const calculatedAmount = treeItem.tree_amount_lao || treeItem.tree_amount_valuer || 0;

                    ownerGroup.totalTreeAmount += calculatedAmount;

                    ownerGroup.trees.push({
                        serialNo: serialNumber,
                        treeType: treeItem.tree_type_name || '',
                        treeCategory: treeItem.tree_type_name1 || '',
                        treeCount: treeItem.tree_count || 0,
                        laoAmount: treeItem.tree_value_lao || 0,
                        valuerAmount: treeItem.tree_value_valuer || 0,
                        calculatedAmount: calculatedAmount,
                        originalTree: treeItem
                    });

                    serialNumber++;
                });
            }

            // Process Wells
            if (owner.well && Array.isArray(owner.well) && owner.well.length > 0) {
                owner.well.forEach(wellItem => {
                    // Calculate well amount - you may need to adjust this logic based on your requirements
                    const calculatedAmount = wellItem.Property_amount_lao || wellItem.Property_amount_valuer || 0;

                    ownerGroup.totalWellAmount += calculatedAmount;

                    ownerGroup.wells.push({
                        serialNo: serialNumber,
                        wellLength: wellItem.Property_length || 0,
                        wellDepth: wellItem.Property_depth || 0,
                        wellTotal: wellItem.total || 0,
                        laoAmount: wellItem.Property_amount_lao || 0,
                        valuerAmount: wellItem.Property_amount_valuer || 0,
                        calculatedAmount: calculatedAmount,
                        originalWell: wellItem
                    });

                    serialNumber++;
                });
            }

            // Process Borewells
            if (owner.borewell && Array.isArray(owner.borewell) && owner.borewell.length > 0) {
                owner.borewell.forEach(borewellItem => {
                    const calculatedAmount = borewellItem.Property_amount_lao || borewellItem.Property_amount_valuer || 0;

                    ownerGroup.totalBorewellAmount += calculatedAmount;

                    ownerGroup.borewells.push({
                        serialNo: serialNumber,
                        borewellDepth: borewellItem.Property_depth || 0,
                        borewellTotal: borewellItem.total || 0,
                        laoAmount: borewellItem.Property_amount_lao || 0,
                        valuerAmount: borewellItem.Property_amount_valuer || 0,
                        calculatedAmount: calculatedAmount,
                        originalBorewell: borewellItem
                    });

                    serialNumber++;
                });
            }

            // Process Pipelines
            if (owner.pipeline && Array.isArray(owner.pipeline) && owner.pipeline.length > 0) {
                owner.pipeline.forEach(pipelineItem => {
                    const calculatedAmount = pipelineItem.Property_amount_lao || pipelineItem.Property_amount_valuer || 0;

                    ownerGroup.totalPipelineAmount += calculatedAmount;

                    ownerGroup.pipelines.push({
                        serialNo: serialNumber,
                        pipelineLength: pipelineItem.Property_length || 0,
                        laoAmount: pipelineItem.Property_amount_lao || 0,
                        valuerAmount: pipelineItem.Property_amount_valuer || 0,
                        calculatedAmount: calculatedAmount,
                        originalPipeline: pipelineItem
                    });

                    serialNumber++;
                });
            }

            // Process Structures (home, tinshed, etc.)
            const structureTypes = ['home', 'tinshed/godown', 'wirefencing', 'farmpond', 'other'];

            structureTypes.forEach(structureType => {
                if (owner[structureType] && Array.isArray(owner[structureType]) && owner[structureType].length > 0) {
                    owner[structureType].forEach(structureItem => {
                        const calculatedAmount = structureItem.Property_amount_lao || structureItem.Property_amount_valuer || 0;

                        ownerGroup.totalStructureAmount += calculatedAmount;

                        ownerGroup.structures.push({
                            serialNo: serialNumber,
                            structureType: structureType,
                            structureWidth: structureItem.Property_width || 0,
                            structureLength: structureItem.Property_length || 0,
                            structureDepth: structureItem.Property_depth || 0,
                            structureHeight: structureItem.Property_height || 0,
                            structureTotal: structureItem.total || 0,
                            laoAmount: structureItem.Property_amount_lao || 0,
                            valuerAmount: structureItem.Property_amount_valuer || 0,
                            calculatedAmount: calculatedAmount,
                            originalStructure: structureItem
                        });

                        serialNumber++;
                    });
                }
            });

            // Only add owners who have at least one item
            if (ownerGroup.trees.length > 0 || ownerGroup.wells.length > 0 ||
                ownerGroup.borewells.length > 0 || ownerGroup.pipelines.length > 0 ||
                ownerGroup.structures.length > 0) {
                compensationRows.push(ownerGroup);
            }
        });

        return compensationRows;
    };

    const buildLocationParams = () => {
  let params = '';
  if (proposalDistrict) params += `&distName=${encodeURIComponent(proposalDistrict)}`;
  if (proposalTaluka)   params += `&talukaName=${encodeURIComponent(proposalTaluka)}`;
  if (proposalVillage)  params += `&villageName=${encodeURIComponent(proposalVillage)}`;
  return params;
};

    // Owner Market Value
    const fetchOwnerMatketValueData = async () => {
        setProposalLoading(true);
        try {
            const response = await apiService.getOwnerMarketValue(projectId, proposalId, buildLocationParams());
            if (response.status === 200 && response.data) {
                const data = response.data;
                setOwnerMarketValueData(data);
            } else {
                console.log('No proposal data found');
            }

        } catch (err) {
            console.error('Error fetching proposal data:', err);
            alert('Failed to fetch proposal data');
        } finally {
            setProposalLoading(false);
        }
    };

    // get Market Value and Groupno as per Survey No
    const getMarketData = (surveyNo, field) => {
        if (!ownerMarketValueData || ownerMarketValueData.length === 0) return null;

        const record = ownerMarketValueData.find(
            (item) => item.survey_no === surveyNo
        );

        return record ? record[field] : null;
    };

    // Get market value SurveyNos in range no 12(1)
    const getMarketValueSurveyNo = (start, end) => {
        if (!ownerMarketValueData || ownerMarketValueData.length === 0) return "";

        const records = ownerMarketValueData.filter(
            (item) => item.rate_per_hectare >= start && item.rate_per_hectare <= end
        );

        // Map survey numbers and join by comma
        const surveyNos = records.map(r => r.survey_no).join(", ");

        return surveyNos || "";
    };

    const formatAmount = (value) => {
        if (!value) return "0/-";
        const rounded = Math.round(value); // Round off decimals
        return rounded.toLocaleString("en-IN") + "/-"; // Format in Indian numbering system
    };

    const finalCompensationData = (dataArray) => {

        const compensationRows = [];
        let totals = {
            landRate: 0,
            landAmount: 0,
            treeAmount: 0,
            borewellAmount: 0,
            firstTotal: 0,
            dilasaAmount: 0,
            interestAmount: 0,
            pipelineAmount: 0,
            secondTotal: 0,
            advancedAmount: 0,
            recoveredUnearnedAmount: 0,
            finalAmount: 0,
            totalAquiredArea: 0
        };

        dataArray.forEach((item, index) => {
            const totalAquiredArea = item.owner_aqr_area || 0;
            const landRate = (Number(item.land_rate) * (Number(item.owner_aqr_area) || 1)) || 0;
            const landAmount = item.land_amount || 0;
            const treeAmount = item.tree_amount || 0;
            const homeAmount = item.home_amount || 0;
            const tinshedAmount = item.tinshed_amount || 0;
            const farmPondAmount = item.water_body_amount || 0;
            const wellAmount = item.structure_amount || 0;
            const wireAmount = item.wire_amount || 0;
            const otherAmount = item.other_asset_amount || 0;
            const borewellAmount = (item.borewell_amount + homeAmount + tinshedAmount + farmPondAmount + wellAmount + wireAmount + otherAmount) || 0;
            const interestAmount = (Number(item.interest_amount) + (Number(item.advance_payment_interest_amount) || 1)) || 0;
            const pipelineAmount = item.pipeline_amount || 0;

            const firstTotal = landAmount + treeAmount + borewellAmount;
            const dilasaAmount = firstTotal; // Same as firstTotal based on your logic
            const secondTotal = firstTotal + dilasaAmount + interestAmount + pipelineAmount;
            const advancedAmount = Number(item.advance_amount || 0);
            const recoveredUnearnedAmount = Number(item.govt_recovery || 0);
            const finalAmount = secondTotal - (advancedAmount + recoveredUnearnedAmount);

            const ownerGroup = {
                ownerId: item.land_owner_id,
                ownerName: item.owner_name,
                gatNo: item.survey_no,
                aquiredArea: item.owner_aqr_area,
                landRate: landRate,
                landgunak: 2,
                landAmount: landAmount,
                treeAmount: treeAmount,
                homeAmount: homeAmount,
                tinshedAmount: tinshedAmount,
                borewellAmount: borewellAmount,
                firstTotal: firstTotal,
                dilasaAmount: dilasaAmount,
                interestAmount: interestAmount,
                pipelineAmount: pipelineAmount,
                secondTotal: secondTotal,
                advancedAmount: advancedAmount,
                recoveredUnearnedAmount: recoveredUnearnedAmount,
                finalAmount: finalAmount
            };

            compensationRows.push(ownerGroup);

            // Add to totals
            const oldTotals = { ...totals };

            totals.totalAquiredArea += totalAquiredArea;
            totals.landRate += landRate;
            totals.landAmount += landAmount;
            totals.treeAmount += treeAmount;
            totals.borewellAmount += borewellAmount;
            totals.firstTotal += firstTotal;
            totals.dilasaAmount += dilasaAmount;
            totals.interestAmount += interestAmount;
            totals.pipelineAmount += pipelineAmount;
            totals.secondTotal += secondTotal;
            totals.advancedAmount += advancedAmount;
            totals.recoveredUnearnedAmount += recoveredUnearnedAmount;
            totals.finalAmount += finalAmount;
        });

        return {
            compensationRows,
            totals
        };
    };

    // fetch LAO users
    const fetchusersLAO = async () => {
        const role = 3;
        try {
            const response = await apiService.getAssignLAO(role, projectId, proposalId);
            console.log('LAO users:', response);
            if (response.status === 200 && response.data) {
                setusersLAO(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersLAO([]);
            }
        } catch (error) {
            console.error('Error fetching LAO users:', error);
            setusersLAO([]);
        } finally {

        }
    };

    // Tracking
    const fetchTrackingDetails = async () => {
        try {
            const response = await apiService.getTrackingSection23(projectId, proposalId);

            // Check if response has the expected structure from your document
            if (response) {
                setTrackingData(response);

            } else {
                console.log("Unexpected response structure:", response);
            }
        } catch (error) {
            console.error("Error fetching tracking details:", error);
        }
    };

    // Punarvarshan
    const fetchPunarvarshanData = async () => {
        if (!projectId || !proposalId) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        try {

            const result = await apiService.get("getPunarvarshan", {
                projectId: projectId,
                proposalId: proposalId
            });

            if (result.status === 200 && Array.isArray(result.data) && result.data.length > 0) {

                // Group data by dist-taluk-village
                const grouped = {};

                result.data.forEach(item => {
                    const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
                    if (!grouped[key]) {
                        grouped[key] = [];
                    }

                    grouped[key].push({
                        id: item.punarvarshan_id,
                        survey_no: item.survey_no,
                        aquire_area: item.aquire_area
                    });
                });

                // Convert into array format for rendering
                const groupedArray = Object.entries(grouped).map(([key, records]) => {
                    const [dist, taluka, village] = key.split('-');
                    const total = records.reduce((sum, r) => sum + parseFloat(r.aquire_area || 0), 0);
                    return { dist, taluka, village, records, total };
                });

                setPunarvarshanData(groupedArray);
            }

        } catch (error) {
            console.error('Error fetching Punarvarshan data:', error);
        } finally {

        }
    };

    // Direct Purchase
    const fetchDirectPurchaseData = async () => {
        if (!projectId || !proposalId) {
            console.log('Invalid project or proposal ID:', { projectId, proposalId });
            return;
        }

        try {

            const result = await apiService.getDirectPurchaseKJP(projectId, proposalId);

            if (result.status === 200 && Array.isArray(result.data) && result.data.length > 0) {

                // Group data by dist-taluk-village
                const grouped = {};

                result.data.forEach(item => {
                    const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
                    if (!grouped[key]) {
                        grouped[key] = [];
                    }

                    grouped[key].push({
                        id: item.direct_purchase_id,
                        survey_no: item.survey_no,
                        registration_no: item.registration_no,
                        registration_date: item.registration_date,
                        size_rupees: item.size_rupees,
                        area_sold: item.area_sold,
                        selling_price: item.selling_price,
                        hectare_rate: item.hectare_rate,
                        hectare_rate_amount: item.hectare_rate_amount,
                        size_gat: item.size_gat,
                    });
                });

                // Convert into array format for rendering
                const groupedArray = Object.entries(grouped).map(([key, records]) => {
                    const [dist, taluka, village] = key.split('-');
                    const total = records.reduce((sum, r) => sum + parseFloat(r.aquire_area || 0), 0);
                    return { dist, taluka, village, records, total };
                });

                setDirectPurchaseData(groupedArray);
            }

        } catch (error) {
            console.error('Error fetching DirectPurchase data:', error);
        } finally {

        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!proposalId) {
            alert('❌ No proposal ID found for update.');
            return;
        }

        try {
            setLoading(true);
            const invalidValues = ["", "N/A", "null", "undefined"];
            const updateData = {
                section_23_date: formData.section_23_date || new Date(),
                section_23_office_name: formData.section_23_office_name || proposalData.section_11_office_name || '',
                section_23_branch_name: formData.section_23_branch_name || proposalData.section_11_branch_name || '',
                section_23_bhusampadan_no: formData.section_23_bhusampadan_no || proposalData.section_11_bhusampadan_no || '',
                section_23_nature_of_land: formData.section_23_nature_of_land || '',
                administrative_order_no: formData.administrative_order_no || '',
                administrative_order_date: formData.administrative_order_date || new Date(),
                acquisition_authority_no: formData.acquisition_authority_no || '',
                acquisition_authority_date: formData.acquisition_authority_date || new Date(),
                propsal_proceeding_no: formData.propsal_proceeding_no || '',
                propsal_proceeding_date: formData.propsal_proceeding_date || new Date(),

                section_23_no1_content:
                    formData.section_23_no1_content &&
                        !invalidValues.includes(formData.section_23_no1_content.trim()) &&
                        formData.section_23_no1_content.trim() !==
                        (defaultContents["no_1"] || "").trim()
                        ? formData.section_23_no1_content.trim()
                        : defaultContents["no_1"],
                section_23_no2_content:
                    formData.section_23_no2_content &&
                        !invalidValues.includes(formData.section_23_no2_content.trim()) &&
                        formData.section_23_no2_content.trim() !==
                        (defaultContents["no_2"] || "").trim()
                        ? formData.section_23_no2_content.trim()
                        : defaultContents["no_2"],
                section_23_no3_a_content:
                    formData.section_23_no3_a_content &&
                        !invalidValues.includes(formData.section_23_no3_a_content.trim()) &&
                        formData.section_23_no3_a_content.trim() !==
                        (defaultContents["no_3_a"] || "").trim()
                        ? formData.section_23_no3_a_content.trim()
                        : defaultContents["no_3_a"],
                section_23_no3_b_content:
                    formData.section_23_no3_b_content &&
                        !invalidValues.includes(formData.section_23_no3_b_content.trim()) &&
                        formData.section_23_no3_b_content.trim() !==
                        (defaultContents["no_3_b"] || "").trim()
                        ? formData.section_23_no3_b_content.trim()
                        : defaultContents["no_3_b"],
                section_23_no7_content:
                    formData.section_23_no7_content &&
                        !invalidValues.includes(formData.section_23_no7_content.trim()) &&
                        formData.section_23_no7_content.trim() !==
                        (defaultContents["no_7"] || "").trim()
                        ? formData.section_23_no7_content.trim()
                        : defaultContents["no_7"],
                section_23_no8_a_content:
                    formData.section_23_no8_a_content &&
                        !invalidValues.includes(formData.section_23_no8_a_content.trim()) &&
                        formData.section_23_no8_a_content.trim() !==
                        (defaultContents["no_8_a"] || "").trim()
                        ? formData.section_23_no8_a_content.trim()
                        : defaultContents["no_8_a"],
                section_23_no8_b_content:
                    formData.section_23_no8_b_content &&
                        !invalidValues.includes(formData.section_23_no8_b_content.trim()) &&
                        formData.section_23_no8_b_content.trim() !==
                        (defaultContents["no_8_b"] || "").trim()
                        ? formData.section_23_no8_b_content.trim()
                        : defaultContents["no_8_b"],
                section_23_no11_content:
                    formData.section_23_no11_content &&
                        !invalidValues.includes(formData.section_23_no11_content.trim()) &&
                        formData.section_23_no11_content.trim() !==
                        (defaultContents["no_11"] || "").trim()
                        ? formData.section_23_no11_content.trim()
                        : defaultContents["no_11"],
                section_23_no12_2_default_content:
                    formData.section_23_no12_2_default_content &&
                        !invalidValues.includes(formData.section_23_no12_2_default_content.trim()) &&
                        formData.section_23_no12_2_default_content.trim() !==
                        (defaultContents["no_12_default"] || "").trim()
                        ? formData.section_23_no12_2_default_content.trim()
                        : defaultContents["no_12_default"],
                section_23_no12_2_b_content:
                    formData.section_23_no12_2_b_content &&
                        !invalidValues.includes(formData.section_23_no12_2_b_content.trim()) &&
                        formData.section_23_no12_2_b_content.trim() !==
                        (defaultContents["no_12_2_b"] || "").trim()
                        ? formData.section_23_no12_2_b_content.trim()
                        : defaultContents["no_12_2_b"],
                section_23_no12_2_c_content:
                    formData.section_23_no12_2_c_content &&
                        !invalidValues.includes(formData.section_23_no12_2_c_content.trim()) &&
                        formData.section_23_no12_2_c_content.trim() !==
                        (defaultContents["no_12_2_c"] || "").trim()
                        ? formData.section_23_no12_2_c_content.trim()
                        : defaultContents["no_12_2_c"],
                section_23_no12_2_d_content:
                    formData.section_23_no12_2_d_content &&
                        !invalidValues.includes(formData.section_23_no12_2_d_content.trim()) &&
                        formData.section_23_no12_2_d_content.trim() !==
                        (defaultContents["no_12_2_d"] || "").trim()
                        ? formData.section_23_no12_2_d_content.trim()
                        : defaultContents["no_12_2_d"],
                section_23_no12_2_e_content:
                    formData.section_23_no12_2_e_content &&
                        !invalidValues.includes(formData.section_23_no12_2_e_content.trim()) &&
                        formData.section_23_no12_2_e_content.trim() !==
                        (defaultContents["no_12_2_e"] || "").trim()
                        ? formData.section_23_no12_2_e_content.trim()
                        : defaultContents["no_12_2_e"],
                section_23_no12_3_content:
                    formData.section_23_no12_3_content &&
                        !invalidValues.includes(formData.section_23_no12_3_content.trim()) &&
                        formData.section_23_no12_3_content.trim() !==
                        (defaultContents["no_12_3"] || "").trim()
                        ? formData.section_23_no12_3_content.trim()
                        : defaultContents["no_12_3"],
                section_23_no12_4_content:
                    formData.section_23_no12_4_content &&
                        !invalidValues.includes(formData.section_23_no12_4_content.trim()) &&
                        formData.section_23_no12_4_content.trim() !==
                        (defaultContents["no_12_4"] || "").trim()
                        ? formData.section_23_no12_4_content.trim()
                        : defaultContents["no_12_4"],
                section_23_no12_5_content:
                    formData.section_23_no12_5_content &&
                        !invalidValues.includes(formData.section_23_no12_5_content.trim()) &&
                        formData.section_23_no12_5_content.trim() !==
                        (defaultContents["no_12_5"] || "").trim()
                        ? formData.section_23_no12_5_content.trim()
                        : defaultContents["no_12_5"],
                section_23_no12_6_content:
                    formData.section_23_no12_6_content &&
                        !invalidValues.includes(formData.section_23_no12_6_content.trim()) &&
                        formData.section_23_no12_6_content.trim() !==
                        (defaultContents["no_12_6"] || "").trim()
                        ? formData.section_23_no12_6_content.trim()
                        : defaultContents["no_12_6"],
                section_23_no13_a_1_content:
                    formData.section_23_no13_a_1_content &&
                        !invalidValues.includes(formData.section_23_no13_a_1_content.trim()) &&
                        formData.section_23_no13_a_1_content.trim() !==
                        (defaultContents["no_13_a_1"] || "").trim()
                        ? formData.section_23_no13_a_1_content.trim()
                        : defaultContents["no_13_a_1"],
                section_23_no13_a_2_content:
                    formData.section_23_no13_a_2_content &&
                        !invalidValues.includes(formData.section_23_no13_a_2_content.trim()) &&
                        formData.section_23_no13_a_2_content.trim() !==
                        (defaultContents["no_13_a_2"] || "").trim()
                        ? formData.section_23_no13_a_2_content.trim()
                        : defaultContents["no_13_a_2"],
                section_23_no13_b_content:
                    formData.section_23_no13_b_content &&
                        !invalidValues.includes(formData.section_23_no13_b_content.trim()) &&
                        formData.section_23_no13_b_content.trim() !==
                        (defaultContents["no_13_b"] || "").trim()
                        ? formData.section_23_no13_b_content.trim()
                        : defaultContents["no_13_b"],
                section_23_no13_c_content:
                    formData.section_23_no13_c_content &&
                        !invalidValues.includes(formData.section_23_no13_c_content.trim()) &&
                        formData.section_23_no13_c_content.trim() !==
                        (defaultContents["no_13_c"] || "").trim()
                        ? formData.section_23_no13_c_content.trim()
                        : defaultContents["no_13_c"],
                section_23_no13_d_content:
                    formData.section_23_no13_d_content &&
                        !invalidValues.includes(formData.section_23_no13_d_content.trim()) &&
                        formData.section_23_no13_d_content.trim() !==
                        (defaultContents["no_13_d"] || "").trim()
                        ? formData.section_23_no13_d_content.trim()
                        : defaultContents["no_13_d"],
                section_23_no13_e_content:
                    formData.section_23_no13_e_content &&
                        !invalidValues.includes(formData.section_23_no13_e_content.trim()) &&
                        formData.section_23_no13_e_content.trim() !==
                        (defaultContents["no_13_e"] || "").trim()
                        ? formData.section_23_no13_e_content.trim()
                        : defaultContents["no_13_e"],
                section_23_no14_content:
                    formData.section_23_no14_content &&
                        !invalidValues.includes(formData.section_23_no14_content.trim()) &&
                        formData.section_23_no14_content.trim() !==
                        (defaultContents["no_14"] || "").trim()
                        ? formData.section_23_no14_content.trim()
                        : defaultContents["no_14"],
                section_23_no15_content:
                    formData.section_23_no15_content &&
                        !invalidValues.includes(formData.section_23_no15_content.trim()) &&
                        formData.section_23_no15_content.trim() !==
                        (defaultContents["no_15"] || "").trim()
                        ? formData.section_23_no15_content.trim()
                        : defaultContents["no_15"],
                section_23_no16_content:
                    formData.section_23_no16_content &&
                        !invalidValues.includes(formData.section_23_no16_content.trim()) &&
                        formData.section_23_no16_content.trim() !==
                        (defaultContents["no_16"] || "").trim()
                        ? formData.section_23_no16_content.trim()
                        : defaultContents["no_16"],
                section_23_no17_content:
                    formData.section_23_no17_content &&
                        !invalidValues.includes(formData.section_23_no17_content.trim()) &&
                        formData.section_23_no17_content.trim() !==
                        (defaultContents["no_17"] || "").trim()
                        ? formData.section_23_no17_content.trim()
                        : defaultContents["no_17"],
                section_23_no19_content:
                    formData.section_23_no19_content &&
                        !invalidValues.includes(formData.section_23_no19_content.trim()) &&
                        formData.section_23_no19_content.trim() !==
                        (defaultContents["no_19"] || "").trim()
                        ? formData.section_23_no19_content.trim()
                        : defaultContents["no_19"],
                section_23_last_content:
                    formData.section_23_last_content &&
                        !invalidValues.includes(formData.section_23_last_content.trim()) &&
                        formData.section_23_last_content.trim() !==
                        (defaultContents["no_last"] || "").trim()
                        ? formData.section_23_last_content.trim()
                        : defaultContents["no_last"],

                // 3
                section_23_3_publication_no12: formData.section_23_3_publication_no12 || new Date(),
                // 4
                dslr_office_name: formData.dslr_office_name || '',
                surveyor_joint_end_date: formData.surveyor_joint_end_date || new Date(),
                // 5
                section_23_5_acquisition_area_compliance_report_date: formData.section_23_5_acquisition_area_compliance_report_date || new Date(),
                section_23_5_acquisition_area_letter_no: formData.section_23_5_acquisition_area_letter_no,
                // 9
                section_23_9_21Gazette_date: formData.section_23_9_21Gazette_date || new Date(),
                section_23_9_21tehsil_office_date: formData.section_23_9_21tehsil_office_date || new Date(),
                section_23_9_21given_notice_date: formData.section_23_9_21given_notice_date || new Date(),
                section_23_9_21objections_representations_statements_no: formData.section_23_9_21objections_representations_statements_no,
                section_23_9_21inquiry_date: formData.section_23_9_21inquiry_date || new Date(),
                section_23_9_21present_lanholders: formData.section_23_9_21present_lanholders,
                section_23_9_21inquiry_completion_date: formData.section_23_9_21inquiry_completion_date || new Date(),
                section_23_9_21disposal_objections_date: formData.section_23_9_21disposal_objections_date || new Date(),
                // 12
                section_23_no12_2_b_table_ids: formData.section_23_no12_2_b_table_ids || '',
                section_23_no12_2_c_table_ids: formData.section_23_no12_2_c_table_ids || '',
                section_23_no12_2_d_table_ids: formData.section_23_no12_2_d_table_ids || '',

            };

            const result = await apiService.updateProposal(
                proposalId,
                updateData
            );

            if (result.status === 200) {
                alert('Section-23 updated successfully!');
                setIsEditing(false);
                if (onUpdated) onUpdated();
                fetchProposalData();
            } else {
                alert('❌ Failed to update proposal.');
            }
        } catch (err) {
            console.error('Error updating proposal:', err);
            alert('❌ Error while updating proposal.');
        } finally {
            setLoading(false);
        }
    };

    // Tracking Button
    // fetch Samanvay users
    const fetchusersSamanvay = async () => {
        const role = 6;
        setLoadingusersSamanvay(true);
        try {
            const response = await apiService.getAllAssignUserRoleSamanvay(6, projectId, proposalId);
            console.log('Samanvay users:', response);
            if (response.status === 200 && response.data) {
                setusersSamanvay(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersSamanvay([]);
            }
        } catch (error) {
            console.error('Error fetching Samanvay users:', error);
            setusersSamanvay([]);
        } finally {
            setLoadingusersSamanvay(false);
        }
    };

    const getFinalDocument = () => {
        // If digital signature exists → use signed PDF
        if (selectedSignDocument) {
            return selectedSignDocument;
        }

        // Else → use uploaded document
        if (selectedDocument) {
            return selectedDocument;
        }

        return null;
    };

    // Handle Send to Samanvay
    const handleSendToSamanvay = async () => {

        // const finalDocument = getFinalDocument();

        // if (!finalDocument) {
        //     showAlert('Document Required', 'Please upload or sign a document');
        //     return;
        // }

        if (!selectedUserSamanvay || !selectedDocumentSamanvay) {
            alert('Please select a user and upload a document to send to Samanvay Officer.');
            return;
        }

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setsendingToSamanvay(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksSamanvay);
            formData.append('usr_id', selectedUserSamanvay);
            formData.append('document', selectedDocumentSamanvay);
            if(userRole === ROLES.COLLECTOR){
                 formData.append("is_approved", isApproved);
            }

            let response
            if(userRole === ROLES.LAO){response = await apiService.postTrackingSection23Samanvay(formData)}
            if(userRole === ROLES.COLLECTOR){response = await apiService.postTrackingSection23SamanvayFinal(formData)}

            console.log('Send to Samanvay response:', response);
            await apiService.postAddSignaturePDF(
                projectId,
                proposalId,
                "section23",               // key for SECTION_TYPE_MAP
                selectedDocumentSamanvay   // same PDF file
            );
            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToSamanvayOfficer
                    || "Successfully sent to Samanvay Officer!"
                );
                setshowSendToSamanvayModal(false);
                setselectedUserSamanvay('');
                setremarksSamanvay('Approved');
                setselectedDocumentSamanvay(null);
                fetchButtonStatus();

            } else {
                alert('Failed to send to Samanvay Officer. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to Samanvay:', error);
            alert('Failed to send to Samanvay Officer. Please try again.');
        } finally {
            setsendingToSamanvay(false);
        }
    };
    const handleCloseModal = () => {
    // Hide the modal
    setshowSendToSamanvayModal(false);
    
    // Reset all form states to null/default
    setselectedUserSamanvay('');
    setremarksSamanvay(''); // or set to 'Approved' if that's your default
    setselectedDocumentSamanvay(null);
    
    // Reset Collector specific state if applicable
    if (userRole === ROLES.COLLECTOR) {
        setIsApproved(null); // or your default value, e.g., 1
    }
    
    // Optional: Reset signature/upload states if they shouldn't persist after canceling
    // setUploadStatus('idle');
    // setselectedSignDocument(null);
    // setUploadError('');
};

    // fetch Collector users
    const fetchUsersAllCollector = async () => {
        const role = 1;
        setLoadingusersCollector(true);
        try {
            const response = await apiService.getAllAssignUserCollector(role, projectId, proposalId);
            console.log('Collector users:', response);
            if (response.status === 200 && response.data) {
                setusersCollectorAll(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersCollectorAll([]);
            }
        } catch (error) {
            console.error('Error fetching Collector users:', error);
            setusersCollectorAll([]);
        } finally {
            setLoadingusersCollector(false);
        }
    };

    // Handle Send to Collector
    const handleSendToCollector = async () => {

        // const finalDocument = getFinalDocument();

        // if (!finalDocument) {
        //     showAlert('Document Required', 'Please upload or sign a document');
        //     return;
        // }

        if (!selectedUserCollector || !selectedDocumentCollector) {
            alert('Please select a user and upload a document to send to Collector Officer.');
            return;
        }

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setsendingToCollector(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksCollector);
            formData.append('usr_id', selectedUserCollector);
            formData.append('document', selectedDocumentCollector);


            const response = await apiService.postTrackingSection23Collector(formData);
            console.log('Send to Collector response:', response);

            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToCollectorOfficer
                    || "Successfully sent to Collector Officer!"
                );
                // alert('Successfully sent to Collector Officer!');
                setshowSendToCollectorModal(false);
                setselectedUserCollector('');
                setremarksCollector('Approved');
                setselectedDocumentCollector(null);
                fetchButtonStatus();

            } else {
                alert('Failed to send to Collector Officer. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to Collector:', error);
            alert('Failed to send to Collector Officer. Please try again.');
        } finally {
            setsendingToCollector(false);
        }
    };

    // Handle Send to LAO
    const handleSendToLAO = async () => {

        // const finalDocument = getFinalDocument();

        // if (!finalDocument) {
        //     showAlert('Document Required', 'Please upload or sign a document');
        //     return;
        // }

        if (!selectedUserLAO || !selectedDocumentLAO) {
            alert('Please select a user and upload a document to send to LAO Officer.');
            return;
        }

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setsendingToLAO(true);

        try {
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('proposal_id', proposalId);
            formData.append('remarks', remarksLAO);
            formData.append('usr_id', selectedUserLAO);
            formData.append('document', selectedDocumentLAO);
            formData.append("is_approved", isApproved);

            const response = await apiService.postTrackingSection23LAO(formData);
            console.log('Send to LAO response:', response);

            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToLAOOfficer
                    || "Successfully sent to LAO Officer!"
                );
                // alert('Successfully sent to LAO Officer!');
                setshowSendToLAOModal(false);
                setselectedUserLAO('');
                setremarksLAO('Approved');
                setselectedDocumentLAO(null);
                fetchButtonStatus();

            } else {
                alert('Failed to send to LAO Officer. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to LAO:', error);
            alert('Failed to send to LAO Officer. Please try again.');
        } finally {
            setsendingToLAO(false);
        }
    };

    // Get user role from local storage
    const userData = JSON.parse(localStorage.getItem('userData'));
    const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

    // Button Disable
    const fetchButtonStatus = async () => {
        try {
            if (!projectId || !proposalId) return;

            // setLoading(true);
            let response;
            const res = await apiService.getTrackingwiseButton(projectId,proposalId,"section23")
            console.log("trackingwise button" , res)

            // Edit button disable
            response = await apiService.getSection23LAOButton(projectId, proposalId);
            setCollectorEditCompletedbuttonDisabled(!response.buttonDisable);

            if (response?.data?.length > 0) {
                const lastRecord = response.data[response.data.length - 1];
                setApproval(lastRecord.is_approved);
            }

            switch (userRole) {
                case ROLES.LAO:
                    response = await apiService.getSection23SamanvayLAOButton(projectId, proposalId);
                    break;
                case ROLES.SAMANVAY:
                    response = await apiService.getSection23CollectorButton(projectId, proposalId);
                    break;
                case ROLES.COLLECTOR:
                    response = await apiService.getSection23LAOButton(projectId, proposalId);
                    break;
                default:
                    return;
            }
            setButtonDisabled(!response.buttonDisable);
        } catch (error) {
            console.error("Error fetching DSLR button state:", error);
        } finally {
            // setLoading(false); // Only set loading to false for main data fetch
        }
    };

    // Unified function to handle viewing documents (for both modals)
    const handleViewDocument = (urlOrFile) => {
        if (!urlOrFile) return;

        let url;
        let isPdf;

        if (urlOrFile instanceof File) {
            url = URL.createObjectURL(urlOrFile);
            isPdf = urlOrFile.type === 'application/pdf';
        } else { // Assuming it's a URL string from backend
            url = urlOrFile;
            isPdf = urlOrFile.toLowerCase().includes('.pdf');
        }

        setFileUrlToView(url);
        setIsPDFToView(isPdf);
        setShowDocumentViewer(true);
    };

    const closeDocumentViewer = () => {
        setShowDocumentViewer(false);
        // Revoke Object URL if it was created from a File object
        if (fileUrlToView.startsWith('blob:')) {
            URL.revokeObjectURL(fileUrlToView);
        }
        setFileUrlToView('');
        setIsPDFToView(false);
    };

    // ADD THESE HELPER FUNCTIONS HERE:
    const showAlert = (title, message, type = 'info') => {
        setAlertConfig({ title, message, type });
        setShowAlertModal(true);

        // Don't auto-hide success messages so user can see them
        if (type !== 'success') {
            setTimeout(() => setShowAlertModal(false), 5000);
        }
    };

    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };

    const handleDataEntryFileSelect = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            return;
        }

        if (!projectId || !proposalId) {
            alert('Project ID and Proposal ID are required.');
            e.target.value = ''; // Reset file input
            return;
        }

        // Show confirmation alert
        const userConfirmed = window.confirm(
            `Selected file: ${file.name}\n\nDo you want to upload this document?`
        );

        if (!userConfirmed) {
            e.target.value = ''; // Reset file input
            return;
        }

        setUploadingDataEntry(true);

        try {
            const response = await apiService.postAddSignaturePDF(
                projectId,
                proposalId,
                "section23",
                file
            );

            // AFTER
            if (response.status === 200) {
                alert('Document uploaded successfully!');

                // ✅ Fetch and store uploaded document URL for View button
                try {
                    const fileResponse = await apiService.getSectionFile(projectId, proposalId, "section23");
                    if (fileResponse?.status === 200 && fileResponse.data?.length > 0) {
                        setUploadedDataEntryFileUrl(fileResponse.data[0].file_path);
                    }
                } catch (err) {
                    console.error("Error fetching uploaded file URL:", err);
                }
            }
        } catch (error) {
            console.error('Error uploading document:', error);
            alert('Failed to upload document. Please try again.');
        } finally {
            setUploadingDataEntry(false);
            e.target.value = ''; // Reset file input for next upload
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Only allow changes to editable fields
        if (editableFields.includes(name)) {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));

            // If user is editing section_19_content, mark it as edited
            // if (name === 'section_19_content') {
            //   setHasUserEditedSection1(true);
            // }
            // if (name === 'section_19_tip') {
            //   setHasUserEditedTip(true);
            // }
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatDateForInput = (dateString) => {
        // If no date provided, use today
        if (!dateString) {
            const today = new Date();
            return today.toISOString().split('T')[0]; // yyyy-mm-dd
        }

        const date = new Date(dateString);

        // Check if date is invalid OR default 1900 date
        if (isNaN(date) || date.getFullYear() === 1900) {
            const today = new Date();
            return today.toISOString().split('T')[0];
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const renderProposalTable = () => (
        <div className="overflow-x-auto p-4">
            <table className="table-auto border border-gray-700 w-full text-sm">
                <tbody>
                    <tr>
                        <td className="border border-gray-700 p-2">1.</td>
                        <td className="border border-gray-700 p-2 w-1/4">संपादन संस्था</td>
                        <td className="border border-gray-700 p-2" colspan="2">
                            {proposalData.acquisition_incharge_designation || ''}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-700 p-2">2.</td>
                        <td className="border border-gray-700 p-2">भूमिसंपादनाचे प्रयोजन</td>
                        <td className="border border-gray-700 p-2" colspan="2">
                            {proposalData.acquisition_purpose || ''}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-700 p-2">3.</td>
                        <td className="border border-gray-700 p-2">प्रशासकीय मान्यता आदेश क्रमांक व दिनांक</td>
                        <td className="border border-gray-700 p-2" colspan="2">
                            {proposalData.administrative_order_no || ''} दि. {formatDate(proposalData.administrative_order_date) || ''}
                        </td>
                    </tr>
                    <tr>
                        <td className="border border-gray-700 p-2">4.</td>
                        <td className="border border-gray-700 p-2">संपादन संस्थेने प्रस्ताव सादर केलेल्या पत्राचा क्रमांक व दिनांक</td>
                        <td className="border border-gray-700 p-2" colspan="2">
                            {proposalData.acquisition_authority_no || ''} दि. {formatDate(proposalData.acquisition_authority_date)}
                        </td>
                    </tr>

                    <tr>
                        <td className="border border-gray-700 p-2" rowSpan={4}>5.</td>
                        <td className="border border-gray-700 p-2" rowSpan={4}>संपादनासाठी प्रस्तावित क्षेत्र</td>

                        <td className="border border-gray-700 p-2" colspan="1">गावाचे नाव :- </td>
                        <td className="border border-gray-700 p-2">{proposalData.village_name} ता. {proposalData.taluka_name} जि. {proposalData.dist_name}</td>
                    </tr>
                    <tr>
                        <td className="border border-gray-700 p-2">संपादनाखालील क्षेत्राचे स्वरुप :- </td>
                        <td className="border border-gray-700 p-2">{proposalData.section_23_nature_of_land || ''}</td>
                    </tr>
                    <tr>
                        <td className="border border-gray-700 p-2">संपादनाखालील क्षेत्र :-</td>
                        <td className="border border-gray-700 p-2">{proposalData.aquired_area} {proposalData.area_unit}</td>
                    </tr>
                    <tr>
                        <td className="border border-gray-700 p-2">भूधारकांची संख्या :-</td>
                        <td className="border border-gray-700 p-2">
                            {landData.reduce((sum, group) => sum + group.records.length, 0)}
                        </td>
                    </tr>

                    <tr>
                        <td className="border border-gray-700 p-2">6.</td>
                        <td className="border border-gray-700 p-2">प्रस्ताव संपादनाच्या कार्यवाहीसाठी वर्ग केलेल्या आदेश क्रमांक व दिनांक</td>
                        <td className="border border-gray-700 p-2" colspan="2">
                            {proposalData.propsal_proceeding_no || ''} दि. {formatDate(proposalData.propsal_proceeding_date) || ''}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

    const renderNo3 = () => {
        const section11Anusuchi1 = () => (
            <div className='mt-5'>
                <p className="text-center underline">अनुसूची-१</p>
                <p className="text-center mt-2">(जमिनीचे वर्णन)</p>

                {groupedData.map((group, gIndex) => (
                    // <div key={gIndex} style={{ pageBreakAfter: 'always' }}>
                    <div>
                        <h3 className="text-center text-xs m-2">
                            गाव: <span className="font-bold pr-3">{group.village}</span>
                            तालुका: <span className="font-bold pr-3">{group.taluka}</span>
                            जिल्हा: <span className="font-bold">{group.dist}</span>
                        </h3>

                        <div className="w-full">
                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                <thead>
                                    <tr className="bg-gray-200">
                                        <th rowSpan="2" className="border border-black p-2 text-center">अ. क्र.</th>
                                        <th rowSpan="2" className="border border-black p-2 text-center">गट क्रमांक</th>
                                        <th colSpan="3" className="border border-black p-2 text-center">संपादित क्षेत्र</th>
                                    </tr>
                                    <tr className="bg-gray-200">
                                        <th className="border border-black p-2 text-center">लागवड योग्य क्षेत्र ({proposalData.area_unit})</th>
                                        <th className="border border-black p-2 text-center">पोट खराब क्षेत्र ({proposalData.area_unit})</th>
                                        <th className="border border-black p-2 text-center">एकुण क्षेत्र ({proposalData.area_unit})</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {group.records.map((record, index) => (
                                        <tr key={index}>
                                            <td className="border border-black p-2 text-center">{index + 1}</td>
                                            <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                            <td className="border border-black p-2 text-center">{parseFloat(record.owner_irrigable_area || 0).toFixed(4)} </td>
                                            <td className="border border-black p-2 text-center">{parseFloat(record.owner_non_irrigable_area || 0).toFixed(4)} </td>
                                            <td className="border border-black p-2 text-center">
                                                {(
                                                    parseFloat(record.owner_irrigable_area || 0) +
                                                    parseFloat(record.owner_non_irrigable_area || 0)
                                                ).toFixed(4)}
                                            </td>

                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="2" className="border border-black p-2 font-bold text-right">एकूण क्षेत्र</td>
                                        <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalIrrigable || 0).toFixed(4)} </td>
                                        <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalNonIrrigable || 0).toFixed(4)} </td>
                                        <td className="border border-black p-2 font-bold text-center">
                                            {parseFloat(
                                                (group.ownerTotalIrrigable || 0) + (group.ownerTotalNonIrrigable || 0)
                                            ).toFixed(4)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                ))}
            </div>
        );

        const section11Publish = () => (
            <div>
                <p>कलम 11(1) खालील प्रारंभिक अधिसूचना प्रसिध्दीचा तपशिल :</p>
                <div className="overflow-x-auto p-4">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2">1</td>
                                <td className="border border-gray-700 p-2">कलम 11(1) खालील अधिसूचनेचा क्रमांक व दिनांक</td>
                                <td className="border border-gray-700 p-2">{proposalData.section_11_notification || ''} दिनांक {formatDate(proposalData.section_11_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">महाराष्ट्र शासन राजपत्र {proposalData.section11_published_gazette_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_published_gazette) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">3</td>
                                <td className="border border-gray-700 p-2">वर्तमान पत्र-1 {proposalData.section11_published_newspaper1_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_published_newspaper1) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">4</td>
                                <td className="border border-gray-700 p-2">वर्तमान पत्र-2 {proposalData.section11_published_newspaper2_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_published_newspaper2) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">5</td>
                                <td className="border border-gray-700 p-2">जिल्हाधिकारी कार्यालय, {proposalData.section11_collector_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_collector_office) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">6</td>
                                <td className="border border-gray-700 p-2">उपविभागीय अधिकारी कार्यालय, {proposalData.section11_sub_divisional_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_sub_divisional_office) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">7</td>
                                <td className="border border-gray-700 p-2">तहसिल कार्यालय, {proposalData.section11_tehsil_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_tehsil_office) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">8</td>
                                <td className="border border-gray-700 p-2">ग्राम महसूल अधिकारी कार्यालय, {proposalData.section11_municipal_authority_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_municipal_authority) || ''}</td>
                            </tr>
                            {/* <tr>
                                <td className="border border-gray-700 p-2">9</td>
                                <td className="border border-gray-700 p-2">स्थानिक ग्रामपंचायत/नगरपालिका/महानगरपालिका,{proposalData.section11_gram_panchayat_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_gram_panchayat_office || '')}</td>
                            </tr> */}
                            <tr>
                                <td className="border border-gray-700 p-2">9</td>
                                <td className="border border-gray-700 p-2">जिल्हाधिकारी कार्यालयाचे संकेतस्थळ (समुचीत शासनाचे संकेतस्थळ) {proposalData.section11_gram_sevak_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_gram_sevak_office) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">10</td>
                                <td className="border border-gray-700 p-2">कलम 11 (1) प्रारंभिक अधिसूचनेचा प्रसिध्दी दिनांक 11 (भूमिसंपादन नियम (महाराष्ट्र) 2014-नियम 10(2) अन्वये अधिसूचनेचा अंतिम प्रसिध्दी दिनांक)</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section11_rehabilitation_rights_notice) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">11</td>
                                <td className="border border-gray-700 p-2">कलम 11(1) खालील अधिसूचनेचा मजकुर कळविण्यासाठी 12 ग्राम पातळीवरील ग्रामसभेचा किंवा नगरपालिका क्षेत्राच्या बाबतीत नगरपालिकेच्या सभेचा दिनांक</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section_23_3_publication_no12) || ''}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                <div className="p-4">
                    <table className="w-full">
                        <tr>
                            <td className="border border-gray-700 p-2">कलम 11 (1) खालील प्रारंभिक अधिसूचनेचा क्रमांक व दिनांक</td>
                            <td className="border border-gray-700 p-2">{proposalData.section_11_notification} दिनांक {formatDate(proposalData.section_11_date)}</td>
                        </tr>
                    </table>
                    {section11Anusuchi1()}
                    {section11Publish()}
                </div>
            </div>
        );
    }

    // const getStageTransitionDate = (fromStage, toStage) => {
    //     console.log(`Looking for transition from stage ${fromStage} to stage ${toStage}`);
    //     console.log("All tracking data:", trackingData);
    //     console.log("Tracking data length:", trackingData?.length);
    //     console.log("Tracking data is array:", Array.isArray(trackingData));

    //     // Safety check
    //     if (!trackingData || !Array.isArray(trackingData) || trackingData.length === 0) {
    //         console.log("No tracking data available");
    //         return null;
    //     }

    //     // Log each tracking record for debugging
    //     trackingData.forEach((item, index) => {
    //         console.log(`Record ${index}:`, {
    //             from_stage: item.from_stage,
    //             from_stage_type: typeof item.from_stage,
    //             to_stage: item.to_stage,
    //             to_stage_type: typeof item.to_stage,
    //             cre_usr_dt: item.cre_usr_dt,
    //             matches: item.from_stage === fromStage && item.to_stage === toStage
    //         });
    //     });

    //     // Try both strict and loose comparison
    //     const transition = trackingData.find(item =>
    //         item.from_stage === fromStage && item.to_stage === toStage
    //     );

    //     // Also try with string/number conversion
    //     const transitionLoose = trackingData.find(item =>
    //         parseInt(item.from_stage) === parseInt(fromStage) && 
    //         parseInt(item.to_stage) === parseInt(toStage)
    //     );

    //     console.log(`Found transition (strict) for ${fromStage} -> ${toStage}:`, transition);
    //     console.log(`Found transition (loose) for ${fromStage} -> ${toStage}:`, transitionLoose);

    //     const finalTransition = transition || transitionLoose;

    //     if (finalTransition) {
    //         console.log(`Date for transition ${fromStage} -> ${toStage}:`, finalTransition.cre_usr_dt);
    //         return finalTransition.cre_usr_dt;
    //     } else {
    //         console.log(`No transition found for ${fromStage} -> ${toStage}`);
    //         return null;
    //     }
    // };

    const getStageTransitionDate = (fromStage, toStage) => { const transition = trackingData.find(item => item.from_stage === fromStage && item.to_stage === toStage); return transition ? transition.cre_usr_dt : null; };

    const renderNo4 = () => {
        const table = () => (
            <div>
                <div className="overflow-x-auto p-4">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2">1</td>
                                <td className="border border-gray-700 p-2">मोजणी कार्यालयाचे नाव</td>
                                <td className="border border-gray-700 p-2" colSpan={2}>{proposalData.dslr_office_name || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">संयुक्त मोजणीसाठी प्रकरण पाठविल्याचे पत्र क्रमांक व दिनांक</td>
                                <td className="border border-gray-700 p-2" colSpan={2}>दिनांक {formatDate(proposalData.dlsr_survey_application_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">3</td>
                                <td className="border border-gray-700 p-2">संपादनाखालील क्षेत्राच्या प्रत्याक्ष मोजणीचा कालावधी</td>
                                <td className="border border-gray-700 p-2" colSpan={2}>दिनांक {formatDate(proposalData.surveyor_joint_start_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">4</td>
                                <td className="border border-gray-700 p-2">संयुक्त मोजणी अहवाल प्राप्त झाल्याचा</td>
                                <td className="border border-gray-700 p-2" colSpan={2}>दिनांक {formatDate(proposalData.surveyor_joint_end_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">5</td>
                                <td className="border border-gray-700 p-2">संयुक्त मोजणी अहवालाची छाननी केल्याचा दिनांक</td>
                                <td className="border border-gray-700 p-2" colSpan={2}>दिनांक {formatDate(getStageTransitionDate(12, 13)) || ''} </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2" rowSpan={2}>6</td>
                                <td className="border border-gray-700 p-2" rowSpan={2}>अंतिम संयुक्त मोजणी अहवालानुसार</td>
                                <td className="border border-gray-700 p-2">मिळकत धारकांची संख्या</td>
                                <td className="border border-gray-700 p-2">{ownersCompensationData.length || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">संपादनाखालील क्षेत्र</td>
                                {/* <td className="border border-gray-700 p-2">{(allOwnerCompensationData?.totals?.totalAquiredArea).toFixed(4)} {proposalData.area_unit}</td> */}
                                <td className="border border-gray-700 p-2">
                                    {Number(allOwnerCompensationData?.totals?.totalAquiredArea || 0).toFixed(4)}
                                    {" "}
                                    {proposalData.area_unit}
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                {table()}
            </div>
        );
    }

    const renderNo5 = () => {
        const table = () => (
            <div>
                <div className="overflow-x-auto p-4">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2">1</td>
                                <td className="border border-gray-700 p-2">संबंधीत तहसिलदार/तलाठी यांना पाठविलेल्या पत्राचा क्रमांक व दिनांक</td>
                                <td className="border border-gray-700 p-2">{proposalData.section_23_5_acquisition_area_letter_no || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">कार्यवाही संदर्भात तलाठी यांचेकडून कार्यपूती अनुपालन अहवाल प्राप्त झाल्याचा दिनांक</td>
                                <td className="border border-gray-700 p-2">{formatDate(proposalData.section_23_5_acquisition_area_compliance_report_date) || ''}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                {table()}
            </div>
        );
    }

    const renderNo6 = () => {
        const table = () => (
            <div>
                <div className="overflow-x-auto p-4">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2">1</td>
                                <td className="border border-gray-700 p-2">कलम 11(1) अन्वये अधिसूचित केलेल्या जमिनीमध्ये हितसंबंधीत असलेल्या व्यक्तीने आक्षेप हरकत दाखल करण्याचा अंतिम दिनांक (प्राथमिक अधिसूचना प्रसिध्द केल्यापासून साठ दिवसाचे आत)</td>
                                <td className="border border-gray-700 p-2">
                                    {proposalData?.propsal_publication_date
                                        ? formatDate(
                                            (() => {
                                                // Parse safely from API string
                                                const [year, month, day] = proposalData.propsal_publication_date.split("T")[0].split("-");
                                                const d = new Date(year, month - 1, day); // local date (no timezone shift)
                                                d.setDate(d.getDate() + 60);
                                                return d;
                                            })()
                                        )
                                        : "—"}
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">प्राप्त हरकती आक्षेपांची संख्या</td>
                                <td className="border border-gray-700 p-2">{generalObjectionData ? generalObjectionData.length : 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">3</td>
                                <td className="border border-gray-700 p-2">आक्षेपांच्या सुनावणीचा दिनांक</td>
                                <td className="border border-gray-700 p-2">
                                    दिनांक{" "}
                                    {generalObjectionData && generalObjectionData.length > 0 ? (
                                        generalObjectionData.map((item, idx) => (
                                            <React.Fragment key={idx}>
                                                {formatDate(item.hearing_date)}
                                                <br />
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        ""
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">4</td>
                                <td className="border border-gray-700 p-2">प्राप्त हरकती आक्षेप चौकशीसाठी भूमि अभिलेख विभाग व यंत्रणेकडे पाठविल्याचा पत्र क्रमांक व दिनांक</td>
                                <td className="border border-gray-700 p-2">निरंक</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">5</td>
                                <td className="border border-gray-700 p-2">चौकशी अहवाल / फेरतपासणी अहवाल (नमुना-ज) यंत्रणा आणि 5 भूमि अभिलेख यांचे संयुक्त अभिप्रायासह प्राप्त झाल्याचा पत्र क्रमांक व दिनाक</td>
                                <td className="border border-gray-700 p-2">दिनांक  {generalObjectionData[0]?.resolution_date
                                    ? formatDate(generalObjectionData[0].resolution_date)
                                    : ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">6</td>
                                <td className="border border-gray-700 p-2">चौकशी प्रक्रियेअंती समुचित शासनाचा अंतिम निर्णय दिनांक</td>
                                <td className="border border-gray-700 p-2">दिनांक  {generalObjectionData[0]?.resolution_date
                                    ? formatDate(generalObjectionData[0].resolution_date) : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                {table()}
            </div>
        );
    }

    const renderNo8 = () => {
        const section19Anusuchi1 = () => (
            <div className='mt-5'>
                <p className="text-center underline">अनुसूची-१</p>
                <p className="text-center mt-2">(जमिनीचे वर्णन)</p>

                {groupedData.map((group, gIndex) => (
                    // <div key={gIndex} style={{ pageBreakAfter: 'always' }}>
                    <div>
                        <h3 className="text-center text-xs m-2">
                            गाव: <span className="font-bold pr-3">{group.village}</span>
                            तालुका: <span className="font-bold pr-3">{group.taluka}</span>
                            जिल्हा: <span className="font-bold">{group.dist}</span>
                        </h3>

                        <div className="w-full">
                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                <thead>
                                    <tr className="bg-gray-200">
                                        <th rowSpan="2" className="border border-black p-2 text-center">अ. क्र.</th>
                                        <th rowSpan="2" className="border border-black p-2 text-center">गट क्रमांक</th>
                                        <th colSpan="3" className="border border-black p-2 text-center">संपादित क्षेत्र</th>
                                    </tr>
                                    <tr className="bg-gray-200">
                                        <th className="border border-black p-2 text-center">लागवड योग्य क्षेत्र ({proposalData.area_unit})</th>
                                        <th className="border border-black p-2 text-center">पोट खराब क्षेत्र ({proposalData.area_unit})</th>
                                        <th className="border border-black p-2 text-center">एकुण क्षेत्र ({proposalData.area_unit})</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {group.records.map((record, index) => (
                                        <tr key={index}>
                                            <td className="border border-black p-2 text-center">{index + 1}</td>
                                            <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                            <td className="border border-black p-2 text-center">{parseFloat(record.owner_irrigable_area || 0).toFixed(4)} </td>
                                            <td className="border border-black p-2 text-center">{parseFloat(record.owner_non_irrigable_area || 0).toFixed(4)} </td>
                                            <td className="border border-black p-2 text-center">
                                                {(
                                                    parseFloat(record.owner_irrigable_area || 0) +
                                                    parseFloat(record.owner_non_irrigable_area || 0)
                                                ).toFixed(4)}
                                            </td>

                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="2" className="border border-black p-2 font-bold text-right">एकूण क्षेत्र</td>
                                        <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalIrrigable || 0).toFixed(4)} </td>
                                        <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalNonIrrigable || 0).toFixed(4)} </td>
                                        <td className="border border-black p-2 font-bold text-center">
                                            {parseFloat(
                                                (group.ownerTotalIrrigable || 0) + (group.ownerTotalNonIrrigable || 0)
                                            ).toFixed(4)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                ))}
            </div>
        );

        const section19Punarvarshan = () => (
            <div className='mt-5'>
                <p className="text-center underline">अनुसूची-३</p>
                <p className="text-center mt-2">पुनर्वसाहत क्षेत्राचे वर्णन</p>

                {punarvarshanData && punarvarshanData.length > 0 ? (
                    punarvarshanData.map((group, gIndex) => (
                        <div key={gIndex}>
                            <h3 className="text-center text-xs m-2">
                                गाव: <span className="font-bold pr-3">{group.village}</span>
                                तालुका: <span className="font-bold pr-3">{group.taluka}</span>
                                जिल्हा: <span className="font-bold">{group.dist}</span>
                            </h3>

                            <div className="w-full">
                                <table className="border border-black border-collapse mb-4 text-sm w-full">
                                    <thead>
                                        <tr className="bg-gray-200">
                                            <th className="border border-black p-2 text-center">अनुक्रमांक</th>
                                            <th className="border border-black p-2 text-center">भूमापन क्रमांक</th>
                                            <th className="border border-black p-2 text-center">संपादित क्षेत्र (हेक्टर)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {group.records.map((record, index) => (
                                            <tr key={index}>
                                                <td className="border border-black p-2 text-center">{index + 1}</td>
                                                <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                <td className="border border-black p-2 text-center">
                                                    {parseFloat(record.aquire_area || 0).toFixed(4)}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="2" className="border border-black p-2 font-bold text-right">
                                                एकूण
                                            </td>
                                            <td className="border border-black p-2 font-bold text-center">
                                                {parseFloat(group.total || 0).toFixed(4)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-xs mt-2">
                        {''}
                    </div>
                )}
            </div>
        );

        const section19Publish = () => (
            <div>
                <p>कलम 19 (1) खालील प्रारंभिक अधिसूचना प्रसिध्दीचा तपक्षित :-</p>
                <div className="overflow-x-auto p-4">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2">1</td>
                                <td className="border border-gray-700 p-2">महाराष्ट्र राज्य राजपत्र {proposalData.section19_published_gazette_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_published_gazette) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">वृत्तपत्र क्र.1 {proposalData.section19_published_newspaper1_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_published_newspaper1) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">3</td>
                                <td className="border border-gray-700 p-2">वृत्तपत्र क्र.2 {proposalData.section19_published_newspaper2_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_published_newspaper2) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">4</td>
                                <td className="border border-gray-700 p-2">जिल्हाधिकारी कार्यालय, {proposalData.section19_collector_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_collector_office) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">5</td>
                                <td className="border border-gray-700 p-2">उपविभागीय अधिकारी कार्यालय, {proposalData.section19_sub_divisional_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_sub_divisional_office) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">6</td>
                                <td className="border border-gray-700 p-2">तहसिल कार्यालय, {proposalData.section19_tehsil_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_tehsil_office) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">7</td>
                                <td className="border border-gray-700 p-2">तलाठी कार्यालय, {proposalData.section19_municipal_authority_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_municipal_authority) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">8</td>
                                <td className="border border-gray-700 p-2">ग्रामपंचायत कार्यालय, {proposalData.section19_government_notice_board_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_government_notice_board) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">9</td>
                                <td className="border border-gray-700 p-2">जिल्हाधिकारी कार्यालयाचे संकेतस्थळ (समुचीत शासनाचे संकेतस्थळ) {proposalData.section19_gram_sevak_office_no || ''}</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_gram_sevak_office || '')}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">10</td>
                                <td className="border border-gray-700 p-2">कलम 19 (1) प्रारंभिक अधिसूचनेचा प्रसिध्दी दिनांक (भूमिसंपादन नियम (महाराष्ट्र) 2014-नियम 14 (3) अन्वये अधिसूचनेचा अंतिम प्रसिध्दी दिनांक)</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section19_rehabilitation_rights_notice) || ''}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                <div>
                    <table className=" p-4 w-full">
                        <tr>
                            <td className="border border-gray-700 p-2">कलम १९ (१) खालील घोषणेचा क्रमांक व दिनांक</td>
                            <td className="border border-gray-700 p-2">{(proposalData.section_19_notification)} दिनांक {formatDate(proposalData.section_19_date)}</td>
                        </tr>
                    </table>
                    {section19Anusuchi1()}
                    {section19Punarvarshan()}
                    {section19Publish()}
                </div>
            </div>
        );
    }

    const renderNo9 = () => {
        const table = () => (
            <div>
                <div className="overflow-x-auto p-4">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2" rowSpan={2}>1</td>
                                <td className="border border-gray-700 p-2" rowSpan={2}>समुचित शासनाचे संकेतस्थळावर प्रसिद्ध केल्याचा दिनांक</td>
                                <td className="border border-gray-700 p-2">महाराष्ट्र शासनचे राजपत्र दिनांक {formatDate(proposalData.section_23_9_21Gazette_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">स्थानिक पातळीवर प्रसिद्ध केल्याचा दिनांक {formatDate(proposalData.section_23_9_21tehsil_office_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">हितसंबंधितांना दिलेल्या नोटीसचा दिनांक</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section_23_9_21given_notice_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">3</td>
                                <td className="border border-gray-700 p-2">प्राप्त आक्षेप / हरकती/ निवेदनांची संख्या</td>
                                <td className="border border-gray-700 p-2">{proposalData.section_23_9_21objections_representations_statements_no || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">4</td>
                                <td className="border border-gray-700 p-2">चौकशी तारीख</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section_23_9_21inquiry_date)}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">5</td>
                                <td className="border border-gray-700 p-2">उपस्थित भुधारक / प्राधिकृत प्रतिनीधी संख्या</td>
                                <td className="border border-gray-700 p-2">{proposalData.section_23_9_21present_lanholders || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">6</td>
                                <td className="border border-gray-700 p-2">कलम 23 खाली चौकशी पूर्ण केल्याचा दिनांक</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section_23_9_21inquiry_completion_date) || ''}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">7</td>
                                <td className="border border-gray-700 p-2">चौकशीअंती आक्षेपः हरकती निकाली काढल्याचा दिनांक</td>
                                <td className="border border-gray-700 p-2">दिनांक {formatDate(proposalData.section_23_9_21disposal_objections_date)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                {table()}
            </div>
        );
    }

    const renderNo10 = () => {
        const table = () => (
            <div className='mt-5'>
                {groupedData.map((group, gIndex) => (
                    // <div key={gIndex} style={{ pageBreakAfter: 'always' }}>
                    <div>
                        <h3 className="text-center text-xs m-2">
                            गाव: <span className="font-bold">{group.village}</span>,
                            तालुका: <span className="font-bold">{group.taluka}</span>,
                            जिल्हा: <span className="font-bold">{group.dist}</span>
                        </h3>
                        <div className="w-full mt-5">
                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                <thead>
                                    <tr className="bg-gray-200">
                                        <th rowSpan="2" className="border border-black p-2 text-center">अ.क्र.</th>
                                        <th rowSpan="2" className="border border-black p-2 text-center">गट क्रमांक</th>
                                        <th colSpan="3" className="border border-black p-2 text-center">संपादनाखालील क्षेत्र ({proposalData.area_unit})</th>
                                        <th rowSpan="2" className="border border-black p-2 text-center">आकारणीचा हेक्टरी दर</th>
                                        <th rowSpan="2" className="border border-black p-2 text-center">गृप नंबर</th>
                                        <th rowSpan="2" className="border border-black p-2 text-center">भुधारणा प्रकार</th>
                                        <th rowSpan="2" className="border border-black p-2 text-center">भुधारकाचे नाव</th>
                                    </tr>
                                    <tr className="bg-gray-200">
                                        <th className="border border-black p-2 text-center">ला.यो.</th>
                                        <th className="border border-black p-2 text-center">पो.ख.</th>
                                        <th className="border border-black p-2 text-center">एकुण</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {group.records.map((record, index) => (
                                        <tr key={index}>
                                            <td className="border border-black p-2 text-center">{index + 1}</td>
                                            <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                            <td className="border border-black p-2 text-center">{parseFloat(record.owner_irrigable_area || 0).toFixed(4)} </td>
                                            <td className="border border-black p-2 text-center">{parseFloat(record.owner_non_irrigable_area || 0).toFixed(4)} </td>
                                            <td className="border border-black p-2 text-center">{(parseFloat(record.owner_irrigable_area || 0) + parseFloat(record.owner_non_irrigable_area || 0)).toFixed(4)}
                                            </td>
                                            <td className="border border-black p-2 text-center">{getMarketData(record.survey_no, "market_amount")}</td>
                                            <td className="border border-black p-2 text-center">{getMarketData(record.survey_no, "market_group_no")}</td>
                                            <td className="border border-black p-2 text-center">{record.land_holding_type}</td>
                                            <td className="border border-black p-2 text-center">{record.owner_name}</td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="2" className="border border-black p-2 font-bold text-right">एकुण क्षेत्र ({proposalData.area_unit})</td>
                                        <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalIrrigable || 0).toFixed(4)} </td>
                                        <td className="border border-black p-2 font-bold text-center">{parseFloat(group.ownerTotalNonIrrigable || 0).toFixed(4)} </td>
                                        <td className="border border-black p-2 font-bold text-center">{parseFloat(group.irrigableNonIrrigableTotal || 0).toFixed(4)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                ))}
            </div>
        );

        return (
            <div>
                <p>या प्रकरणातील संपादनाखानील अंतिम क्षेत्राचा तपशिल खालीलप्रमाणे आहे.</p>
                {table()}
            </div>
        );
    }

    const renderNo12 = () => {
        const one = () => (
            <div className='mt-5'>
                <div className="w-full">
                    <table className="border border-black border-collapse mb-4 text-sm w-full">
                        <thead>
                            <tr className="bg-gray-200">
                                <th className="border border-black p-2 text-center">आकार गट</th>
                                <th className="border border-black p-2 text-center">आकार गट आकारणी/प्रति हेक्टर</th>
                                <th className="border border-black p-2 text-center">गट क्रमांक</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border border-black p-2 text-center">1</td>
                                <td className="border border-black p-2 text-center">0.00 ते 1.25</td>
                                <td className="border border-black p-2 text-center">{getMarketValueSurveyNo(0.00, 1.25)}</td>
                            </tr>
                            <tr>
                                <td className="border border-black p-2 text-center">2</td>
                                <td className="border border-black p-2 text-center">1.26 ते 2.50</td>
                                <td className="border border-black p-2 text-center">{getMarketValueSurveyNo(1.26, 2.50)}</td>
                            </tr>
                            <tr>
                                <td className="border border-black p-2 text-center">3</td>
                                <td className="border border-black p-2 text-center">2.51 ते 5.00</td>
                                <td className="border border-black p-2 text-center">{getMarketValueSurveyNo(2.51, 5.00)}</td>
                            </tr>
                            <tr>
                                <td className="border border-black p-2 text-center">4</td>
                                <td className="border border-black p-2 text-center">5.01 ते 7.50</td>
                                <td className="border border-black p-2 text-center">{getMarketValueSurveyNo(5.01, 7.50)}</td>
                            </tr>
                            <tr>
                                <td className="border border-black p-2 text-center">5</td>
                                <td className="border border-black p-2 text-center">7.51 ते 10.00</td>
                                <td className="border border-black p-2 text-center">{getMarketValueSurveyNo(7.51, 10.00)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );

        const two = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_2_default_content", "no_12_default", "display")}</p>
                {/* A */}
                <div>
                    <p className="font-bold text-center">अ) शेतजमिनीच्या प्राप्त खरेदी-विक्री व्यवहारांची माहिती :-</p>
                    <div className='mt-5'>

                        {directPurchaseData && directPurchaseData.length > 0 ? (
                            directPurchaseData.map((group, gIndex) => (
                                <div key={gIndex}>
                                    <p className="font-bold text-center">(मौजे {group.village} ता. {group.taluka} जि. {group.dist})</p>

                                    <div className="w-full">
                                        <table className="border border-black border-collapse mb-4 text-sm w-full">
                                            <thead>
                                                <tr className="bg-gray-200">
                                                    <th className="border border-black p-2 text-center">अ.क्र</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                    <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                    <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                    <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                    <th className="border border-black p-2 text-center">आकार गट</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {group.records.map((record, index) => (
                                                    <tr key={index}>
                                                        <td className="border border-black p-2 text-ceanter">{index + 1}</td>
                                                        <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                        <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                        <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                        <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                        <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                        <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                    </tr>
                                                ))}
                                                {/* <tr>
                                                    <td colSpan="2" className="border border-black p-2 font-bold text-right">
                                                        एकूण
                                                    </td>
                                                    <td className="border border-black p-2 font-bold text-center">
                                                        {parseFloat(group.total || 0).toFixed(4)}
                                                    </td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-xs mt-2">
                                {''}
                            </div>
                        )}
                    </div>
                </div>

                {/* B */}
                <div>
                    <p className="font-bold text-center">ब) मुल्यांकन प्रक्रियेतून वगळलेले खरेदी-विक्री व्यवहार :-</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_2_b_content", "no_12_2_b", "display")}</p>

                    {/* Table */}
                    <div className='mt-5'>

                        {directPurchaseData?.map((group, gIndex) => {
                            // Split the B IDs from proposalData
                            const bIds = proposalData?.section_23_no12_2_b_table_ids
                                ? proposalData.section_23_no12_2_b_table_ids.split(",").map(String)
                                : [];

                            // Filter records
                            const filteredB = group.records.filter(r => bIds.includes(r.id.toString()));
                            if (!filteredB.length) return null;

                            return (
                                <div key={gIndex}>
                                    <p className="font-bold text-center">(मौजे {group.village} ता. {group.taluka} जि. {group.dist})</p>
                                    <div className="w-full">
                                        <table className="border border-black border-collapse mb-4 text-sm w-full">
                                            <thead>
                                                <tr className="bg-gray-200">
                                                    <th className="border border-black p-2 text-center">अ.क्र</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                    <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                    <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                    <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                    <th className="border border-black p-2 text-center">आकार गट</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredB.map((record, index) => (
                                                    <tr key={record.id}>
                                                        <td className="border border-black p-2 text-center">{index + 1}</td>
                                                        <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                        <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                        <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                        <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                        <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                        <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* C */}
                <div>
                    <p className="font-bold text-center">क) मुल्यांकनासाठी विचारात न घेतलेल्या खरेदी-विक्री व्यवहारांचा तपशिल :-</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_2_c_content", "no_12_2_c", "display")}</p>

                    {/* Table */}
                    <div className='mt-5'>
                        {directPurchaseData?.map((group, gIndex) => {
                            // Split the C IDs from proposalData
                            const bIds = proposalData?.section_23_no12_2_c_table_ids
                                ? proposalData.section_23_no12_2_c_table_ids.split(",").map(String)
                                : [];

                            // Filter records
                            const filteredB = group.records.filter(r => bIds.includes(r.id.toString()));
                            if (!filteredB.length) return null;

                            return (
                                <div key={gIndex}>
                                    <p className="font-bold text-center">(मौजे {group.village} ता. {group.taluka} जि. {group.dist})</p>
                                    <div className="w-full">
                                        <table className="border border-black border-collapse mb-4 text-sm w-full">
                                            <thead>
                                                <tr className="bg-gray-200">
                                                    <th className="border border-black p-2 text-center">अ.क्र</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                    <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                    <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                    <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                    <th className="border border-black p-2 text-center">आकार गट</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredB.map((record, index) => (
                                                    <tr key={record.id}>
                                                        <td className="border border-black p-2 text-center">{index + 1}</td>
                                                        <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                        <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                        <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                        <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                        <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                        <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* D */}
                <div>
                    <p className="font-bold text-center">ड) संपादनाखालील शेतजमिनीचे मुल्यनिर्धारण :-</p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_2_d_content", "no_12_2_d", "display")}</p>

                    {/* Table */}
                    <div className='mt-5'>
                        {directPurchaseData?.map((group, gIndex) => {
                            // Split the D IDs from proposalData
                            const bIds = proposalData?.section_23_no12_2_d_table_ids
                                ? proposalData.section_23_no12_2_d_table_ids.split(",").map(String)
                                : [];

                            // Filter records
                            const filteredB = group.records.filter(r => bIds.includes(r.id.toString()));
                            if (!filteredB.length) return null;

                            return (
                                <div key={gIndex}>
                                    <p className="font-bold text-center">(मौजे {group.village} ता. {group.taluka} जि. {group.dist})</p>
                                    <div className="w-full">
                                        <table className="border border-black border-collapse mb-4 text-sm w-full">
                                            <thead>
                                                <tr className="bg-gray-200">
                                                    <th className="border border-black p-2 text-center">अ.क्र</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                    <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                    <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                    <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                    <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                    <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                    <th className="border border-black p-2 text-center">आकार गट</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredB.map((record, index) => (
                                                    <tr key={record.id}>
                                                        <td className="border border-black p-2 text-center">{index + 1}</td>
                                                        <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                        <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                        <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                        <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                        <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                        <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                        <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* D */}
                <div>
                    {/* <p className="font-bold text-center"></p> */}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_2_e_content", "no_12_2_e", "display")}</p>

                    {/* Table */}

                </div>
            </div>
        );

        const three = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_3_content", "no_12_3", "display")}</p>

                {/* Table */}
                {/* <div className="overflow-x-auto p-4">
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <tbody>
                                <tr>
                                    <td className="border border-gray-700 p-2">अ.क्र.</td>
                                    
                                </tr>
                                <tr></tr>
                            </tbody>
                        </table>
                    </div> */}
            </div>
        )

        const four = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_4_content", "no_12_4", "display")}</p>

                {/* Table */}
                {/* <div className="overflow-x-auto p-4">
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <tbody>
                                <tr>
                                    <td className="border border-gray-700 p-2">अ.क्र.</td>
                                    
                                </tr>
                                <tr></tr>
                            </tbody>
                        </table>
                    </div> */}
            </div>
        )

        const five = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_5_content", "no_12_5", "display")}</p>

                {/* Table */}
                {/* <div className="overflow-x-auto p-4">
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <tbody>
                                <tr>
                                    <td className="border border-gray-700 p-2">अ.क्र.</td>
                                    
                                </tr>
                                <tr></tr>
                            </tbody>
                        </table>
                    </div> */}
            </div>
        )

        const six = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no12_6_content", "no_12_6", "display")}</p>

                {/* Table */}
                {/* <div className="overflow-x-auto p-4">
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <tbody>
                                <tr>
                                    <td className="border border-gray-700 p-2">अ.क्र.</td>
                                    
                                </tr>
                                <tr></tr>
                            </tbody>
                        </table>
                    </div> */}
            </div>
        )

        return (
            <div>
                <p className="font-bold">1) संपादनाखालील जमिनीचे गृपनिहाय वर्गीकरण :-</p>
                {one()}
                <p className="font-bold">2) खरेदी विक्री व्यवहार पध्दतीनुसार :-</p>
                {two()}
                <p className="font-bold">3) शिघ्रसिध्दगणक (वार्षिक बाजारमुल्य दर तक्ता) पध्दतीनूसार :-</p>
                {three()}
                <p className="font-bold">4) संपादनाखालील जमीनीचे निर्धारित बाजारमुल्य :-</p>
                {four()}
                <p className="font-bold">5) संपादनाखालील जमिनीचे निर्धारीत बाजारमुल्य ज्या घटकाव्दारे गुणावयाचे आहे तो घटक (गुणक):-</p>
                {five()}
                <p className="font-bold">6) संपादनाखालील पोट खराब क्षेत्राचे मुल्यांकन :-</p>
                {six()}
            </div>
        );
    }

    const renderNo13 = () => {
        // tree functions
        const one = () => (
            <div className='mt-5'>
                <div>
                    <div className="w-full mt-5">
                        {ownersCompensationData?.some(owner =>
                            owner.trees.some(t => t.originalTree.tree_type_name1 === "फळझाडे")
                        ) ? (
                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                <thead>
                                    <tr className="bg-gray-100 text-center">
                                        <td className="border border-black p-2 font-semibold">अ.क्र.</td>
                                        <td className="border border-black p-2 font-semibold">गट क्र.</td>
                                        <td className="border border-black p-2 font-semibold">भूधारकाचे नाव</td>
                                        <td className="border border-black p-2 font-semibold">फळझाडाचा प्रकार</td>
                                        <td className="border border-black p-2 font-semibold">संख्या</td>
                                        <td className="border border-black p-2 font-semibold">मुल्यांकीत रक्कम</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ownersCompensationData.map((ownerGroup) => {
                                        const filteredTrees = ownerGroup.trees.filter(
                                            (t) => t.originalTree.tree_type_name1 === "फळझाडे"
                                        );

                                        if (filteredTrees.length === 0) return null;

                                        const totalCount = filteredTrees.reduce((sum, t) => sum + t.treeCount, 0);
                                        const totalAmount = filteredTrees.reduce((sum, t) => sum + t.calculatedAmount, 0);

                                        return (
                                            <React.Fragment key={ownerGroup.ownerId}>
                                                {filteredTrees.map((tree, treeIndex) => (
                                                    <tr key={`${ownerGroup.ownerId}-${treeIndex}`} className="hover:bg-gray-50">
                                                        {treeIndex === 0 && (
                                                            <td className="border border-black p-2 text-center" rowSpan={filteredTrees.length}>
                                                                {tree.serialNo}
                                                            </td>
                                                        )}
                                                        {treeIndex === 0 && (
                                                            <td className="border border-black p-2 text-center" rowSpan={filteredTrees.length}>
                                                                {ownerGroup.gatNo}
                                                            </td>
                                                        )}
                                                        {treeIndex === 0 && (
                                                            <td className="border border-black p-2" rowSpan={filteredTrees.length}>
                                                                {ownerGroup.ownerName}
                                                            </td>
                                                        )}
                                                        <td className="border border-black p-2 text-center">{tree.treeType}</td>
                                                        <td className="border border-black p-2 text-center">{tree.treeCount}</td>
                                                        <td className="border border-black p-2 text-center">
                                                            {tree.calculatedAmount.toLocaleString('en-IN')}
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr className="font-semibold">
                                                    <td colSpan={4} className="border border-black p-2 text-right">एकूण</td>
                                                    <td className="border border-black p-2 text-center">{totalCount}</td>
                                                    <td className="border border-black p-2 text-center">{totalAmount.toLocaleString('en-IN')}</td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                    <tr className="bg-gray-300 font-bold">
                                        <td colSpan={5} className="border border-black p-2 text-right">एकूण बेरीज</td>
                                        <td className="border border-black p-2 text-center">
                                            ₹ {ownersCompensationData
                                                .reduce((sum, ownerGroup) => {
                                                    const filteredTrees = ownerGroup.trees.filter(
                                                        (t) => t.originalTree.tree_type_name1 === "फळझाडे"
                                                    );
                                                    return sum + filteredTrees.reduce((s, t) => s + t.calculatedAmount, 0);
                                                }, 0)
                                                .toLocaleString('en-IN')}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <p>&nbsp;&nbsp;&nbsp;&nbsp; प्रस्तुत प्रकरणातील संपादन क्षेत्रात फळ झाडे नसल्याने फळझाडांचे मुल्यांकन निरंक आहे.</p>
                        )}
                    </div>
                </div>
            </div>
        );

        const two = () => (
            <div className='mt-5'>
                <div>
                    <div className="w-full mt-5">
                        {ownersCompensationData?.some(owner =>
                            owner.trees.some(t => t.originalTree.tree_type_name1 === "वनझाडे")
                        ) ? (
                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                <thead>
                                    <tr className="bg-gray-100 text-center">
                                        <td className="border border-black p-2 font-semibold">अ.क्र.</td>
                                        <td className="border border-black p-2 font-semibold">गट क्र.</td>
                                        <td className="border border-black p-2 font-semibold">भूधारकाचे नाव</td>
                                        <td className="border border-black p-2 font-semibold">वनझाडाचा प्रकार</td>
                                        <td className="border border-black p-2 font-semibold">संख्या</td>
                                        <td className="border border-black p-2 font-semibold">मुल्यांकीत रक्कम</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ownersCompensationData.map((ownerGroup) => {
                                        const filteredTrees = ownerGroup.trees.filter(
                                            (t) => t.originalTree.tree_type_name1 === "वनझाडे"
                                        );

                                        if (filteredTrees.length === 0) return null;

                                        const totalCount = filteredTrees.reduce((sum, t) => sum + t.treeCount, 0);
                                        const totalAmount = filteredTrees.reduce((sum, t) => sum + t.calculatedAmount, 0);

                                        return (
                                            <React.Fragment key={ownerGroup.ownerId}>
                                                {filteredTrees.map((tree, treeIndex) => (
                                                    <tr key={`${ownerGroup.ownerId}-${treeIndex}`} className="hover:bg-gray-50">
                                                        {treeIndex === 0 && (
                                                            <td className="border border-black p-2 text-center" rowSpan={filteredTrees.length}>
                                                                {tree.serialNo}
                                                            </td>
                                                        )}
                                                        {treeIndex === 0 && (
                                                            <td className="border border-black p-2 text-center" rowSpan={filteredTrees.length}>
                                                                {ownerGroup.gatNo}
                                                            </td>
                                                        )}
                                                        {treeIndex === 0 && (
                                                            <td className="border border-black p-2" rowSpan={filteredTrees.length}>
                                                                {ownerGroup.ownerName}
                                                            </td>
                                                        )}
                                                        <td className="border border-black p-2 text-center">{tree.treeType}</td>
                                                        <td className="border border-black p-2 text-center">{tree.treeCount}</td>
                                                        <td className="border border-black p-2 text-center">
                                                            {tree.calculatedAmount.toLocaleString('en-IN')}
                                                        </td>
                                                    </tr>
                                                ))}
                                                <tr className="font-semibold">
                                                    <td colSpan={4} className="border border-black p-2 text-right">एकूण</td>
                                                    <td className="border border-black p-2 text-center">{totalCount}</td>
                                                    <td className="border border-black p-2 text-center">{totalAmount.toLocaleString('en-IN')}</td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                    <tr className="bg-gray-300 font-bold">
                                        <td colSpan={5} className="border border-black p-2 text-right">एकूण बेरीज</td>
                                        <td className="border border-black p-2 text-center">
                                            ₹ {ownersCompensationData
                                                .reduce((sum, ownerGroup) => {
                                                    const filteredTrees = ownerGroup.trees.filter(
                                                        (t) => t.originalTree.tree_type_name1 === "वनझाडे"
                                                    );
                                                    return sum + filteredTrees.reduce((s, t) => s + t.calculatedAmount, 0);
                                                }, 0)
                                                .toLocaleString('en-IN')}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;प्रस्तुत प्रकरणातील संपादन क्षेत्रात वन झाडे नसल्याने वनझाडांचे मुल्यांकन निरंक आहे.</p>
                        )}
                    </div>
                </div>
            </div>
        );

        // well/borewell table
        const three = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no13_c_content", "no_13_c", "display")}</p>

                <div className="overflow-x-auto">
                    {ownersCompensationData && ownersCompensationData.some(owner =>
                        owner.wells.length > 0 || owner.borewells.length > 0
                    ) ? (
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <thead>
                                <tr className="bg-gray-100">
                                    <td className="border border-gray-700 p-2 font-semibold">अ.क्र.</td>
                                    <td className="border border-gray-700 p-2 font-semibold">गट क्रमांक</td>
                                    <td className="border border-gray-700 p-2 font-semibold">भुधारकाचे नाव</td>
                                    <td className="border border-gray-700 p-2 font-semibold">विहीर संख्या</td>
                                    <td className="border border-gray-700 p-2 font-semibold">मुल्यांकीत रक्कम (रुपये)</td>
                                    <td className="border border-gray-700 p-2 font-semibold">बोअरवेल संख्या</td>
                                    <td className="border border-gray-700 p-2 font-semibold">मुल्यांकीत रक्कम (रुपये)</td>
                                </tr>
                            </thead>
                            <tbody>
                                {ownersCompensationData.map((ownerGroup, ownerIndex) => {
                                    const hasWellsOrBorewells = ownerGroup.wells.length > 0 || ownerGroup.borewells.length > 0;

                                    if (!hasWellsOrBorewells) return null;

                                    const maxRecords = Math.max(ownerGroup.wells.length, ownerGroup.borewells.length);
                                    const rows = [];

                                    for (let i = 0; i < maxRecords; i++) {
                                        const well = ownerGroup.wells[i];
                                        const borewell = ownerGroup.borewells[i];

                                        rows.push(
                                            <tr key={`${ownerGroup.ownerId}-${i}`}>
                                                {i === 0 && (
                                                    <td className="border border-gray-700 p-2 text-center" rowSpan={maxRecords}>
                                                        {ownerIndex + 1}
                                                    </td>
                                                )}
                                                {i === 0 && (
                                                    <td className="border border-gray-700 p-2 text-center" rowSpan={maxRecords}>
                                                        {ownerGroup.gatNo}
                                                    </td>
                                                )}
                                                {i === 0 && (
                                                    <td className="border border-gray-700 p-2" rowSpan={maxRecords}>
                                                        {ownerGroup.ownerName}
                                                    </td>
                                                )}
                                                <td className="border border-gray-700 p-2 text-center">
                                                    {well ? (well.wellTotal || well.originalWell?.total || 0) : '-'}
                                                </td>
                                                <td className="border border-gray-700 p-2 text-center">
                                                    {well && well.calculatedAmount > 0 ? `${well.calculatedAmount.toLocaleString('en-IN')}` : '-'}
                                                </td>
                                                <td className="border border-gray-700 p-2 text-center">
                                                    {borewell ? (borewell.borewellTotal || borewell.originalBorewell?.total || 0) : '-'}
                                                </td>
                                                <td className="border border-gray-700 p-2 text-center">
                                                    {borewell && borewell.calculatedAmount > 0 ? `${borewell.calculatedAmount.toLocaleString('en-IN')}` : '-'}
                                                </td>
                                            </tr>
                                        );
                                    }

                                    return rows;
                                })}
                                <tr className="bg-gray-300 font-bold">
                                    <td colSpan={3} className="border border-gray-700 p-2 text-right">एकूण बेरीज</td>
                                    <td className="border border-gray-700 p-2 text-center">
                                        {ownersCompensationData
                                            .reduce((sum, owner) =>
                                                sum + owner.wells.reduce((s, well) => s + (well.wellTotal || well.originalWell?.total || 0), 0), 0
                                            )}
                                    </td>
                                    <td className="border border-gray-700 p-2 text-center">
                                        ₹ {ownersCompensationData
                                            .reduce((sum, owner) =>
                                                sum + owner.wells.reduce((s, well) => s + well.calculatedAmount, 0), 0
                                            ).toLocaleString('en-IN')}
                                    </td>
                                    <td className="border border-gray-700 p-2 text-center">
                                        {ownersCompensationData
                                            .reduce((sum, owner) =>
                                                sum + owner.borewells.reduce((s, borewell) => s + (borewell.borewellTotal || borewell.originalBorewell?.total || 0), 0), 0
                                            )}
                                    </td>
                                    <td className="border border-gray-700 p-2 text-center">
                                        ₹ {ownersCompensationData
                                            .reduce((sum, owner) =>
                                                sum + owner.borewells.reduce((s, borewell) => s + borewell.calculatedAmount, 0), 0
                                            ).toLocaleString('en-IN')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;प्रस्तुत प्रकरणातील संपादन क्षेत्रात विहीर/बोअरवेल नसल्याने मुल्यांकन निरंक आहे.</p>
                    )}
                </div>
            </div>
        );

        // pipeline table
        const four = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no13_d_content", "no_13_d", "display")}</p>

                <div className="overflow-x-auto">
                    {ownersCompensationData && ownersCompensationData.some(owner => owner.pipelines.length > 0) ? (
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <thead>
                                <tr className="bg-gray-100">
                                    <td className="border border-gray-700 p-2 font-semibold">अ.क्र.</td>
                                    <td className="border border-gray-700 p-2 font-semibold">गट क्रमांक</td>
                                    <td className="border border-gray-700 p-2 font-semibold">भुधारकाचे नाव</td>
                                    <td className="border border-gray-700 p-2 font-semibold">पाईपलाईनच्या मुल्यांकनाची रक्कम (रुपये)</td>
                                </tr>
                            </thead>
                            <tbody>
                                {ownersCompensationData.map((ownerGroup, index) => {
                                    if (ownerGroup.pipelines.length === 0) return null;

                                    const pipelineAmount = ownerGroup.pipelines.reduce((sum, pipeline) => sum + pipeline.calculatedAmount, 0);

                                    return (
                                        <tr key={ownerGroup.ownerId}>
                                            <td className="border border-gray-700 p-2 text-center">{index + 1}</td>
                                            <td className="border border-gray-700 p-2 text-center">{ownerGroup.gatNo}</td>
                                            <td className="border border-gray-700 p-2">{ownerGroup.ownerName}</td>
                                            <td className="border border-gray-700 p-2 text-center">
                                                {pipelineAmount.toLocaleString('en-IN')}
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr className="bg-gray-300 font-bold">
                                    <td colSpan={3} className="border border-gray-700 p-2 text-right">एकूण बेरीज</td>
                                    <td className="border border-gray-700 p-2 text-center">
                                        ₹ {ownersCompensationData
                                            .reduce((sum, owner) =>
                                                sum + owner.pipelines.reduce((s, pipeline) => s + pipeline.calculatedAmount, 0), 0
                                            ).toLocaleString('en-IN')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;प्रस्तुत प्रकरणातील संपादन क्षेत्रात पाईपलाईन नसल्याने मुल्यांकन निरंक आहे.</p>
                    )}
                </div>
            </div>
        );

        const structureTypeMap = {
            "tinshed/godown": "टिनशेड/गोदाम",
            "home": "घर",
            "Shop": "दुकान",
            "Compound": "कंपाउंड भिंत",
            "wirefencing": "तार कुंपण",
            "farmpond": "शेततळे",
            "other": "इतर",
        };

        // structures (home/tinshed) table
        const five = () => (
            <div>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no13_e_content", "no_13_e", "display")}</p>

                <div className="overflow-x-auto">
                    {ownersCompensationData && ownersCompensationData.some(owner => owner.structures.length > 0) ? (
                        <table className="table-auto border border-gray-700 w-full text-sm">
                            <thead>
                                <tr className="bg-gray-100">
                                    <td className="border border-gray-700 p-2 font-semibold">अ.क्र.</td>
                                    <td className="border border-gray-700 p-2 font-semibold">गट क्रमांक</td>
                                    <td className="border border-gray-700 p-2 font-semibold">भुधारकाचे नाव</td>
                                    <td className="border border-gray-700 p-2 font-semibold">बांधकामाचा तपशिल</td>
                                    <td className="border border-gray-700 p-2 font-semibold">मुल्यांकीत रक्कम (रुपये)</td>
                                </tr>
                            </thead>
                            <tbody>
                                {ownersCompensationData.map((ownerGroup) => {
                                    if (ownerGroup.structures.length === 0) return null;

                                    return (
                                        <React.Fragment key={ownerGroup.ownerId}>
                                            {ownerGroup.structures.map((structure, structureIndex) => (
                                                <tr key={`${ownerGroup.ownerId}-${structureIndex}`}>
                                                    {structureIndex === 0 && (
                                                        <td className="border border-gray-700 p-2 text-center" rowSpan={ownerGroup.structures.length}>
                                                            {structure.serialNo}
                                                        </td>
                                                    )}
                                                    {structureIndex === 0 && (
                                                        <td className="border border-gray-700 p-2 text-center" rowSpan={ownerGroup.structures.length}>
                                                            {ownerGroup.gatNo}
                                                        </td>
                                                    )}
                                                    {structureIndex === 0 && (
                                                        <td className="border border-gray-700 p-2" rowSpan={ownerGroup.structures.length}>
                                                            {ownerGroup.ownerName}
                                                        </td>
                                                    )}
                                                    <td className="border border-gray-700 p-2">
                                                        {structureTypeMap[structure.structureType] || structure.structureType}
                                                    </td>
                                                    <td className="border border-gray-700 p-2 text-center">
                                                        {structure.calculatedAmount.toLocaleString('en-IN')}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr className="font-semibold">
                                                <td colSpan={4} className="border border-gray-700 p-2 text-right">एकूण</td>
                                                <td className="border border-gray-700 p-2 text-center">
                                                    {ownerGroup.structures.reduce((sum, structure) => sum + structure.calculatedAmount, 0).toLocaleString('en-IN')}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}
                                <tr className="bg-gray-300 font-bold">
                                    <td colSpan={4} className="border border-gray-700 p-2 text-right">एकूण बेरीज</td>
                                    <td className="border border-gray-700 p-2 text-center">
                                        ₹ {ownersCompensationData
                                            .reduce((sum, owner) =>
                                                sum + owner.structures.reduce((s, structure) => s + structure.calculatedAmount, 0), 0
                                            ).toLocaleString('en-IN')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;प्रस्तुत प्रकरणातील संपादन क्षेत्रात बांधकाम नसल्याने मुल्यांकन निरंक आहे.</p>
                    )}
                </div>
            </div>
        );

        return (
            <div>
                {/* A */}
                <p className="font-bold">अ) संपादनाखालील क्षेत्रातील फळझाडांचे मुल्यांकन :-</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no13_a_1_content", "no_13_a_1", "display")}</p>
                {one()}
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no13_a_2_content", "no_13_a_2", "display")}</p>

                {/* B */}
                <p className="font-bold">ब) संपादनाखालील क्षेत्रातील वनझाडांचे मुल्यांकन :-</p>
                {two()}

                {/* C */}
                <p className="font-bold">क) संपादनाखालील क्षेत्रातील विहीर / बोअरवेल इत्यादीचे मुल्यांकन :-</p>
                {three()}

                {/* D */}
                <p className="font-bold">ड) सपादनाखालील क्षेत्रातील पाईपलाईनचे मुल्यांकन :-</p>
                {four()}

                {/* E */}
                <p className="font-bold">इ) संपादनाखालील क्षेत्रातील बांधकामाचे मुल्यांकन :-</p>
                {five()}
            </div>
        );
    };

    const renderNo18 = () => {
        const table = () => (
            <div className='mt-5'>
                <div className="overflow-x-auto">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2">1</td>
                                <td className="border border-gray-700 p-2">कलम 26 (1) नुसार निर्धारीत केलेले जमिनीचे बाजारमुल्य</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.landRate) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">ज्या घटकाव्दारे जमीनीचे बाजारमुल्य गुणावयाचे आहे तो घटक (गुणक) (कलम 26 (2) नुसार)</td>
                                <td className="border border-gray-700 p-2">2</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">3</td>
                                <td className="border border-gray-700 p-2">जमीनीची किंमत (कलम 26 नुसार) (बाजारमुल्य x गुणक या सुत्रानुसार)</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.landAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">4</td>
                                <td className="border border-gray-700 p-2">फळझाडे / वनझाडे मुल्यांकन (कलम 27 नुसार)</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.treeAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">5</td>
                                <td className="border border-gray-700 p-2">विहीर / बोअरवेल / बांधकाम ई. मुल्यांकन (कलम 27 नुसार)</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.borewellAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">6</td>
                                <td className="border border-gray-700 p-2">एकुण भरपाई रक्कम (कलम 27 नुसार) (रकाना 3 ते 5 ची बेरीज)</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.firstTotal) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">7</td>
                                <td className="border border-gray-700 p-2">दिलासा रक्कम @ 100% (कलम 30 (1) नुसार) रकाना (6) वर</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.dilasaAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">8</td>
                                <td className="border border-gray-700 p-2">जमीनीच्या बाजारमूल्यावर द.सा.द.शे. 12% या दराने अतिरिक्त घटकाची रक्कम (रकाना 3 वर) (कलम 30 (3) नुसार) (एकुण दिवस 163 )
                                </td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.interestAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">9</td>
                                <td className="border border-gray-700 p-2">पाईपलाईनचे मुल्यांकन</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.pipelineAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">10</td>
                                <td className="border border-gray-700 p-2">निवाडयाची एकुण रक्कम (रकाना 6 ते 9 ची बेरीज)</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.secondTotal) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">11</td>
                                <td className="border border-gray-700 p-2">वजा (-) 50% अग्रिमाची रक्कम</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.advancedAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">12</td>
                                <td className="border border-gray-700 p-2">वजा (-) वसुली केलेली अनर्जित रक्कम</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.recoveredUnearnedAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">13</td>
                                <td className="border border-gray-700 p-2">अग्रीम व अनर्जित रक्कम वजा जाता निव्वळ देय रक्कम (रकाना 11-12-13)</td>
                                <td className="border border-gray-700 p-2">₹ {formatAmount(allOwnerCompensationData?.totals?.finalAmount) || 0}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                <p className="text-center font-bold">-: मुल्यांकनाचा तपशिल :-</p>
                <p className="text-center font-bold">(पहा भूमीसंपादन, पुनर्वसन व पुर्नस्थापना करतांना वाजवी भरपाई व पारदर्शकतेचा हक्क अधिनियम 2013 ते कलम 30)</p>
                {table()}
            </div>
        );
    }

    // Convert number into Marathi words
    const numberToMarathiWords = (num) => {
        if (!num || isNaN(num)) return "";

        const ones = [
            "", "एक", "दोन", "तीन", "चार", "पाच", "सहा", "सात", "आठ", "नऊ",
            "दहा", "अकरा", "बारा", "तेरा", "चौदा", "पंधरा", "सोळा", "सतरा", "अठरा", "एकोणीस"
        ];

        // Traditional Marathi numbers 20-99
        const traditionalNumbers = {
            20: "वीस", 21: "एकवीस", 22: "बावीस", 23: "तेवीस", 24: "चोवीस", 25: "पंचवीस",
            26: "सव्वीस", 27: "सत्तावीस", 28: "अठ्ठावीस", 29: "एकोणतीस",
            30: "तीस", 31: "एकतीस", 32: "बत्तीस", 33: "तेहतीस", 34: "चौतीस", 35: "पस्तीस",
            36: "छत्तीस", 37: "सदतीस", 38: "अडतीस", 39: "एकोणचाळीस",
            40: "चाळीस", 41: "एक्केचाळीस", 42: "बेचाळीस", 43: "त्रेचाळीस", 44: "चव्वेचाळीस", 45: "पंचेचाळीस",
            46: "सेहेचाळीस", 47: "सत्तेचाळीस", 48: "अठ्ठेचाळीस", 49: "एकोणपन्नास",
            50: "पन्नास", 51: "एक्कावन्न", 52: "बावन्न", 53: "त्रेपन्न", 54: "चौपन्न", 55: "पंचावन्न",
            56: "छप्पन्न", 57: "सत्तावन्न", 58: "अठ्ठावन्न", 59: "एकोणसाठ",
            60: "साठ", 61: "एकसष्ट", 62: "बासष्ट", 63: "त्रेसष्ट", 64: "चौसष्ट", 65: "पासष्ट",
            66: "सहासष्ट", 67: "सदुसष्ट", 68: "अडुसष्ट", 69: "एकोणसत्तर",
            70: "सत्तर", 71: "एकाहत्तर", 72: "बाहत्तर", 73: "त्र्याहत्तर", 74: "चौऱ्याहत्तर", 75: "पंच्याहत्तर",
            76: "शहात्तर", 77: "सत्याहत्तर", 78: "अठ्ठ्याहत्तर", 79: "एकोणऐंशी",
            80: "ऐंशी", 81: "एक्याऐंशी", 82: "ब्याऐंशी", 83: "त्र्याऐंशी", 84: "चौऱ्याऐंशी", 85: "पंच्याऐंशी",
            86: "शहाऐंशी", 87: "सत्याऐंशी", 88: "अठ्ठ्याऐंशी", 89: "एकोणनव्वद",
            90: "नव्वद", 91: "एक्याण्णव", 92: "ब्याण्णव", 93: "त्र्याण्णव", 94: "चौऱ्याण्णव", 95: "पंच्याण्णव",
            96: "शहाण्णव", 97: "सत्याण्णव", 98: "अठ्ठ्याण्णव", 99: "नव्याण्णव"
        };

        const numToWordsBelow100 = (n) => {
            if (n < 20) return ones[n];
            return traditionalNumbers[n] || "";
        };

        const numToWords = (n) => {
            if (n === 0) return "शून्य";
            let result = "";

            // Handle crores (कोटी)
            if (Math.floor(n / 10000000) > 0) {
                result += numToWords(Math.floor(n / 10000000)) + " कोटी ";
                n %= 10000000;
            }

            // Handle lakhs (लाख)
            if (Math.floor(n / 100000) > 0) {
                result += numToWords(Math.floor(n / 100000)) + " लाख ";
                n %= 100000;
            }

            // Handle thousands (हजार)
            if (Math.floor(n / 1000) > 0) {
                result += numToWords(Math.floor(n / 1000)) + " हजार ";
                n %= 1000;
            }

            // Handle hundreds (शे/शंभर)
            if (Math.floor(n / 100) > 0) {
                const hundreds = Math.floor(n / 100);
                if (hundreds === 1) {
                    result += "शंभर ";
                } else if (hundreds === 2) {
                    result += "दोनशे ";
                } else if (hundreds === 3) {
                    result += "तीनशे ";
                } else if (hundreds === 4) {
                    result += "चारशे ";
                } else if (hundreds === 5) {
                    result += "पाचशे ";
                } else if (hundreds === 6) {
                    result += "सहाशे ";
                } else if (hundreds === 7) {
                    result += "सातशे ";
                } else if (hundreds === 8) {
                    result += "आठशे ";
                } else if (hundreds === 9) {
                    result += "नऊशे ";
                } else {
                    result += numToWords(hundreds) + "शे ";
                }
                n %= 100;
            }

            if (n > 0) {
                result += numToWordsBelow100(n);
            }

            return result.trim();
        };

        return numToWords(parseInt(num, 10));
    };

    const renderNo19 = () => {
        const irrigableTotal = landData?.reduce((sum, r) => sum + (r.irrigableTotal || 0), 0) || 0;
        const nonIrrigableTotal = landData?.reduce((sum, r) => sum + (r.nonIrrigableTotal || 0), 0) || 0;
        const total = irrigableTotal + nonIrrigableTotal;

        const table = () => (
            <div className='mt-5'>
                <div className="overflow-x-auto">
                    <table className="table-auto border border-gray-700 w-full text-sm">
                        <tbody>
                            <tr>
                                <td className="border border-gray-700 p-2" rowSpan={4}>1</td>
                                <td className="border border-gray-700 p-2" rowSpan={4}>संपादित जमिनीचे खरे व नक्की असे</td>
                                {/* <td className="border border-gray-700 p-2"></td> */}
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">लागवडयोग्य क्षेत्र :- </td>
                                <td className="border border-gray-700 p-2">{parseFloat(irrigableTotal || 0).toFixed(4)} {proposalData.area_unit}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">पोटखराब क्षेत्र :-</td>
                                <td className="border border-gray-700 p-2">{parseFloat(nonIrrigableTotal || 0).toFixed(4)} {proposalData.area_unit}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">एकुण क्षेत्र :-</td>
                                <td className="border border-gray-700 p-2">{parseFloat(total || 0).toFixed(4)} {proposalData.area_unit}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">2</td>
                                <td className="border border-gray-700 p-2">एकुण भरपाईची रक्कम :-</td>
                                <td className="border border-gray-700 p-2" colspan="2">₹ {formatAmount(allOwnerCompensationData?.totals?.secondTotal) || 0}</td>
                            </tr>
                            <tr>
                                {/* <td className="border border-gray-700 p-2">3</td> */}
                                <td className="border border-gray-700 p-2 text-center" colspan="4">अक्षरी रुपये{" "}
                                    {numberToMarathiWords(allOwnerCompensationData?.totals?.secondTotal || 0)}{" "}
                                    फक्त/-</td>
                                {/* <td className="border border-gray-700 p-2" colspan="2"></td> */}
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">4</td>
                                <td className="border border-gray-700 p-2">वजा (-) अग्रीमाची रक्कम :-</td>
                                <td className="border border-gray-700 p-2" colspan="2">{formatAmount(allOwnerCompensationData?.totals?.advancedAmount) || 0}</td>
                            </tr>
                            <tr>
                                <td className="border border-gray-700 p-2">5</td>
                                <td className="border border-gray-700 p-2">निव्वळ देय रक्कम :-</td>
                                <td className="border border-gray-700 p-2" colspan="2">₹ {formatAmount(allOwnerCompensationData?.totals?.finalAmount) || 0}</td>
                            </tr>
                            <tr>
                                {/* <td className="border border-gray-700 p-2"></td> */}
                                <td className="border border-gray-700 p-2 text-center" colspan="4">अक्षरी रुपये{" "}
                                    {numberToMarathiWords(allOwnerCompensationData?.totals?.finalAmount || 0)}{" "}
                                    फक्त/-</td>
                                {/* <td className="border border-gray-700 p-2" colspan="2"></td> */}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

        return (
            <div>
                {table()}
            </div>
        );
    }

    const renderNotificationDocument = (ref) => (
        <div
            ref={ref} id="notification-content"
            className="space-y-4 m-1 p-1 bg-white shadow-lg rounded-lg border border-gray-300"
            style={{
                // fontFamily: "'Noto Sans Devanagari', Arial, sans-serif",
                minHeight: '4500mm',
                // minHeight: 'auto',
                // minHeight: 'fit-content',
                // minHeight: '100%',
                width: '210mm',
                padding: '15mm',
                margin: '0 auto'
            }}>

            {/* Header */}
            <div className="text-center mb-5">
                {/* Logo */}
                <img
                    src="/Emblem_of_India.svg"
                    alt="महाराष्ट्र शासन"
                    className="mx-auto mb-2 w-20"
                />

                {/* Government name */}
                <div className="font-bold text-base">महाराष्ट्र शासन</div>
                <div className="font-bold text-base">महसूल व वन विभाग</div>

                {/* Office Name */}
                <div className="font-bold text-2xl">
                    {/* {getFieldValue('section_19_office_name', 'section_11_office_name', '')} */}
                    {proposalData.section_23_office_name || proposalData.section_19_office_name || proposalData.section_11_office_name}
                </div>

                {/* Branch */}
                <div className="text-lg font-semibold">
                    शाखा :- {proposalData.section_23_branch_name || proposalData.section_19_branch_name || proposalData.section_11_branch_name}
                </div>
            </div>

            {/* Bottom Contact Section */}
            <div className="text-xs mt-4">
                {/* Horizontal line */}
                <hr className="border-black border-2 my-1" />
            </div>

            <div className="text-justify leading-relaxed space-y-1 text-sm">

                <div className="space-y-3">
                    <p className="text-center text-base font-bold">भूसंपादन प्रकरण क्रमांक - {proposalData.section_23_bhusampadan_no || proposalData.section_11_bhusampadan_no}</p>
                    {/* मौजे {proposalData.village_name} ता. {proposalData.taluka_name} जिल्हा- {proposalData.dist_name} */}
                    {/* <p className="text-center text-base font-bold underline">
                        {collectorEditCompletedbuttonDisabled
                            ? (approval === true || approval === 1 ? 'अंतिम निवाडा' : 'प्रारुप निवाडा')
                            : 'प्रारुप निवाडा'}
                    </p> */}
                    <p className="text-center text-lg font-bold underline">
                        {currentType === 'antimNivada' ? 'अंतिम निवाडा' : 'प्रारुप निवाडा'}
                    </p>
                    <p className="text-center text-sm font-bold">(भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम, 2013 चे कलम 23 नुसार)</p>
                    <p className="text-center text-sm">(दिनांक {formatDate(proposalData.section_23_date)})</p>
                </div>

                <div className="mt-4">
                    {renderProposalTable()}
                </div>

                {/* 1 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">1) प्रस्तावना:</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no1_content", "no_1", "display")}</p>
                </div>

                {/* 2 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">2) सामाजिक आघात व सार्वजनिक प्रयोजन निर्धारित करणे (प्रकरण-दोन, कलम 4 ते 9)</div>
                    {/* { } */}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no2_content", "no_2", "display")}</p>
                </div>

                {/* 3 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">3) प्राथमिक अधिसूचना प्रसिध्द करणे (प्रकरण-चार, कलम 11):-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no3_a_content", "no_3_a", "display")}</p>
                    {renderNo3()}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no3_b_content", "no_3_b", "display")}</p>
                </div>

                {/* 4 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">4) प्रस्तावित क्षेत्राची संयुक्त मोजणी :-</div>
                    {renderNo4()}
                </div>

                {/* 5 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">5) संपादनाखालील जमीनीचे भुमि अभिलेख अद्‌द‌यावत करणे [भूमिसंपादन नियम (महाराष्ट्र) 2014 नियम-10(3)] :-</div>
                    {renderNo5()}
                </div>

                {/* 6 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">6) आक्षेपांची सुनावणी घेणे (प्रकरण चार, कलम 15):-</div>
                    {renderNo6()}
                </div>

                {/* 7 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">7) प्रशासकाने पुनर्वसन व पुनर्वसाहत योजना तयार करणे (प्रकरण-चार, कलम 16):-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no7_content", "no_7", "display")}</p>
                </div>

                {/* 8 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">8) अंतिम अधिसूचना व पुनर्वसन व पुनर्वसाहतीच्या संक्षिप्त गोषवा-यांची प्रसिध्दी (प्रकरण-चार, कलम 19) :-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no8_a_content", "no_8_a", "display")}</p>
                    {renderNo8()}
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no8_b_content", "no_8_b", "display")}</p>
                </div>

                {/* 9 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">9) हितसंबंधित व्यक्तींना नोटिस देणे व चौकशी (प्रकरण-चार, कलम 21 ते 23):-</div>
                    {renderNo9()}
                </div>

                {/* 10 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">10) भूसंपादनाखालील अंतिम क्षेत्राचा तपशित :-</div>
                    {renderNo10()}
                </div>

                {/* 11 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">11) मालकीहक्क तपासणी :-</div>
                    <p style={{ whiteSpace: "pre-wrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no11_content", "no_11", "display")}</p>
                </div>

                {/* 12 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">12) संपादनाखालील जमीनीचे बाजारमुल्य निर्धारित करणे (प्रकरण-चार, कलम 26) :-</div>
                    {renderNo12()}
                </div>

                {/* 13 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">13) नुकसान भरपाईची रक्कम निर्धारीत करणे (प्रकरण-चार, कलम 27)</div>
                    {renderNo13()}
                </div>

                {/* 14 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">14) दिलासा रक्कम [प्रकरण-चार, कलम 30 (1)] :-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no14_content", "no_14", "display")}</p>
                </div>

                {/* 15 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">15) अतिरिक्त घटकाची रक्कम [प्रकरण-चार, कलम 30 (3)] :-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no15_content", "no_15", "display")}</p>
                </div>

                {/* 16 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">16) भूमिधारी (भोगवटदार वर्ग-2) जमिनीबाबत :-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no16_content", "no_16", "display")}</p>
                </div>

                {/* 17 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">१७) अगोदर वसूली :-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no17_content", "no_17", "display")}</p>
                </div>

                {/* 18 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">18) अंतिम मुल्याकंन :-</div>
                    {renderNo18()}
                </div>

                {/* 19 */}
                <div className="mt-8">
                    <div className="font-bold mt-10 mb-2 text-base">19) निवाडा (प्रकरण-चार, कलम 30) :-</div>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_no19_content", "no_19", "display")}</p>
                    {renderNo19()}
                </div>

                {/* Summary */}
                <div className="mt-8">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{getContent("section_23_last_content", "no_last", "display")}</p>
                </div>

                <div className="page-break-avoid">
                    <div className="mt-8">
                        <div>दिनांक :- {formatDate(proposalData.section_23_date) || ''}</div>
                    </div>

                    <div className="p-12 m-10 flex justify-between items-end">
                        <div className="text-center mt-44 ml-auto">
                            <div className="font-bold">({laoName || ''})</div>
                            <div className="font-bold">{laoDesi || ''}</div>
                        </div>

                        {/* <div className="text-center mt-44">
                            <div className="font-bold">{usersCollector[0]?.full_name || ''}</div>
                            <div className="font-bold">{usersCollector[0]?.designation || ''}</div>
                        </div> */}
                    </div>
                </div>
            </div>

        </div>
    );

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            section_23_no12_2_b_table_ids: selected12BIds.join(","),
            section_23_no12_2_c_table_ids: selected12CIds.join(","),
            section_23_no12_2_d_table_ids: selected12DIds.join(","),
        }));
    }, [selected12BIds, selected12CIds, selected12DIds]);

    useEffect(() => {
        if (proposalData) {
            setSelected12BIds(
                proposalData.section_23_no12_2_b_table_ids
                    ? proposalData.section_23_no12_2_b_table_ids.split(",").map(String)
                    : []
            );
            setSelected12CIds(
                proposalData.section_23_no12_2_c_table_ids
                    ? proposalData.section_23_no12_2_c_table_ids.split(",").map(String)
                    : []
            );
            setSelected12DIds(
                proposalData.section_23_no12_2_d_table_ids
                    ? proposalData.section_23_no12_2_d_table_ids.split(",").map(String)
                    : []
            );
        }
    }, [proposalData]);

    const renderEditModal = () => (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-8">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-2xl font-bold text-gray-800">प्रारुप निवाडा संपादित करा</h2>
                        <button
                            onClick={() => setIsEditing(false)}
                            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                        >
                            ×
                        </button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        {/* Proposal Details */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">भूसंपादन प्रकरण तपशील</h2>
                                </div>
                            </div>

                            {/* Two-column grid */}
                            <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        भूसंपादन क्रमांक :
                                    </label>
                                    <input
                                        type="text"
                                        name="section_23_bhusampadan_no"
                                        value={formData.section_23_bhusampadan_no || proposalData.section_11_bhusampadan_no}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                        placeholder="Enter Bhusampadan No..."
                                    />
                                </div>

                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        दिनांक :
                                    </label>
                                    <input
                                        type="date"
                                        name="section_23_date"
                                        value={formatDateForInput(formData.section_23_date)}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                        placeholder="Enter Date..."
                                    />
                                </div>

                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        कार्यालयाचे नाव :
                                    </label>
                                    <input
                                        type="text"
                                        name="section_23_office_name"
                                        value={formData.section_23_office_name || proposalData.section_11_office_name}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                        placeholder="Enter Office name..."
                                    />
                                </div>

                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        शाखेचे नाव :
                                    </label>
                                    <input
                                        type="text"
                                        name="section_23_branch_name"
                                        value={formData.section_23_branch_name || proposalData.section_11_branch_name}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                        placeholder="Enter Branch name..."
                                    />
                                </div>

                            </div>
                        </div>

                        {/* Proposal detail */}
                        <div className="overflow-x-auto p-4">
                            <table className="table-auto border border-gray-700 w-full text-sm">
                                <tbody>
                                    <tr>
                                        <td className="border border-gray-700 p-2">1.</td>
                                        <td className="border border-gray-700 p-2 w-1/4">संपादन संस्था</td>
                                        <td className="border border-gray-700 p-2" colspan="2">
                                            {proposalData.acquisition_incharge_designation || ''}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-700 p-2">2.</td>
                                        <td className="border border-gray-700 p-2">भूमिसंपादनाचे प्रयोजन</td>
                                        <td className="border border-gray-700 p-2" colspan="2">
                                            {proposalData.acquisition_purpose || ''}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-700 p-2">3.</td>
                                        <td className="border border-gray-700 p-2">प्रशासकीय मान्यता आदेश क्रमांक व दिनांक</td>
                                        <td className="border border-gray-700 p-2" colspan="2">
                                            <div className="flex gap-2">
                                                <input
                                                    type="text"
                                                    name="administrative_order_no"
                                                    value={formData.administrative_order_no}
                                                    onChange={handleInputChange}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                    placeholder="Enter no..."
                                                />
                                                <input
                                                    type="date"
                                                    name="administrative_order_date"
                                                    value={formatDateForInput(formData.administrative_order_date)}
                                                    onChange={handleInputChange}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                    placeholder="Enter Date..."
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-700 p-2">4.</td>
                                        <td className="border border-gray-700 p-2">संपादन संस्थेने प्रस्ताव सादर केलेल्या पत्राचा क्रमांक व दिनांक</td>
                                        <td className="border border-gray-700 p-2" colspan="2">
                                            <div className="flex gap-2">
                                                <input
                                                    type="text"
                                                    name="acquisition_authority_no"
                                                    value={formData.acquisition_authority_no}
                                                    onChange={handleInputChange}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                    placeholder="Enter no..."
                                                />
                                                <input
                                                    type="date"
                                                    name="acquisition_authority_date"
                                                    value={formatDateForInput(formData.acquisition_authority_date)}
                                                    onChange={handleInputChange}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                    placeholder="Enter Date..."
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-700 p-2" rowSpan={4}>5.</td>
                                        <td className="border border-gray-700 p-2" rowSpan={4}>संपादनासाठी प्रस्तावित क्षेत्र</td>

                                        <td className="border border-gray-700 p-2" colspan="1">गावाचे नाव :- </td>
                                        <td className="border border-gray-700 p-2">{proposalData.village_name} ता. {proposalData.taluka_name} जि. {proposalData.dist_name}</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-700 p-2">संपादनाखालील क्षेत्राचे स्वरुप :- </td>
                                        <td className="border border-gray-700 p-2">
                                            <input
                                                type="text"
                                                name="section_23_nature_of_land"
                                                value={formData.section_23_nature_of_land}
                                                onChange={handleInputChange}
                                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                placeholder="Enter..."
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-700 p-2">संपादनाखालील क्षेत्र :-</td>
                                        <td className="border border-gray-700 p-2">{proposalData.aquired_area} {proposalData.area_unit}</td>
                                    </tr>
                                    <tr>
                                        <td className="border border-gray-700 p-2">भूधारकांची संख्या :-</td>
                                        <td className="border border-gray-700 p-2">
                                            {landData.reduce((sum, group) => sum + group.records.length, 0)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="border border-gray-700 p-2">6.</td>
                                        <td className="border border-gray-700 p-2">प्रस्ताव संपादनाच्या कार्यवाहीसाठी वर्ग केलेल्या आदेश क्रमांक व दिनांक</td>
                                        <td className="border border-gray-700 p-2" colspan="2">
                                            <div className="flex gap-2">
                                                <input
                                                    type="text"
                                                    name="propsal_proceeding_no"
                                                    value={formData.propsal_proceeding_no}
                                                    onChange={handleInputChange}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                    placeholder="Enter no..."
                                                />
                                                <input
                                                    type="date"
                                                    name="propsal_proceeding_date"
                                                    value={formatDateForInput(formData.propsal_proceeding_date)}
                                                    onChange={handleInputChange}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                    placeholder="Enter Date..."
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* 1 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-1</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        प्रस्तावना:
                                    </label>
                                    <textarea
                                        name="section_23_no1_content"
                                        value={getContent("section_23_no1_content", "no_1", "edit")}
                                        onChange={handleInputChange}
                                        rows={7}
                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                        placeholder="Enter section content..."
                                    />
                                    <p className="text-sm text-gray-500 mt-1">
                                        {formData.section_23_no1_content &&
                                            formData.section_23_no1_content.trim() !== '' &&
                                            formData.section_23_no1_content !== 'N/A' &&
                                            formData.section_23_no1_content !== 'null' &&
                                            formData.section_23_no1_content !== 'undefined' &&
                                            formData.section_23_no1_content.trim() !== (defaultContents["no_1"] || "").trim()
                                            ? "Using custom content."
                                            : "Default content is shown. Start typing to use custom content."}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* 2 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-2</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        सामाजिक आघात व सार्वजनिक प्रयोजन निर्धारित करणे (प्रकरण-दोन, कलम 4 ते 9):
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no2_content"
                                            value={getContent("section_23_no2_content", "no_2", "edit")}
                                            onChange={handleInputChange}
                                            rows={4}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                        <p className="text-sm text-gray-500 mt-1">
                                            {formData.section_23_no2_content &&
                                                formData.section_23_no2_content.trim() !== '' &&
                                                formData.section_23_no2_content !== 'N/A' &&
                                                formData.section_23_no2_content !== 'null' &&
                                                formData.section_23_no2_content !== 'undefined' &&
                                                formData.section_23_no2_content.trim() !== (defaultContents["no_2"] || "").trim()
                                                ? "Using custom content."
                                                : "Default content is shown. Start typing to use custom content."}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 3 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-3</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        प्राथमिक अधिसूचना प्रसिध्द करणे (प्रकरण-चार, कलम 11):
                                    </label>
                                    <div>
                                        <p className="font-bold text-sm">भाग १</p>
                                        <textarea
                                            name="section_23_no3_a_content"
                                            value={getContent("section_23_no3_a_content", "no_3_a", "edit")}
                                            onChange={handleInputChange}
                                            rows={3}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                    <div>
                                        <h2 className="font-bold text-sm">भाग २</h2>
                                        <textarea
                                            name="section_23_no3_b_content"
                                            value={getContent("section_23_no3_b_content", "no_3_b", "edit")}
                                            onChange={handleInputChange}
                                            rows={5}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-6 mt-2">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        कलम 11(1) खालील प्रारंभिक अधिसूचना प्रसिध्दीचा तपशिल :-
                                    </label>
                                    <div className="overflow-x-auto p-4">
                                        <table className="table-auto border border-gray-700 w-full text-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">12</td>
                                                    <td className="border border-gray-700 p-2">कलम 11(1) खालील अधिसूचनेचा मजकुर कळविण्यासाठी 12 ग्राम पातळीवरील ग्रामसभेचा किंवा नगरपालिका क्षेत्राच्या बाबतीत नगरपालिकेच्या सभेचा दिनांक</td>
                                                    <td className="border border-gray-700 p-2">
                                                        <input
                                                            type="date"
                                                            name="section_23_3_publication_no12"
                                                            value={formatDateForInput(proposalData.section_23_3_publication_no12)}
                                                            onChange={handleInputChange}
                                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        ></input>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 4 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-4</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        प्रस्तावित क्षेत्राची संयुक्त मोजणी :- :-
                                    </label>
                                    <div className="overflow-x-auto p-4">
                                        <table className="table-auto border border-gray-700 w-full text-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">1</td>
                                                    <td className="border border-gray-700 p-2">मोजणी कार्यालयाचे नाव</td>
                                                    <td className="border border-gray-700 p-2">
                                                        <input
                                                            type="text"
                                                            name="dslr_office_name"
                                                            value={proposalData.dslr_office_name}
                                                            onChange={handleInputChange}
                                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                            placeholder="Enter Office Name..."
                                                        ></input>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">4</td>
                                                    <td className="border border-gray-700 p-2">संयुक्त मोजणी अहवाल प्राप्त झाल्याचा</td>
                                                    <td className="border border-gray-700 p-2">
                                                        <input
                                                            type="date"
                                                            name="surveyor_joint_end_date"
                                                            value={formatDateForInput(formData.surveyor_joint_end_date)}
                                                            onChange={handleInputChange}
                                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                                                            placeholder="Enter Date..."
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 5 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-5</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        संपादनाखालील जमीनीचे भुमि अभिलेख अद्‌द‌यावत करणे [भूमिसंपादन नियम (महाराष्ट्र) 2014 नियम-10(3)] :-
                                    </label>
                                    <div className="overflow-x-auto p-4">
                                        <table className="table-auto border border-gray-700 w-full text-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">1</td>
                                                    <td className="border border-gray-700 p-2">संपादनाखालील जमिनीचे भूमि अभिलेख अद्‌‌‌यावत करण्यासाठी 1 संबंधीत तहसिलदार तलाठी यांना पाठविलेल्या पत्राचा क्रमांक व दिनांक</td>
                                                    <td className="border border-gray-700 p-2">
                                                        <input
                                                            type="text"
                                                            name="section_23_5_acquisition_area_letter_no"
                                                            value={proposalData.section_23_5_acquisition_area_letter_no}
                                                            onChange={handleInputChange}
                                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                            placeholder="Enter Letter No..."
                                                        ></input>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">2</td>
                                                    <td className="border border-gray-700 p-2">संपादनाखालील मिळकतीचे अभिलेख अ‌‌द्यावत करावयाच्या 2 कार्यवाही संदभर्भात तलाठी यांचेकडून कार्यपूती अनुपालन अहवाल प्राप्त झाल्याचा दिनांक</td>
                                                    <td className="border border-gray-700 p-2">
                                                        <input
                                                            type="date"
                                                            name="section_23_5_acquisition_area_compliance_report_date"
                                                            value={formatDateForInput(proposalData.section_23_5_acquisition_area_compliance_report_date)}
                                                            onChange={handleInputChange}
                                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                            placeholder="Enter Letter No..."
                                                        ></input>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 6 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-6</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        आक्षेपांची सुनावणी घेणे (प्रकरण चार, कलम 15):-
                                    </label>
                                    <div className="overflow-x-auto p-4">
                                        <table className="table-auto border border-gray-700 w-full text-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">1</td>
                                                    <td className="border border-gray-700 p-2">कलम 11(1) अन्वये अधिसूचित केलेल्या जमिनीमध्ये हितसंबंधीत असलेल्या व्यक्तीने आक्षेप हरकत दाखल करण्याचा अंतिम दिनांक (प्राथमिक अधिसूचना प्रसिध्द केल्यापासून साठ दिवसाचे आत)</td>
                                                    <td className="border border-gray-700 p-2">
                                                        {proposalData?.propsal_publication_date
                                                            ? formatDate(
                                                                (() => {
                                                                    // Parse safely from API string
                                                                    const [year, month, day] = proposalData.propsal_publication_date.split("T")[0].split("-");
                                                                    const d = new Date(year, month - 1, day); // local date (no timezone shift)
                                                                    d.setDate(d.getDate() + 60);
                                                                    return d;
                                                                })()
                                                            )
                                                            : "—"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">2</td>
                                                    <td className="border border-gray-700 p-2">प्राप्त हरकती आक्षेपांची संख्या</td>
                                                    <td className="border border-gray-700 p-2">{generalObjectionData ? generalObjectionData.length : 0}</td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">3</td>
                                                    <td className="border border-gray-700 p-2">आक्षेपांच्या सुनावणीचा दिनांक</td>
                                                    <td className="border border-gray-700 p-2">
                                                        दिनांक{" "}
                                                        {generalObjectionData && generalObjectionData.length > 0 ? (
                                                            generalObjectionData.map((item, idx) => (
                                                                <React.Fragment key={idx}>
                                                                    {formatDate(item.hearing_date)}
                                                                    <br />
                                                                </React.Fragment>
                                                            ))
                                                        ) : (
                                                            ""
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">4</td>
                                                    <td className="border border-gray-700 p-2">प्राप्त हरकती आक्षेप चौकशीसाठी भूमि अभिलेख विभाग व यंत्रणेकडे पाठविल्याचा पत्र क्रमांक व दिनांक</td>
                                                    <td className="border border-gray-700 p-2">निरंक</td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">5</td>
                                                    <td className="border border-gray-700 p-2">चौकशी अहवाल / फेरतपासणी अहवाल (नमुना-ज) यंत्रणा आणि 5 भूमि अभिलेख यांचे संयुक्त अभिप्रायासह प्राप्त झाल्याचा पत्र क्रमांक व दिनाक</td>
                                                    <td className="border border-gray-700 p-2">दिनांक  {generalObjectionData[0]?.resolution_date
                                                        ? formatDate(generalObjectionData[0].resolution_date)
                                                        : ''}</td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">6</td>
                                                    <td className="border border-gray-700 p-2">चौकशी प्रक्रियेअंती समुचित शासनाचा अंतिम निर्णय दिनांक</td>
                                                    <td className="border border-gray-700 p-2">दिनांक  {generalObjectionData[0]?.resolution_date
                                                        ? formatDate(generalObjectionData[0].resolution_date) : ''}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 7 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-7</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        प्रशासकाने पुनर्वसन व पुनर्वसाहत योजना तयार करणे (प्रकरण-बार, कलम 16):-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no7_content"
                                            value={getContent("section_23_no7_content", "no_7", "edit")}
                                            onChange={handleInputChange}
                                            rows={5}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 8 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-8</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        अंतिम अधिसूचना व पुनर्वसन व पुनर्वसाहतीच्या संक्षिप्त गोषवा-यांची प्रसिध्दी (प्रकरण-पार, कलम 19) :-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no8_a_content"
                                            value={getContent("section_23_no8_a_content", "no_8_a", "edit")}
                                            onChange={handleInputChange}
                                            rows={2}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                    <div>
                                        <textarea
                                            name="section_23_no8_b_content"
                                            value={getContent("section_23_no8_b_content", "no_8_b", "edit")}
                                            onChange={handleInputChange}
                                            rows={5}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 9 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-9</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        हितसंबंधित व्यक्तींना नोटिस देणे व चौकशी (प्रकरण-चार, कलम 21 ते 23):-
                                    </label>
                                    <div className="overflow-x-auto p-4">
                                        <table className="table-auto border border-gray-700 w-full text-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="border border-gray-700 p-2" rowSpan={2}>1</td>
                                                    <td className="border border-gray-700 p-2" rowSpan={2}>कलम 21 खालील जाहीर नोटिस प्रसिध्द केल्याचा दिनांक</td>
                                                    <td className="border border-gray-700 p-2">महाराष्ट्र शासनचे राजपत्र दिनांक
                                                        <input
                                                            type="date"
                                                            name="section_23_9_21Gazette_date"
                                                            value={formatDateForInput(proposalData.section_23_9_21Gazette_date)}
                                                            onChange={handleInputChange}
                                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                            placeholder="Enter Gazette..."
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">तसेच ठो कार्यालयामध्ये दिनांक <input
                                                        type="date"
                                                        name="section_23_9_21tehsil_office_date"
                                                        value={formatDateForInput(proposalData.section_23_9_21tehsil_office_date)}
                                                        onChange={handleInputChange}
                                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        placeholder="Enter Tehsil Office..."
                                                    />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">2</td>
                                                    <td className="border border-gray-700 p-2">हितसंबंधितांना दिलेल्या नोटीसचा दिनांक</td>
                                                    <td className="border border-gray-700 p-2"><input
                                                        type="date"
                                                        name="section_23_9_21given_notice_date"
                                                        value={formatDateForInput(proposalData.section_23_9_21given_notice_date)}
                                                        onChange={handleInputChange}
                                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        placeholder="Enter Notice Date..."
                                                    />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">3</td>
                                                    <td className="border border-gray-700 p-2">प्राप्त आक्षेप / हरकती/ निवेदनांची संख्या</td>
                                                    <td className="border border-gray-700 p-2"><input
                                                        type="text"
                                                        name="section_23_9_21objections_representations_statements_no"
                                                        value={proposalData.section_23_9_21objections_representations_statements_no}
                                                        onChange={handleInputChange}
                                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        placeholder="Enter No..."
                                                    />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">4</td>
                                                    <td className="border border-gray-700 p-2">चौकशी तारीख</td>
                                                    <td className="border border-gray-700 p-2"><input
                                                        type="date"
                                                        name="section_23_9_21inquiry_date"
                                                        value={formatDateForInput(proposalData.section_23_9_21inquiry_date)}
                                                        onChange={handleInputChange}
                                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        placeholder="Enter Inquiry Date..."
                                                    />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">5</td>
                                                    <td className="border border-gray-700 p-2">उपस्थित भुधारक / प्राधिकृत प्रतिनीधी संख्या</td>
                                                    <td className="border border-gray-700 p-2"><input
                                                        type="text"
                                                        name="section_23_9_21present_lanholders"
                                                        value={proposalData.section_23_9_21present_lanholders}
                                                        onChange={handleInputChange}
                                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        placeholder="Enter No..."
                                                    />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">6</td>
                                                    <td className="border border-gray-700 p-2">कलम 23 खाली चौकशी पूर्ण केल्याचा दिनांक</td>
                                                    <td className="border border-gray-700 p-2"><input
                                                        type="date"
                                                        name="section_23_9_21inquiry_completion_date"
                                                        value={formatDateForInput(proposalData.section_23_9_21inquiry_completion_date)}
                                                        onChange={handleInputChange}
                                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        placeholder="Enter Date..."
                                                    />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="border border-gray-700 p-2">7</td>
                                                    <td className="border border-gray-700 p-2">चौकशीअंती आक्षेपः हरकती निकाली काढल्याचा दिनांक</td>
                                                    <td className="border border-gray-700 p-2"><input
                                                        type="date"
                                                        name="section_23_9_21disposal_objections_date"
                                                        value={formatDateForInput(proposalData.section_23_9_21disposal_objections_date)}
                                                        onChange={handleInputChange}
                                                        className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                        placeholder="Enter Date..."
                                                    />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 11 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-11</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        मालकीहक्क तपासणी :-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no11_content"
                                            value={getContent("section_23_no11_content", "no_11", "edit")}
                                            onChange={handleInputChange}
                                            rows={6}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 12 */}
                        <div className="mb-6">
                            <div>
                                <div className="flex items-center justify-center mb-6">
                                    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                        <h2 className="font-bold text-lg">क्रमांक-12</h2>
                                    </div>
                                </div>

                                <div className="space-y-6">
                                    <div className="group">
                                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                                            संपादनाखालील जमीनीचे बाजारमुल्य निर्धारित करणे (प्रकरण-चार, कलम 26) :-
                                        </label>
                                        <div>
                                            <textarea
                                                name="section_23_no12_2_default_content"
                                                value={getContent("section_23_no12_2_default_content", "no_12_default", "edit")}
                                                onChange={handleInputChange}
                                                rows={7}
                                                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                placeholder="Enter section content..."
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* 12 2 */}
                                <div>
                                    {/* 12 2 A */}
                                    <div className="space-y-6">
                                        <label className="block font-semibold text-gray-700 mb-2 text-base">
                                            2) खरेदी विक्री व्यवहार पध्दतीनुसार :-
                                        </label>
                                        <p className="">अ) शेतजमिनीच्या प्राप्त खरेदी-विक्री व्यवहारांची माहिती :-</p>
                                        <div className='mt-5'>
                                            {directPurchaseData && directPurchaseData.length > 0 ? (
                                                directPurchaseData.map((group, gIndex) => (
                                                    <div key={gIndex}>
                                                        <p className="font-bold text-center">(मौजे {group.village} ता. {group.taluka} जि. {group.dist})</p>

                                                        <div className="w-full">
                                                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                                                <thead>
                                                                    <tr className="bg-gray-200">
                                                                        <th className="border border-black p-2 text-center">विभाग निवडा</th>
                                                                        <th className="border border-black p-2 text-center">अ.क्र</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                                        <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                                        <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                                        <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                                        <th className="border border-black p-2 text-center">आकार गट</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {group.records.map((record, index) => (
                                                                        <tr key={index}>
                                                                            {/* Dropdown */}
                                                                            <td className="border border-black p-2 text-center">
                                                                                <select
                                                                                    value={
                                                                                        selected12BIds.includes(record.id.toString())
                                                                                            ? "b"
                                                                                            : selected12CIds.includes(record.id.toString())
                                                                                                ? "c"
                                                                                                : selected12DIds.includes(record.id.toString())
                                                                                                    ? "d"
                                                                                                    : ""
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        const value = e.target.value;
                                                                                        const idStr = record.id.toString(); // ensure string

                                                                                        // Remove from all sections
                                                                                        setSelected12BIds(prev => prev.filter(i => i !== idStr));
                                                                                        setSelected12CIds(prev => prev.filter(i => i !== idStr));
                                                                                        setSelected12DIds(prev => prev.filter(i => i !== idStr));

                                                                                        // Add to selected section
                                                                                        if (value === "b") setSelected12BIds(prev => [...prev, idStr]);
                                                                                        if (value === "c") setSelected12CIds(prev => [...prev, idStr]);
                                                                                        if (value === "d") setSelected12DIds(prev => [...prev, idStr]);
                                                                                    }}
                                                                                    className="border border-gray-300 rounded px-2 py-1"
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    <option value="b">वगळलेले</option>
                                                                                    <option value="c">विचारात न घेतलेल्या</option>
                                                                                    <option value="d">विचारात घेतलेल्या</option>
                                                                                </select>

                                                                            </td>

                                                                            <td className="border border-black p-2 text-center">{index + 1}</td>
                                                                            <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                                            <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                                            <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                                            <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                                            <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                                            <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="text-xs mt-2"></div>
                                            )}

                                        </div>
                                    </div>

                                    {/* 12 2 B */}
                                    <div className="space-y-6">
                                        <div className="group">
                                            <h2>ब) मुल्यांकन प्रक्रियेतून वगळलेले खरेदी-विक्री व्यवहार :-</h2>
                                            <div>
                                                <textarea
                                                    name="section_23_no12_2_b_content"
                                                    value={getContent("section_23_no12_2_b_content", "no_12_2_b", "edit")}
                                                    onChange={handleInputChange}
                                                    rows={4}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                    placeholder="Enter section content..."
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-5">
                                            {directPurchaseData.map((group, gIndex) => {
                                                const filtered = group.records.filter(r => selected12BIds.includes(r.id.toString()));

                                                // If no selected records, show blank
                                                if (filtered.length === 0) return (
                                                    <div key={gIndex} className="text-xs mt-2">{''}</div>
                                                );

                                                return (
                                                    <div key={gIndex}>
                                                        <p className="font-bold text-center">
                                                            (मौजे {group.village} ता. {group.taluka} जि. {group.dist})
                                                        </p>

                                                        <div className="w-full">
                                                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                                                <thead>
                                                                    <tr className="bg-gray-200">
                                                                        <th className="border border-black p-2 text-center">अ.क्र</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                                        <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                                        <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                                        <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                                        <th className="border border-black p-2 text-center">आकार गट</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {filtered.map((record, index) => (
                                                                        <tr key={index}>
                                                                            <td className="border border-black p-2 text-center">{index + 1}</td>
                                                                            <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                                            <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                                            <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                                            <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                                            <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                                            <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* 12 2 C */}
                                    <div className="space-y-6">
                                        <div className="group">
                                            <h2>क) मुल्यांकनासाठी विचारात न घेतलेल्या खरेदी-विक्री व्यवहारांचा तपशिल :-</h2>
                                            <div>
                                                <textarea
                                                    name="section_23_no12_2_c_content"
                                                    value={getContent("section_23_no12_2_c_content", "no_12_2_c", "edit")}
                                                    onChange={handleInputChange}
                                                    rows={3}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                    placeholder="Enter section content..."
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-5">
                                            {directPurchaseData.map((group, gIndex) => {
                                                const filtered = group.records.filter(r => selected12CIds.includes(r.id.toString()));

                                                // If no selected records, show blank
                                                if (filtered.length === 0) return (
                                                    <div key={gIndex} className="text-xs mt-2">{''}</div>
                                                );

                                                return (
                                                    <div key={gIndex}>
                                                        <p className="font-bold text-center">
                                                            (मौजे {group.village} ता. {group.taluka} जि. {group.dist})
                                                        </p>

                                                        <div className="w-full">
                                                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                                                <thead>
                                                                    <tr className="bg-gray-200">
                                                                        <th className="border border-black p-2 text-center">अ.क्र</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                                        <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                                        <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                                        <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                                        <th className="border border-black p-2 text-center">आकार गट</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {filtered.map((record, index) => (
                                                                        <tr key={index}>
                                                                            <td className="border border-black p-2 text-center">{index + 1}</td>
                                                                            <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                                            <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                                            <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                                            <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                                            <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                                            <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* 12 2 D */}
                                    <div className="space-y-6">
                                        <div className="group">
                                            <h2>ड) संपादनाखालील शेतजमिनीचे मुल्यनिर्धारण :-</h2>
                                            <div>
                                                <textarea
                                                    name="section_23_no12_2_d_content"
                                                    value={getContent("section_23_no12_2_d_content", "no_12_2_d", "edit")}
                                                    onChange={handleInputChange}
                                                    rows={3}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                    placeholder="Enter section content..."
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-5">
                                            {directPurchaseData.map((group, gIndex) => {
                                                const filtered = group.records.filter(r => selected12DIds.includes(r.id.toString()));

                                                // If no selected records, show blank
                                                if (filtered.length === 0) return (
                                                    <div key={gIndex} className="text-xs mt-2">{''}</div>
                                                );

                                                return (
                                                    <div key={gIndex}>
                                                        <p className="font-bold text-center">
                                                            (मौजे {group.village} ता. {group.taluka} जि. {group.dist})
                                                        </p>

                                                        <div className="w-full">
                                                            <table className="border border-black border-collapse mb-4 text-sm w-full">
                                                                <thead>
                                                                    <tr className="bg-gray-200">
                                                                        <th className="border border-black p-2 text-center">अ.क्र</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी क्रमाक</th>
                                                                        <th className="border border-black p-2 text-center">नोंदणी दिनांक</th>
                                                                        <th className="border border-black p-2 text-center">गट क्रमांक</th>
                                                                        <th className="border border-black p-2 text-center">विक्री क्षेत्र ({proposalData.area_unit})</th>
                                                                        <th className="border border-black p-2 text-center">विक्री किमंत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रति हेक्टरी किमत (रुपये)</th>
                                                                        <th className="border border-black p-2 text-center">प्रती हेक्टरी आकार</th>
                                                                        <th className="border border-black p-2 text-center">आकार गट</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {filtered.map((record, index) => (
                                                                        <tr key={index}>
                                                                            <td className="border border-black p-2 text-center">{index + 1}</td>
                                                                            <td className="border border-black p-2 text-center">{record.registration_no}</td>
                                                                            <td className="border border-black p-2 text-center">{formatDate(record.registration_date)}</td>
                                                                            <td className="border border-black p-2 text-center">{record.survey_no}</td>
                                                                            <td className="border border-black p-2 text-center">{record.area_sold}</td>
                                                                            <td className="border border-black p-2 text-center">{record.selling_price}</td>
                                                                            <td className="border border-black p-2 text-center">{record.hectare_rate}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_rupees}</td>
                                                                            <td className="border border-black p-2 text-center">{record.size_gat}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* 12 2 e */}
                                    <div className="space-y-6">
                                        <div className="group">
                                            <div>
                                                <textarea
                                                    name="section_23_no12_2_e_content"
                                                    value={getContent("section_23_no12_2_e_content", "no_12_2_e", "edit")}
                                                    onChange={handleInputChange}
                                                    rows={2}
                                                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                                    placeholder="Enter section content..."
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 12 3 */}
                            <div className="space-y-6">
                                <div className="group">
                                    <h2>3) शिघ्रसिध्दगणक (वार्षिक बाजारमुल्य दर तक्ता) पध्दतीनूसार :-</h2>
                                    <div>
                                        <textarea
                                            name="section_23_no12_3_content"
                                            value={getContent("section_23_no12_3_content", "no_12_3", "edit")}
                                            onChange={handleInputChange}
                                            rows={4}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 12 4 */}
                            <div className="space-y-6">
                                <div className="group">
                                    <h2>4) संपादनाखालील जमीनीचे निर्धारित बाजारमुल्य :-</h2>
                                    <div>
                                        <textarea
                                            name="section_23_no12_4_content"
                                            value={getContent("section_23_no12_4_content", "no_12_4", "edit")}
                                            onChange={handleInputChange}
                                            rows={2}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 12 5 */}
                            <div className="space-y-6">
                                <div className="group">
                                    <h2>5) संपादनाखालील जमिनीचे निर्धारीत बाजारमुल्य ज्या घटकाव्दारे गुणावयाचे आहे तो घटक (गुणक):-</h2>
                                    <div>
                                        <textarea
                                            name="section_23_no12_5_content"
                                            value={getContent("section_23_no12_5_content", "no_12_5", "edit")}
                                            onChange={handleInputChange}
                                            rows={7}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 12 6 */}
                            <div className="space-y-6">
                                <div className="group">
                                    <h2>6) संपादनाखालील पोट खराब क्षेत्राचे मुल्यांकन :-</h2>
                                    <div>
                                        <textarea
                                            name="section_23_no12_6_content"
                                            value={getContent("section_23_no12_6_content", "no_12_6", "edit")}
                                            onChange={handleInputChange}
                                            rows={4}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* 13 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-13</h2>
                                </div>
                            </div>

                            {/* A */}
                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        नुकसान भरपाईची रक्कम निर्धारीत करणे (प्रकरण-चार, कलम 27) :-
                                    </label>
                                    <p>अ) संपादनाखालील क्षेत्रातील फळझाडांचे मुल्यांकन :-</p>
                                    <div>
                                        <textarea
                                            name="section_23_no13_a_1_content"
                                            value={getContent("section_23_no13_a_1_content", "no_13_a_1", "edit")}
                                            onChange={handleInputChange}
                                            rows={6}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                                <div className="group">
                                    <div>
                                        <textarea
                                            name="section_23_no13_a_2_content"
                                            value={getContent("section_23_no13_a_2_content", "no_13_a_2", "edit")}
                                            onChange={handleInputChange}
                                            rows={2}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* B */}
                            <div className="space-y-6">
                                <div className="group">
                                    <p>ब) संपादनाखालील क्षेत्रातील वनझाडांचे मुल्यांकन :-</p>
                                    <div>
                                        <textarea
                                            name="section_23_no13_b_content"
                                            value={getContent("section_23_no13_b_content", "no_13_b", "edit")}
                                            onChange={handleInputChange}
                                            rows={1}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* C */}
                            <div className="space-y-6">
                                <div className="group">
                                    <p>क) संपादनाखालील क्षेत्रातील विहीर / बोअरवेल इत्यादीचे मुल्यांकन :-</p>
                                    <div>
                                        <textarea
                                            name="section_23_no13_c_content"
                                            value={getContent("section_23_no13_c_content", "no_13_c", "edit")}
                                            onChange={handleInputChange}
                                            rows={7}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* D */}
                            <div className="space-y-6">
                                <div className="group">
                                    <p>ड) सपादनाखालील क्षेत्रातील पाईपलाईनचे मुल्यांकन :-</p>
                                    <div>
                                        <textarea
                                            name="section_23_no13_d_content"
                                            value={getContent("section_23_no13_d_content", "no_13_d", "edit")}
                                            onChange={handleInputChange}
                                            rows={7}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* E */}
                            <div className="space-y-6">
                                <div className="group">
                                    <p>इ) संपादनाखालील क्षेत्रातील बांधकामाचे मुल्यांकन :-</p>
                                    <div>
                                        <textarea
                                            name="section_23_no13_e_content"
                                            value={getContent("section_23_no13_e_content", "no_13_e", "edit")}
                                            onChange={handleInputChange}
                                            rows={7}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* 14 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-14</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        दिलासा रक्कम [प्रकरण-चार, कलम 30 (1)] :-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no14_content"
                                            value={getContent("section_23_no14_content", "no_14", "edit")}
                                            onChange={handleInputChange}
                                            rows={2}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 15 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-15</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        अतिरिक्त घटकाची रक्कम [प्रकरण-चार, कलम 30 (3)] :-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no15_content"
                                            value={getContent("section_23_no15_content", "no_15", "edit")}
                                            onChange={handleInputChange}
                                            rows={3}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 16 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-16</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        भूमिधारी (भोगवटदार वर्ग-2) जमिनीबाबत :-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no16_content"
                                            value={getContent("section_23_no16_content", "no_16", "edit")}
                                            onChange={handleInputChange}
                                            rows={3}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 17 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-17</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        अगोदर वसूली :-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no17_content"
                                            value={getContent("section_23_no17_content", "no_17", "edit")}
                                            onChange={handleInputChange}
                                            rows={1}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 19 */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">क्रमांक-19</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">
                                        निवाडा (प्रकरण-चार, कलम 30) :-
                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_no19_content"
                                            value={getContent("section_23_no19_content", "no_19", "edit")}
                                            onChange={handleInputChange}
                                            rows={5}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Summary */}
                        <div className="mb-6">
                            <div className="flex items-center justify-center mb-6">
                                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                                    <h2 className="font-bold text-lg">सारांश</h2>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="group">
                                    <label className="block font-semibold text-gray-700 mb-2 text-base">

                                    </label>
                                    <div>
                                        <textarea
                                            name="section_23_last_content"
                                            value={getContent("section_23_last_content", "no_last", "edit")}
                                            onChange={handleInputChange}
                                            rows={5}
                                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                                            placeholder="Enter section content..."
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4 pt-3 border-t border-gray-200">
                            <button
                                type="button"
                                onClick={() => setIsEditing(false)}
                                className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 transform hover:scale-105"
                            >
                                {translations[language]?.Cancel}
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg"
                            >
                                {loading && (
                                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                                )}
                                <span>{loading ? translations[language]?.Saving : translations[language]?.Save}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div >
        </div >
    );

    // PDF
    const handlePrintView = () => {
        // Create a new window with print-optimized content
        const printWindow = window.open('', '_blank');

        if (!printWindow) {
            alert('Please allow popups to use the print feature.');
            return;
        }

        // Get the content
        const content = notificationContentRef.current.innerHTML;

        // Create HTML for print window
        const printHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>प्रारुप निवाडा (कलम-23)</title>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }
        
        * {
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Noto Sans Devanagari', Arial, sans-serif;
          font-size: 14px;
          line-height: 1.4;
          color: black;
          background: white;
          margin: 0;
          padding: 0;
        }
        
        .print-container {
          width: 100%;
          max-width: none;
          background: white;
        }
        
        .pr-3{
          padding-right:1rem;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 1rem;
          page-break-inside: auto !important;
        }
  
        thead {
            display: table-header-group;
        }

        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }

        td, th {
            border: 1px solid black;
            padding: 8px;
            font-size: 14px;
            page-break-inside: avoid;
        }
        
        h1, h2, h3, h4, h5, h6 {
          margin: 1rem 0 0.5rem 0;
          page-break-after: avoid;
          font-weight: bold;
        }
        
        p {
          margin: 0.5rem 0;
          text-align: justify;
          line-height: 1.5;
          orphans: 3;
          widows: 3;
        }

       .text-xs { font-size: 0.75rem; }   /* 12px */
.text-sm { font-size: 0.875rem; }  /* 14px */
.text-base { font-size: 1rem; }    /* 16px */
.text-lg { font-size: 1.125rem; }  /* 18px */
.text-xl { font-size: 1.25rem; }   /* 20px */
.text-2xl { font-size: 1.5rem; font-weight: 700; } /* 24px Bold */
        .flex { display: flex; }
        .justify-between { justify-content: space-between; }
        .items-end { align-items: flex-end; }
        .text-center { text-align: center; }
        .mt-44 { margin-top: 1rem; float:right }
        .m-10{ margin: 5rem; }
        .text-right { text-align: right; }
        .ml-auto{ margin-left: auto; }
        .font-bold { font-weight: bold; }
        .font-semibold { font-weight: 600;}
        .underline { text-decoration: underline; }
        .indent-8 { text-indent: 2rem; }
        .mt-8 { margin-top: 2rem; }
        .mb-2 { margin-bottom: 0.5rem; }
        .mb-6 { margin-bottom: 1.5rem; }
        .flex { display: flex; }
        .justify-center{ justify-content: center; }

        .w-auto{
          width:auto;
          max-width: 28rem;
        }

        .space-y-4 > * + * {
          margin-top: 1rem;
        }
        
        .mx-auto{
          margin-left: auto;
          margin-right: auto;
          width : 8%;
          margin-bottom:2px;
        }

        .border-black{
          border : 1.5px solid black;
        }

        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          
          .page-break {
            page-break-after: always;
          }
          
          table {
            page-break-inside: avoid;
          }
          
          tr {
            page-break-inside: avoid;
          }
          
          table {
            page-break-inside: auto !important;
          }

          thead {
            display: table-header-group; /* repeat header on each page */
          }

          tfoot {
            display: table-footer-group;
          }

          tr {
            page-break-inside: avoid; /* avoid breaking inside a single row */
            page-break-after: auto;
          }

          td, th {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          .page-break-avoid {
            page-break-inside: avoid;
            break-inside: avoid;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-container">
        ${content}
      </div>
      <script>
        window.onload = function() {
          window.focus();
          window.print();
        };
      </script>
    </body>
    </html>
  `;

        printWindow.document.write(printHTML);
        printWindow.document.close();
    };

    const handleUploadedFile = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        // ✅ open uploaded file in signature modal
        setPdfForSigning(file);
        setShowSignaturePad(true);
    };

    // Word
    const handleDownloadWord = () => {
        try {
            if (!notificationContentRef.current) {
                alert("❌ No content available to download.");
                return;
            }

            // Get the same content you use for print
            const content = notificationContentRef.current.innerHTML;

            // Build full HTML like print view but for Word export
            const wordHTML = `
    <!DOCTYPE html>
    <html xmlns:o='urn:schemas-microsoft-com:office:office'
          xmlns:w='urn:schemas-microsoft-com:office:word'
          xmlns='http://www.w3.org/TR/REC-html40'>
    <head>
      <meta charset="UTF-8">
      <title>प्रारुप निवाडा (कलम-23)</title>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }

        * {
          box-sizing: border-box;
        }

        body {
          font-family: 'Noto Sans Devanagari', Arial, sans-serif;
          font-size: 12px;
          line-height: 1.4;
          color: black;
          background: white;
          margin: 0;
          padding: 0;
        }

        .print-container {
          width: 100%;
          background: white;
        }

        .pr-3{ padding-right:1rem; }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 1rem;
        }
        td, th {
          border: 1px solid black;
          padding: 8px;
          font-size: 11px;
        }
        h1, h2, h3, h4, h5, h6 {
          margin: 1rem 0 0.5rem 0;
          font-weight: bold;
        }
        p {
          margin: 0.5rem 0;
          text-align: justify;
          line-height: 1.5;
        }
        .text-2xl { font-size: 1.8rem; }
        .flex { display: flex; }
        .justify-between { justify-content: space-between; }
        .items-end { align-items: flex-end; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .underline { text-decoration: underline; }
        .indent-8 { text-indent: 2rem; }
        .mt-8 { margin-top: 2rem; }
        .mb-6 { margin-bottom: 1.5rem; }
        .border-black{ border : 1.5px solid black; }
      </style>
    </head>
    <body>
      <div class="print-container">
        ${content}
      </div>
    </body>
    </html>`;

            // Create Blob for Word
            const blob = new Blob([wordHTML], { type: "application/msword" });

            // Create download link
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Section23.doc";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Error generating Word file:", err);
            alert("❌ Failed to generate Word file.");
        }
    };

    // All Default Contents
    const defaultContents = {
        no_1: `प्रस्तुत प्रकरणातील भुसंपादनाची कार्यवाही पूर्ण करण्यासाठी मा. जिल्हाधिकारी बुलढाणा (समुचित शासन) यांनी त्यांचे आदेश ${proposalData.propsal_proceeding_no} दि.${formatDate(proposalData.propsal_proceeding_date || new Date())} अन्वये जिल्हाधिकारी कर्तव्ये पार पाडण्यासाठी ${laoDesi} (इमारत व दळणवळण) बुलढाणा यांना भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारर्दशकतेचा हक्क अधिनियम 2013 चे कलम 3 (ग) खालील तरतुदीनुसार प्राधिकृत केलेले आहे. त्यानुसार प्राप्त संवैधानिक प्राधिकारानुसार प्राथमिक चौकशी अंती व्यापक लोकहितास्तव भूमि संपादनाची आवश्यकता असल्याची खात्री झाल्यानंतर, प्रस्तुत प्रकरणात भूमिसंपादन, पुनर्वसन व पुनःस्र्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 मधील तरतूदीनूसार पुढीलप्रमाणे कार्यवाही करण्यात आलेली आहे.`,

        no_2: `भारत सरकार, पर्यावरण व वन मंत्रालय, नवी दिल्ली यांचे पत्र क्रमांक J-12011/22/2007-1A.1, दि. 11.05.2007 अन्वये जिगांव या मोठ्या सिंचन प्रकल्पाला पर्यावरण विषयक सर्वेक्षण मंजूरी प्रदान करण्यात आलेली असल्याने भूमीसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 6 पोटकलम 2 मधील परंतुकानुसार सामाजिक आघात निधोरणाशी संबंधित असणा-या तरतुदी या प्रकल्पाला लागु होणार नाहीत.`,

        no_3_a: `प्रस्तुत प्रकरणात भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम, 2013 चे कलम 11 च्या पोट-कलम (1) अन्वये मा. जिल्हाधिकारी बुलढाणा (समुचित शासन) यांचेकडुन खालीलप्रमाणे प्रारंभिक अधिसूचना काढण्यात आलेली आहे.`,

        no_3_b: `प्रस्तुत प्रकरणात भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 11 च्या पोट कलम (1) अन्वये वरीलप्रमाणे प्रारंभिक अधिसूचना काढण्यात आली. भूमिसंपादन, पुनर्वसन व पुनःस्र्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क (महाराष्ट्र) नियम 2014 चे नियम 10 च्या पोट-नियम (2) अन्वये सदर अधिसूचना प्रसिध्दीचा अंतिम दिनांक ${proposalData.section_23_3_publication_no12 || ''} हा कलम 11 च्या पोट-कलम (1) खालील प्रारंभिक अधिसूचनेचा प्रसिध्दी दिनांक मानण्यात आला आहे.`,

        no_7: `शासन पत्र क्रमांक- आरपीए-409/प्र के 132/2-1, दि. 22/07/2009 अन्वये जिगाव पाटबंधारे मोठा प्रकल्प हा राज्य शासनाचा प्रकल्प असुन जलसंपदा विभागामार्फत उभारण्यात येत आहे. या प्रकल्पाची प्रकल्पसंस्था जलसंपदा विभाग असून या प्रकल्पामुळे बाधित होणा-या प्रकल्पग्रस्तांचे पुनर्वसन महाराष्ट्र प्रकल्पबाधित व्यक्तीचे पुनर्वसन अधिनियम, 1999 व केंद्र शासनाचे राष्ट्रीय पुनर्वसन धोरण 2007 नुसार होत असल्याने भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम, 2013 नुसार पुनर्वसन व पुनर्स्थापना योजना लागू होणार नाही असे कळविण्यात आले आहे.`,

        no_8_a: `भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना उचित भरपाई मिळण्याचा आणि पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 19 च्या पोट-कलम (1) अन्वये मा. जिल्हाधिकारी बुलढाणा (समुचित शासन) यांचेकडून खालीलप्रमाणे घोषण करण्यात आलेली आहे.`,

        no_8_b: `प्रस्तुत प्रकरणात भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 19 च्या पोट कलम (1) अन्वये वरीलप्रमाणे अधिसूचना काढण्यात आली. भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क (महाराष्ट्र) नियम 2014 चे नियम 14 च्या पोट-नियम (3) अन्वये सदर अधिसूचना प्रसिध्द करण्याचा अतिम दिनांक ${formatDate(proposalData.section19_rehabilitation_rights_notice)} हा कलम 19 च्या पोट-कलम (1) खालील घोषणेचा प्रसिध्दी दिनांक मानण्यात आला आहे.`,

        // no_11: `भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे प्रकरण एक मधील कलम 3 (र) मध्ये "जमिन मालक" या संजेची व्याख्या स्पष्ट करण्यात आली आहे. कलम ३ (२) (एक) मध्ये असे नमुद करण्यात आले आहे की, जमिन मालक या संजेत "जिचे नाव, संबंधित प्राधिकारणाच्या अभिलेखांमध्ये जमिनीचा किंवा इमारतीचा किंवा त्याच्या भागाचा मालक म्हणून नोंदविलेले आहे अशी कोणतीही व्यक्ती" अश्या कोणत्याही व्यक्तीचा समावेश होतो. सदर कायदेशीर तरतूद विचारात घेऊन संपादनाखालील जमिनीच्या मालकीहक्काबाबत अधिकार अभिलेख (गाव नमुना नं. 7/12) मधील भोगवटदार सदरी असलेल्या नांदी तपासून खात्री करण्यात आली आहे.`,

        no_11: `भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा आणि पारदर्शकतेचा हक्क अधिनियम, 2013 चे प्रकरण एक मधिल कलम 3 (र) मध्ये  “जमिन मालक”   या संज्ञेची व्याख्या स्पष्ट करण्यात आली आहे. कलम 3 (र) (एक) मध्ये असे नमुद करण्यात आले आहे की, “जमिन मालक”   या संज्ञेत पुढीलपैकी कोणत्याही व्यक्तीचा समावेश होतो. (एक) जिचे नाव, संबंधित प्राधिकारणाच्या अभिलेखांमध्ये जमिनीचा किंवा इमारतीचा किंवा त्याच्या भागाचा मालक म्हणून नोंदविलेले आहे अशी कोणतीही व्यक्ती. सदर कायदेशीर तरतूद विचारात घेऊन संपादनाखालील जमिनीच्या मालकीहक्काबाबत ग्राम महसूल अधिकारी यांच्याकडून प्राप्त अधिकार अभिलेखामधील (गाव नमुना नं.7/12) भोगवटदार सदर असलेल्या नोंदी तपासून खात्री करण्यात आली आहे.
        महाराष्ट्र जमिन महसूल अधिनियम 1966 चे कलम 157 नुसार “अधिकार अभिलेखातील नोंद आणि फेरफार नोंदवहीतील प्रमाणित नोंद ही, एतदविरुध्द सिध्द करण्यात येईपर्यंत किंवा त्याबद्दल नविन नोंद कायदेशीररित्या दाखल करण्यात येईपर्यंत खरी असल्याचे गृहित धरण्यात येईल.” 
        सदर तरतूदीनुसार ग्राम महसूल अधिकारी / तलाठी यांच्याकडून प्राप्त अधिकार अभिलेखाच्या आधारेच भोगवटदार सदरी असलेल्या भूधारकांची नावे प्रमाण मानून निवाडयात समाविष्ट करण्यात आलेले आहेत.`,

        no_12_default: `प्रस्तुत प्रकरणात कलम 11 च्या पोट कलम (1) खालील प्रारंभिक अधिसूचना प्रसिध्दीचा अंतिम दिनांक ${formatDate(proposalData.section19_rehabilitation_rights_notice)} मानण्यात आलेला आहे. सबब कलम 26 (1) खालील तरतूदीनूसार या दिनांकापासून मागिल तीन वर्षातील संपादनाखालील जमीनीशी अनुरुप खरेदी-विक्री व्यवहार विचारात घेणे क्रमप्राप्त आहे. त्याकरीता दुय्यम निबंधक नांदुरा जि. बुलढाणा यांचेकडून दिनांक ${formatDate(proposalData.direct_purchase_to_date)} ते ${formatDate(proposalData.direct_purchase_from_date)} या कालावधीतील मौजे येरळी ता.नांदुरा जि. बुलढाणा येथील शेतजमिनीच्या खरेदी-विक्री व्यवहारांची माहिती मागविण्यात आलेली आहे. दुय्यम निबंधक नांदुरा त्यांचे पत्र जा.क्र./सूची क्र.2प्रत/152/2024 दिनांक 01.07.2024 अन्वये उक्त कालावधीतील मौजे येरळी येथील एकुण ${directPurchaseData.length} (सहा) खरेदी-विक्री व्यवहारांची माहिती प्राप्त झालेली आहे. त्या माहितीचा तपशिल खालीलप्रमाणे आहे.`,

        no_12_2_b: `शासन परिपत्रक, महसूल व वन विभाग क्रमांक संकीर्ण-2023/प्र.क्र. 02/अ-2, दिनांक 24.01.2023 चे परिच्छेद 3 अन्वये प्राप्त निर्देशानुसार सदर प्रकरणातील भूसंपादनाची कलम 11 (1) खालील अधिसूचना निर्गमित झाल्याच्या दिनांकापासून (दिनांक 29.05.2024) मागील एक वर्षातील अर्थात दिनांक 28.05.2023 ते 28.05.2024 या कालावधीतील व्यवहार मुल्यांकन प्रक्रियेतून वगळावयाचे आहेत, या कालावधीमधील व्यवहाराचा तपशिल पुढीलप्रमाणे...`,

        no_12_2_c: `मौजे येरळी येथिल प्राप्त झालेले व्यवहार हे खरेदीखताने हस्तांतरीत झालेले असल्याने मूल्यनिर्धारणासाठी उपयोगी ठरतात. मौजे येरळी येथिल प्राप्त एकुण प्राप्त 6 व्यवहारांपैकी अ.क्र. 1, 2 व 4 वरील एकुण 3 व्यवहार हे आकारमान गट 4 चे असल्याने मुल्यनिर्धारणासाठी विचारात घेता येत नाही.`,

        no_12_2_d: `एकुण प्राप्त झालेल्या 6 खरेदी-विक्री व्यवहारांमधून वरीलप्रमाणे परिच्छेद (ब) व (क) मध्ये नमुद अनुक्रमे 2+3 असे एकुण 5 व्यवहार वगळता, उर्वरित 1 व्यवहार शिल्लक असल्याने तो विचार क्षेत्रात अंतर्भुत करण्यात आला आहे. या व्यवहाराचा तपशिल खालीलप्रमाणे आहे.`,

        no_12_2_e: `भूमिसंपादन, पूनर्वसन व पुनस्र्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 26 (1) खालील तरतूदीनुसार संपादनाखालील शेतजमिनीची किंमत रु. 804500.00 प्रति हेक्टरी निर्धारीत करण्यात येत आहे.`,

        no_12_3: `प्रस्तुत प्रकरणात कलम 11 च्या पोटकलम (1) खालील प्रारंभिक अधिसूचना प्रसिध्दीचा अंतिम दिनांक 29.05.2024 मानण्यात आलेला आहे. सबब कलम 26 (1) खालील तरतूदीनूसार संपादनाखालील शेतजमिनीच्या मुल्यांकनासाठी 2024-2025 या वर्षाचे बाजारमुल्य दर (प्रती हेक्टरी) विचारात घेण्यात आले आहेत. मौजे येरळी ता. नांदुरा जि. बुलढाणा या गावाचा समावेश विभाग क्र.3 मध्ये असून सन 2024-2025 या वर्षाच्या बाजारमूल्य दरपत्रकानुसार जिरायत शेतजमिनीचा बाजारमूल्य दर खालीलप्रमाणे आहे.`,

        no_12_4: `उक्त परिच्छेद 12 मधिल उप-परिच्छेद (2) व (3) नुसार मौजे येरळी ता. नांदुरा येथिल संपादनाखालील शेतजमिनीच्या प्रति हेक्टरी दराचा तुलनात्मक तक्ता खालीलप्रमाणे आहे.`,

        no_12_5: `भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 26 (2) मध्ये जमीनीचे बाजारमुल्य ज्या घटकाव्दारे गुणावयाचे आहे त्या घटकाची (गुणकाची) तरतुद करण्यात आली आहे. तसेच कलम 30 च्या पोटकलम (2) नुसार पहिल्या अधिसूचनेमध्ये संपादनाखालील जमिनीच्या बाजारमुल्य निर्धारणाची रित विनिर्दिष्ट करण्यात आलेली आहे.
        महाराष्ट्र शासन राजपत्र असाधारण भाग-4 अ, मध्ये दिनांक 26 मे, 2015 रोजी महसूल व वन विभागाची अधिसूचना दिनांक 26 मे, 2015 प्रसिध्द करण्यात आलेली आहे. त्यानुसार यासंदर्भात काढण्यात आलेल्या इतर सर्व शासकीय अधिसूचनांचे अधिक्रमण करुन त्यासोबत जोडलेल्या अनुसूचिच्या स्तंभ (2) मध्ये विनिर्दिष्ट केलेल्या क्षेत्रासाठी ज्या घटकांव्दारे बाजारमुल्य गुणले जाणार आहे तो घटक (गुणक) नव्याने निर्धारीत करण्यात आलेला आहे.
        भूसंपादन अधिनियम 2013 चे कलम 3 (यू) नूसार "बाजारमुल्य" म्हणजे कलम 26 नुसार निर्धारीत केलेले जमिनीचे मुल्य होय. त्यामुळे जमिनीच्या बाजार मुल्यात कलम 26 (1) व 26 (2) या दोन्ही तरतूदर्दीचा समावेश होतो कलम 26 मधिल परंतुकामध्ये बाजारमुल्य निर्धारित करण्याची तारीख ही ज्या तारखेस कलम 11 अन्वये अधिसूचना काढण्यात आली ती तारीख असेल असे नमुद करण्यात आले आहे. त्यानुसार प्रस्तुत प्रकरणातील कलम 11 खालील अधिसूचनेचा दिनांक 29.05.2024 हा कलम 26 (2) तरतुदीनुसार गुणक ठरवितांना सुध्दा मुल्यांकन दिनांक म्हणून ग्राहय धरणे कायदेशीर तरतूदीशी सुसंगत ठरते. संपादनाखालील क्षेत्राचा समावेश अनुसूचिच्या अनुक्रमांक (3) मध्ये नमुद केलेल्या क्षेत्रात असल्याने, या जमिनीच्या निर्धारीत बाजारमुल्यावर 02.00 (दोन) या गुणकाने वाढ देण्यात आली आहे.`,

        no_12_6: `महाराष्ट्र शासन महसूल व वन विभाग शासन निर्णय क्रमांक-संकीर्ण 09/2017/ प्रक्र. 148/अ-2/2018 दिनांक 05/09/2018 मधील तरतुदीनुसार संपादनाखालील क्षेत्रात समाविष्ट असलेल्या पोटखराब जमिनीचे मुल्यांकन तुलनात्मक जमिनीच्या मुल्यांकनाच्या 100% एवढे निर्धारीत करावयाचे आहे. प्रस्तुत प्रकरणात संपादनाखालील क्षेत्रात पोटखराब क्षेत्राचा समावेश नसल्याने पोटखराब क्षेत्राचे मुल्य निर्धारित करण्याचा प्रश्न उद्भवत नाही.`,

        no_13_a_1: `प्रस्तुत प्रकरणातील संयुक्त मोजणी अहवालामध्ये फळझाडांचा समावेश आहे. जिल्हा अधिक्षक कृषी अधिकारी बुलढाणा यांचे पत्र जा.क्र. फलो/फळझाडे मुल्यांकन/5202/2024 दिनांक 12.08.2024 अन्वये संपादनाखालील क्षेत्रावरील फळझाडांचा मुल्यांकन अहवाल प्राप्त झालेला आहे. त्यानुसार फळझाडांचे मुल्यांकन खालीलप्रमाणे. भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 27 खालील तरतुदीनुसार संपादनाखालील जमिनीवरील फळझाडांचे मुल्यांकनाची रक्कम संबंधितास देय ठरविण्यात आली आहे. व या रक्कमेचा समावेश प्रपत्र-ई मध्ये एकुण भरपाईच्या रक्कमेत करण्यात आलेला आहे.`,

        no_13_a_2: `संयुक्त मोजणी अहवालात पेरुची 232 झाडे नमुद आहेत तथापी कृषी अधिकारी, ता.कृ.अ. नांदुरा यांच्या दिनांक 18.07.2024 रोजीच्या पंचनामा व मोका पाहणी नुसार प्रत्यक्षात मोक्यावर पेरुची 227 च झाडे आढळून आलेली आहेत.`,

        no_13_b: `प्रस्तुत प्रकरणातील संपादन क्षेत्रात वन झाडे नसल्याने वनझाडांचे मुल्यांकन निरंक आहे.`,

        no_13_c: `प्रस्तुत प्रकरणातील संयुक्त मोजणी अहवालामध्ये बोअरवेलचा समावेश आहे. "कार्यकारी अभियंता, सार्वजनीक बांधकाम विभाग, खामगांव" यांचे पत्र जावक क्र.4676/प्रशा 3/2024 दिनांक 07.08.2024 व पत्र जावक क्र.4678/प्रशा 3/2024 दिनांक 13.09.2024 रोजीच्या पत्रानुसार संपादनाखालील क्षेत्रावरील बोअरवेलचा मुल्यांकन अहवाल प्राप्त झालेला आहे. त्यानुसार या घटकाचे मुल्यांकन खालीलप्रमाणे.
        भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 27 मधील तरतुदीनुसार खालील प्रमाणे संयुक्त मोजणी अहवालानुसार संपादनाखालील जमीनीवरील बोअरवेल चे मुल्याकंनाची रक्कम संबंधितास देय ठरविण्यात आलेली आहे. व या रक्कमेचा समावेश प्रपत्र-ई मध्ये एकुण भरपाईच्या रक्कमेत करण्यात आलेला आहे.
        सदर मुल्यांकन देय ठरवितांना संयुक्त मोजणी अहवाल आधारभूत मानण्यात आला आहे. सदर मुल्यांकनाबाबत भविष्यात काही दोष/त्रुटी आढळून आल्यास त्यास संबंधित यंत्रणा जबाबदार राहील.`,

        no_13_d: `प्रस्तुत प्रकरणातील संयुक्त मोजणी अहवालामध्ये पाईपलाईनचा समावेश आहे. कार्यकारी अभियंता, सार्वजनीक बांधकाम विभाग, खामगांव यांचे पत्र जावक क्र.4676/प्रथा 3/2024 दिनांक 07.08.2024 व पत्र जावक क्र.4678/प्रशा 3/2024 दिनांक 13.09.2024 रोजीच्या पत्रानुसार संपादनाखालील क्षेत्रावरील पाईपलाईनचा मुल्यांकन अहवाल प्राप्त झालेला आहे. त्यानुसार या घटकाचे मुल्यांकन खालीलप्रमाणे.
        भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 27 मधील तरतुदीनुसार खालील प्रमाणे संयुक्त मोजणी अहवालानुसार संपादनाखालील जमीनीवरील पाईपलाईनच्या मुल्याकंनाची रक्कम संबंधितास देय ठरविण्यात आलेली आहे. व या रक्कमेचा समावेश प्रपत्र-ई मध्ये एकुण भरपाईच्या रक्कमेत करण्यात आलेला आहे.`,

        no_13_e: `प्रस्तुत प्रकरणातील संयुक्त मोजणी अहवालामध्ये बांधकामाचा समावेश आहे. कार्यकारी अभियंता, सार्वजनीक बांधकाम विभाग, खामगांव यांचे पत्र जावक क्र.4676/प्रशा 3/2024 दिनांक 07.08.2024 व पत्र जावक क्र. 4678/प्रशा 3/2024 दिनांक 13.09.2024 रोजीच्या पत्रानुसार संपादनाखालील क्षेत्रावरील बांधकामाचा मुल्यांकन अहवाल प्राप्त झालेला आहे. त्यानुसार या घटकाचे मुल्यांकन खालीलप्रमाणे.
        भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 27 मधील तरतुदीनुसार खालील प्रमाणे संयुक्त मोजणी अहवालानुसार संपादनाखालील जमीनीवरील बांधकामाचे मुल्याकंनाची रक्कम संबंधितास देय ठरविण्यात आलेली आहे. व या रक्कमेचा समावेश प्रपत्र-ई मध्ये एकुण भरपाईच्या रक्कमेत करण्यात आलेला आहे. सदर मुल्यांकन देय ठरवितांना संयुक्त मोजणी अहवाल आधारभूत मानण्यात आला आहे. सदर मुल्यांकनाबाबत भविष्यात काही दोष । त्रुटी आढळुन आल्यास त्यास संबंधित यंत्रणा जबाबदार राहील.`,

        no_14: `भुमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 30 (1) खालील तरतुदीनुसार संपादनाखालील 'जमिनीच्या एकुण भरपाई रकमेवर' 100% दिलासा रक्कम देय ठरविण्यात आली आहे.`,

        no_15: `भूमीसंपादन, पुनर्वसन व पुर्नस्थापना करतांना वाजवी भरपाई व पारदर्शकतेचा हक्क अधिनियम 2013 चे कलम 30 (3) खालील तरतुदीनुसार कलम 26 अन्वये निर्धारीत केलेल्या संपादनाखालील जमिनीच्या बाजारमुल्यावर द.सा.द.शे.12 % या दराने दिनांक 29.05.2024 ते 08.11.2024 (एकुण 163 दिवस) या कालावधीकरीता अतिरीक्त घटकाची परिगणना करण्यात आली आहे.`,

        no_16: `या भूसंपादन प्रकरणामध्ये भोगवटदार वर्ग-2 या जमिनीच्या सत्ता प्रकारातील भुधारकांची जमिन संपादनाखाली नसल्यामुळे संपादनाखालील जमिनीच्या कलम 26 (1) नुसार निर्धारीत केलेल्या बाजारमुल्यातून 10% अनर्जित रक्कम वा नजराणा रक्कम वसूल करण्यात आलेली नाही.`,

        no_17: `या भूसंपादन प्रकरणामध्ये समावेश असलेल्या भूधारकास अग्रिम मोबदला प्रदान करण्यात आलेला नाही.`,

        no_19: `भूमिसंपादन, पुनर्वसन व पुनःस्र्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क (महाराष्ट्र) नियम 2014 मधील नियम 18 च्या पोटनियम, 2 व 4 खालील तरतूदीनुसार मी, अजिंक्य गोडगे, उपजिल्हाधिकारी भूसंपादन (इमारत व दळणवळण), जिल्हाधिकारी कार्यालय, बुलढाणा, भूमिसंपादन, पुनर्वसन व पुनःस्र्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे प्रकरण-चार मधील कलम 23 खालील तरतुदीनुसार खालीलप्रमाणे प्रारुप निवाडा तयार करुन 'मा. जिल्हाधिकारी बुलढाणा' यांचे पूर्व मान्यतेस सादर करित आहे.`,

        no_last: `प्रस्तुत प्रकरणातील भूसंपादनाचा संपूर्ण मोबदला तसेच भूमिसंपादन, पुनर्वसन व पुनःस्थापना करतांना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम 2013 चे प्रकरण 8 मधील कलम 51 खालील तरतुदीनुसार स्थापित भूमिसंपादन, पुनर्वसन व पुनःस्थापना प्राधिकरणाच्या निर्णयानुसार तसेच मा.उच्च न्यायालयाचे अपीलातील निर्णयानुसार देय होणारा वाढीव मोबदला (अनुषंगीक व्याजासह) संबंधीत भूधारकांना अदा करण्यासाठी संपूर्ण निधी प्राथम्याने उपलब्ध करुन देण्याची सर्वस्वी जबाबदारी भूसंपादन संस्था या नात्याने कार्यकारी अभियंता, सार्वजनिक बांधकाम विभाग, खामगांव गांधी राहील.`
    };

    // 2. Generic Helper Function
    const getContent = (fieldName, key, mode = "display") => {
        const userContent = formData[fieldName];
        const defaultContent = defaultContents[key] || "";
        const invalidValues = ["", "N/A", "null", "undefined"];

        if (typeof userContent === "string") {
            const trimmed = userContent.trim();

            if (mode === "edit") {
                // Edit mode → always show formData if valid
                return !invalidValues.includes(trimmed)
                    ? userContent
                        .replace(/\\n/g, "\n")
                        .replace(/\\t/g, "\t")
                    : defaultContent;
            } else {
                // Display mode → show formData only if valid AND not same as default
                return !invalidValues.includes(trimmed) && trimmed !== defaultContent.trim()
                    ? userContent
                        .replace(/\\n/g, "\n")
                        .replace(/\\t/g, "\t")
                    : defaultContent;
            }
        }

        // Fallback → if userContent is not a string
        return defaultContent;
    };

    if (ProposalLoading) {
        return (
            <div className="p-6 max-w-7xl mx-auto">
                <div className="flex justify-center items-center h-80">
                    <div className="text-center animate-float">
                        <div className="inline-flex relative">
                            <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                            <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                            </div>
                        </div>
                        <p className="text-gray-400 mt-4">{currentType === 'prarupNivada' ? 'प्रारुप' : 'अंतिम'} निवाडा लोड होते आहे...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="bg-gray-50 min-h-screen">
                <div className="max-w-7xl mx-auto p-4">
                    {/* Header */}
                    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    {/* Approval Status Display */}
                                {(userRole === ROLES.LAO || userRole === ROLES.SAMANVAY || userRole === ROLES.COLLECTOR) && (
                                    <>
                                        {approval !== null && (
                                            <div className="my-2 flex items-center text-lg font-semibold">
                                                {approval === true || approval === 1 ? (
                                                    <div className="flex items-center text-green-600 space-x-2">
                                                        <CheckCircle className="w-7 h-7" />
                                                        <span>माननीय जिल्हाधिकारी यांनी मंजूर केले आहे</span>
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center text-red-600 space-x-2 mt-3">
                                                        <XCircle className="w-7 h-7" />
                                                        <span>माननीय जिल्हाधिकारी यांनी नामंजूर केले आहे</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}
                        <div className="flex justify-between items-center">
                        
                            <div className="flex gap-3">
                                <button
                                    onClick={handleDownloadWord}
                                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
                                >
                                    Download Word
                                </button>

                                <button
                                    type="button"
                                    onClick={handlePrintView}
                                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
                                >
                                    <span>{translations[language]?.Print}</span>
                                </button>

                                {userRole === ROLES.DATA_ENTRY && (
                                    <>
                                        <input
                                            type="file"
                                            id="dataEntryFileInput"
                                            onChange={handleDataEntryFileSelect}
                                            className="hidden"
                                            accept=".pdf,.doc,.docx"
                                            disabled={uploadingDataEntry}
                                        />
                                        <label
                                            htmlFor="dataEntryFileInput"
                                            className={`px-6 py-2 rounded-lg flex items-center space-x-2 cursor-pointer ${uploadingDataEntry
                                                ? 'bg-gray-400 cursor-not-allowed'
                                                : 'bg-blue-600 text-white hover:bg-blue-700'
                                                }`}
                                        >
                                            {uploadingDataEntry ? (
                                                <>
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                                    <span>Uploading...</span>
                                                </>
                                            ) : (
                                                <span>Upload Document</span>
                                            )}
                                        </label>
                                        {/* ✅ View button — shown only after upload succeeds */}
                                        {uploadedDataEntryFileUrl && (
                                            <button
                                                type="button"
                                                onClick={() => handleViewDocument(uploadedDataEntryFileUrl)}
                                                className="px-5 py-3 text-sm bg-blue-600 hover:bg-blue-700 text-white rounded-xl flex items-center space-x-2 shadow-md"
                                                title="View Uploaded Document"
                                            >
                                                <Eye className="h-5 w-5" />
                                                <span>View</span>
                                            </button>
                                        )}
                                    </>
                                )}

                                {currentType === 'prarupNivada' && (
                                    <>
                                        {/* Data Entry */}
                                        {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (
                                            <button
                                                type="button"
                                                onClick={() => setIsEditing(true)}
                                                disabled={collectorEditCompletedbuttonDisabled && (approval === true || approval === 1)}
                                                className={`px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors 
                                            ${collectorEditCompletedbuttonDisabled && (approval === true || approval === 1)
                                                        ? 'bg-gray-400 text-white cursor-not-allowed'
                                                        : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                                            >
                                                <span>{translations[language]?.Edit}</span>
                                            </button>
                                        )}
                                    </>
                                )}
                                
                            </div>

                            {/* Action Buttons */}
                            <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
                                
                                {/* Send Back to LAO */}
                                {/* {userRole === ROLES.SAMANVAY && (
                                    <button
                                        onClick={() => {
                                            setTrackingRole('Back_LAOSection23');
                                            setShowTrackingModal(true);
                                        }}
                                        className="flex items-center px-4 py-2 rounded-lg transition-colors bg-purple-600 text-white hover:bg-purple-700"
                                    >
                                        Send Back to LAO
                                    </button>
                                )} */}

                                {/* Send Back to Samanvay */}
                                {/* {userRole === ROLES.COLLECTOR && (
                                    <button
                                        onClick={() => {
                                            setTrackingRole('Back_SamanvaySection23');
                                            setShowTrackingModal(true);
                                        }}
                                        className="flex items-center px-4 py-2 rounded-lg transition-colors bg-purple-600 text-white hover:bg-purple-700"
                                    >
                                        Send Back to Samanvay
                                    </button>
                                )} */}

                                {/* <button className="relative">
                                    <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                                        <Upload size={18} />
                                        <span>Upload Signature</span>
                                        <input
                                            type="file"
                                            accept="application/pdf,image/*"
                                            className="hidden"
                                            onChange={handleUploadedFile}
                                        />
                                    </label>
                                </button> */}

                                {currentType === 'prarupNivada' && (
                                    <>
                                        {/* {(userRole === ROLES.LAO || userRole === ROLES.SAMANVAY || userRole === ROLES.COLLECTOR) && ( */}
                                        {/* Data Entry */}
                                        {/* {(userRole === ROLES.LAO || userRole === ROLES.SAMANVAY || userRole === ROLES.COLLECTOR || userRole === ROLES.DATA_ENTRY) && (
                                            <button
                                                type="button"
                                                onClick={() => setIsEditing(true)}
                                                disabled={collectorEditCompletedbuttonDisabled && (approval === true || approval === 1)}
                                                className={`px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors 
                                            ${collectorEditCompletedbuttonDisabled && (approval === true || approval === 1)
                                                        ? 'bg-gray-400 text-white cursor-not-allowed'
                                                        : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                                            >
                                                <span>{translations[language]?.Edit}</span>
                                            </button>
                                        )} */}

                                        {userRole === ROLES.LAO && (
                                            <>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        if (buttonDisabled) {
                                                            showConfirm(
                                                                translations[language]?.confirmResubmission,
                                                                translations[language]?.resubmissionWarning,
                                                                () => {
                                                                    // what should happen on confirm
                                                                    setshowSendToSamanvayModal(true);
                                                                },
                                                                () => {
                                                                    // optional cancel callback
                                                                    console.log("Resend cancelled");
                                                                },
                                                                "danger" // modal color type
                                                            );
                                                        } else {
                                                            setshowSendToSamanvayModal(true);
                                                        }
                                                    }}
                                                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                                        ? "bg-red-600 text-white hover:bg-red-700"
                                                        : "bg-purple-600 text-white hover:bg-purple-700"
                                                        }`}
                                                    title={
                                                        buttonDisabled
                                                            ? translations[language]?.AlreadySentToSamanvayOfficerClickToResend
                                                            : translations[language]?.SendToSamanvayOfficer
                                                    }
                                                >
                                                    <Send className="mr-2 h-4 w-4" />
                                                    <span>{translations[language]?.SendToSamanvayOfficer}</span>
                                                </button>
                                            </>
                                        )}
                                           {userRole === ROLES.COLLECTOR && (
                                            <>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        if (buttonDisabled) {
                                                            showConfirm(
                                                                translations[language]?.confirmResubmission,
                                                                translations[language]?.resubmissionWarning,
                                                                () => {
                                                                    // what should happen on confirm
                                                                    setshowSendToSamanvayModal(true);
                                                                },
                                                                () => {
                                                                    // optional cancel callback
                                                                    console.log("Resend cancelled");
                                                                },
                                                                "danger" // modal color type
                                                            );
                                                        } else {
                                                            setshowSendToSamanvayModal(true);
                                                        }
                                                    }}
                                                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                                        ? "bg-red-600 text-white hover:bg-red-700"
                                                        : "bg-purple-600 text-white hover:bg-purple-700"
                                                        }`}
                                                    title={
                                                        buttonDisabled
                                                            ? translations[language]?.AlreadySentToSamanvayOfficerClickToResend
                                                            : translations[language]?.SendToSamanvayOfficer
                                                    }
                                                >
                                                    <Send className="mr-2 h-4 w-4" />
                                                    <span>{translations[language]?.SendToSamanvayOfficer}</span>
                                                </button>
                                            </>
                                        )}

                                        {userRole === ROLES.SAMANVAY && (
                                            <>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        if (buttonDisabled) {
                                                            showConfirm(
                                                                translations[language]?.confirmResubmission,
                                                                translations[language]?.resubmissionWarning,
                                                                () => {
                                                                    // what should happen on confirm
                                                                    setshowSendToCollectorModal(true);
                                                                },
                                                                () => {
                                                                    // optional cancel callback
                                                                    console.log("Resend cancelled");
                                                                },
                                                                "danger" // modal color type
                                                            );
                                                        } else {
                                                            setshowSendToCollectorModal(true);
                                                        }
                                                    }}
                                                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                                        ? "bg-red-600 text-white hover:bg-red-700"
                                                        : "bg-purple-600 text-white hover:bg-purple-700"
                                                        }`}
                                                    title={
                                                        buttonDisabled
                                                            ? translations[language]?.SendToCollectorAlreadySentClickToResend
                                                            : translations[language]?.SendToCollector
                                                    }
                                                >
                                                    <Send className="mr-2 h-4 w-4" />
                                                    <span>{translations[language]?.SendToCollector}</span>
                                                </button>
                                            </>
                                        )}

                                        {userRole === ROLES.SAMANVAY && (
                                            <>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        if (buttonDisabled) {
                                                            showConfirm(
                                                                translations[language]?.confirmResubmission,
                                                                translations[language]?.resubmissionWarning,
                                                                () => {
                                                                    // what should happen on confirm
                                                                    setshowSendToLAOModal(true);
                                                                },
                                                                () => {
                                                                    // optional cancel callback
                                                                    console.log("Resend cancelled");
                                                                },
                                                                "danger" // modal color type
                                                            );
                                                        } else {
                                                            setshowSendToLAOModal(true);
                                                        }
                                                    }}
                                                    className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                                                        ? "bg-red-600 text-white hover:bg-red-700"
                                                        : "bg-purple-600 text-white hover:bg-purple-700"
                                                        }`}
                                                    title={
                                                        buttonDisabled
                                                            ? translations[language]?.AlreadySentBackToLAOClickToResend
                                                            : translations[language]?.sendToLAO
                                                    }
                                                >
                                                    <Send className="mr-2 h-4 w-4" />
                                                    <span>{translations[language]?.sendToLAO}</span>
                                                </button>

                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Back Model */}
                    <SendTrackingModal
                        isOpen={showTrackingModal}
                        onClose={() => setShowTrackingModal(false)}
                        role={trackingRole}
                        projectId={projectId}
                        proposalId={proposalId}
                        translations={translations}
                        language={language}
                    />

                    {/* Main Document Display */}
                    <div>
                        {renderNotificationDocument(notificationContentRef)}
                    </div>

                    {/* Edit Modal */}
                    {isEditing && renderEditModal()}

                    {/* Send to Samanvay Modal */}
                    {showSendToSamanvayModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                                <div className="p-6">
{
    userRole === ROLES.COLLECTOR &&  (<div className="space-y-4">
                                        {/* Final Award Approval (Yes/No) */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                प्रारुप निवाडा मंजूर आहे का? *
                                            </label>
                                            <div className="flex items-center space-x-6">
                                                <label className="inline-flex items-center">
                                                    <input
                                                        type="radio"
                                                        name="isApproved"
                                                        value={1}
                                                        checked={isApproved === 1}
                                                        onChange={() => setIsApproved(1)}
                                                        className="text-blue-600 focus:ring-blue-500 border-gray-300"
                                                    />
                                                    <span className="ml-2 text-gray-700">होय</span>
                                                </label>
                                                <label className="inline-flex items-center">
                                                    <input
                                                        type="radio"
                                                        name="isApproved"
                                                        value={0}
                                                        checked={isApproved === 0}
                                                        onChange={() => setIsApproved(0)}
                                                        className="text-blue-600 focus:ring-blue-500 border-gray-300"
                                                    />
                                                    <span className="ml-2 text-gray-700">नाही</span>
                                                </label>
                                            </div>
                                        </div>

                                    
                                    </div>
                                )}
                                    


                                    <div className="space-y-4">
                                        {/* User Selection */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.selectUserSamanvayOfficer} *
                                            </label>
                                            <select
                                                value={selectedUserSamanvay}
                                                onChange={(e) => setselectedUserSamanvay(e.target.value)}
                                                disabled={loadingusersSamanvay}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingusersSamanvay ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                                </option>
                                                {usersSamanvay.map((user) => (
                                                    <option key={user.usr_id} value={user.usr_id}>
                                                        {user.full_name} ({user.usr_role})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Remarks */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.Remarks}
                                            </label>
                                            <textarea
                                                value={remarksSamanvay}
                                                onChange={(e) => setremarksSamanvay(e.target.value)}
                                                rows={3}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                placeholder="Enter remarks..."
                                            />
                                        </div>

                                        {/* Document Upload */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.UploadDocument} *
                                            </label>
                                            <input
                                                type="file"
                                                onChange={(e) => setselectedDocumentSamanvay(e.target.files[0])}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            />
                                            {selectedDocumentSamanvay && (
                                                <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                                                    <div className="flex items-center justify-between mb-2">
                                                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                                                            {translations[language]?.Selected}: {selectedDocumentSamanvay.name}
                                                        </p>
                                                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                                                            {(selectedDocumentSamanvay.size / 1024 / 1024).toFixed(2)} MB
                                                        </span>
                                                    </div>
                                                    <div className="flex gap-2">
                                                        {selectedDocumentSamanvay.type === 'application/pdf' && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        if (selectedDocumentSamanvay?.type === 'application/pdf') {
                                                                            setPdfForSigning(selectedDocumentSamanvay);
                                                                            setShowSignaturePad(true);
                                                                        }
                                                                    }}
                                                                    disabled={uploadStatus === 'uploading'}
                                                                    className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                                                                >
                                                                    {uploadStatus === 'uploading' ? (
                                                                        <>
                                                                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                                                            Signing...
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                            </svg>
                                                                            Sign Doc
                                                                        </>
                                                                    )}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleViewDocument(
                                                                        uploadStatus === 'success' ? selectedSignDocument : selectedDocumentSamanvay
                                                                    )}
                                                                    className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                                                                >
                                                                    <Eye className="h-3 w-3" />
                                                                    {translations[language]?.View}
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                    {/* Upload status messages */}
                                                    {uploadStatus === 'success' && (
                                                        <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                                                            ✅ Document Signed Successfully
                                                        </div>
                                                    )}
                                                    {uploadStatus === 'error' && uploadError && (
                                                        <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                                                            ❌ {uploadError}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Modal Actions */}
                                    <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                        <button
                                        onClick={handleCloseModal} 
                                         className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                          disabled={sendingToSamanvay}
                                            >
                                         {translations[language]?.Cancel}
                                        </button>
                                        <button
                                            onClick={handleSendToSamanvay}
                                            disabled={sendingToSamanvay || !selectedUserSamanvay || !selectedDocumentSamanvay}
                                            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                        >
                                            {sendingToSamanvay ? (
                                                <>
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                                    {translations[language]?.sending}
                                                </>
                                            ) : (
                                                <>
                                                    <Send className="mr-2 h-4 w-4" />
                                                    {translations[language]?.CommonSave}
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Send to Collector Modal */}
                    {showSendToCollectorModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                                <div className="p-6">
                                    {/* <div className="flex justify-between items-center mb-6">
                                    <h3 className="text-xl font-semibold text-gray-800">
                                      {translations[language]?.SendToCollector}
                                    </h3>
                                    <button
                                      onClick={() => setshowSendToCollectorModal(false)}
                                      className="text-gray-400 hover:text-gray-600"
                                    >
                                      <X className="h-6 w-6" />
                                    </button>
                                  </div> */}

                                    <div className="space-y-4">
                                        {/* User Selection */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.SelectUserCollector}*
                                            </label>
                                            <select
                                                value={selectedUserCollector}
                                                onChange={(e) => setselectedUserCollector(e.target.value)}
                                                disabled={loadingusersCollector}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingusersCollector ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                                </option>
                                                {usersCollectorAll.map((user) => (
                                                    <option key={user.usr_id} value={user.usr_id}>
                                                        {user.full_name} ({user.usr_role || user.user_role})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Remarks */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.Remarks}
                                            </label>
                                            <textarea
                                                value={remarksCollector}
                                                onChange={(e) => setremarksCollector(e.target.value)}
                                                rows={3}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                placeholder="Enter remarks..."
                                            />
                                        </div>

                                        {/* Document Upload */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Upload Document *
                                            </label>
                                            <input
                                                type="file"
                                                onChange={(e) => setselectedDocumentCollector(e.target.files[0])}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            />

                                        </div>

                                    </div>

                                    {/* Modal Actions */}
                                    <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                        <button
                                            onClick={() => {
                                                setshowSendToCollectorModal(false);
                                            }}
                                            className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                            disabled={sendingToCollector}
                                        >
                                            {translations[language]?.Cancel}
                                        </button>
                                        <button
                                            onClick={handleSendToCollector}
                                            disabled={sendingToCollector || !selectedUserCollector || !selectedDocumentCollector}
                                            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                        >
                                            {sendingToCollector ? (
                                                <>
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                                    {translations[language]?.Sending}
                                                </>
                                            ) : (
                                                <>
                                                    <Send className="mr-2 h-4 w-4" />
                                                    {translations[language]?.CommonSave}
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Send to LAO Modal */}
                    {showSendToLAOModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                                <div className="p-6">
                                    {/* <div className="flex justify-between items-center mb-6">
                                    <h3 className="text-xl font-semibold text-gray-800">
                                      {translations[language]?.SendBackToLAOOfficer}
                                    </h3>
                                    <button
                                      onClick={() => setshowSendToLAOModal(false)}
                                      className="text-gray-400 hover:text-gray-600"
                                    >
                                      <X className="h-6 w-6" />
                                    </button>
                                  </div> */}

                                    <div className="space-y-4">
                                        {/* Final Award Approval (Yes/No) */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                प्रारुप निवाडा मंजूर आहे का? *
                                            </label>
                                            <div className="flex items-center space-x-6">
                                                <label className="inline-flex items-center">
                                                    <input
                                                        type="radio"
                                                        name="isApproved"
                                                        value={1}
                                                        checked={isApproved === 1}
                                                        onChange={() => setIsApproved(1)}
                                                        className="text-blue-600 focus:ring-blue-500 border-gray-300"
                                                    />
                                                    <span className="ml-2 text-gray-700">होय</span>
                                                </label>
                                                <label className="inline-flex items-center">
                                                    <input
                                                        type="radio"
                                                        name="isApproved"
                                                        value={0}
                                                        checked={isApproved === 0}
                                                        onChange={() => setIsApproved(0)}
                                                        className="text-blue-600 focus:ring-blue-500 border-gray-300"
                                                    />
                                                    <span className="ml-2 text-gray-700">नाही</span>
                                                </label>
                                            </div>
                                        </div>

                                        {/* User Selection */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.SelectUserLAO}*
                                            </label>
                                            <select
                                                value={selectedUserLAO}
                                                onChange={(e) => setselectedUserLAO(e.target.value)}
                                                disabled={loadingusersLAO}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            >
                                                <option value="">
                                                    {loadingusersLAO ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                                </option>
                                                {usersLAO.map((user) => (
                                                    <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                                                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Remarks */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                {translations[language]?.Remarks}
                                            </label>
                                            <textarea
                                                value={remarksLAO}
                                                onChange={(e) => setremarksLAO(e.target.value)}
                                                rows={3}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                placeholder="Enter remarks..."
                                            />
                                        </div>

                                        {/* Document Upload */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Upload Document *
                                            </label>
                                            <input
                                                type="file"
                                                onChange={(e) => setselectedDocumentLAO(e.target.files[0])}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            />
                                        </div>
                                    </div>

                                    {/* Modal Actions */}
                                    <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                        <button
                                            onClick={() => {
                                                setshowSendToLAOModal(false);
                                            }}
                                            className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                            disabled={sendingToLAO}
                                        >
                                            {translations[language]?.Cancel}
                                        </button>
                                        <button
                                            onClick={handleSendToLAO}
                                            disabled={sendingToLAO || !selectedUserLAO || !selectedDocumentLAO}
                                            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                        >
                                            {sendingToLAO ? (
                                                <>
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                                    {translations[language]?.Sending}
                                                </>
                                            ) : (
                                                <>
                                                    <Send className="mr-2 h-4 w-4" />
                                                    {translations[language]?.CommonSave}
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Unified Document Viewer Modal */}
                    {showDocumentViewer && (
                        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                            <div className="bg-white rounded-3xl w-full max-w-5xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
                                {/* Header */}
                                <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
                                    <div className="flex items-center space-x-3">
                                        <h3 className="text-2xl font-bold text-gray-800 tracking-tight">Document Preview</h3>
                                    </div>
                                    <button
                                        onClick={closeDocumentViewer}
                                        className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold shadow-sm hover:shadow-md"
                                        aria-label="Close modal"
                                    >
                                        ×
                                    </button>
                                </div>

                                {/* Document Viewer Container */}
                                <div className="h-[calc(95vh)] flex flex-col">
                                    <div className="flex-1 bg-gray-50 overflow-hidden shadow-inner border border-gray-200">
                                        {/* Document Content */}
                                        <div className="w-full h-full flex items-center justify-center">
                                            {isPDFToView ? (
                                                <iframe
                                                    src={fileUrlToView}
                                                    className="w-full h-full border-0 bg-white shadow-lg"
                                                    title="PDF Preview"
                                                ></iframe>
                                            ) : (
                                                <img
                                                    src={fileUrlToView}
                                                    alt="File"
                                                    className="w-full h-full object-contain shadow-lg"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {showAlertModal && (
                        <div className="fixed top-4 right-4 z-50">
                            <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
                                alertConfig.type === 'warning' ? 'border-yellow-500' :
                                    alertConfig.type === 'info' ? 'border-blue-500' :
                                        'border-green-500'
                                }`}>
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                                            alertConfig.type === 'warning' ? 'bg-yellow-100' :
                                                alertConfig.type === 'info' ? 'bg-blue-100' :
                                                    'bg-green-100'
                                            }`}>
                                            <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                                                alertConfig.type === 'warning' ? 'text-yellow-600' :
                                                    alertConfig.type === 'info' ? 'text-blue-600' :
                                                        'text-green-600'
                                                }`}>
                                                {alertConfig.type === 'error' ? '✕' :
                                                    alertConfig.type === 'warning' ? '⚠' :
                                                        alertConfig.type === 'info' ? 'ℹ' : '✓'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="ml-3 flex-1">
                                        <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                                        <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
                                    </div>
                                    <button
                                        onClick={() => setShowAlertModal(false)}
                                        className="ml-4 text-gray-400 hover:text-gray-600"
                                    >
                                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Confirmation Modal */}
                    {showConfirmModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                                <div className="p-6">
                                    <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                            'bg-blue-100'
                                        }`}>
                                        {confirmConfig.type === 'danger' ? '⚠' :
                                            confirmConfig.type === 'warning' ? '⚠' : '?'}
                                    </div>

                                    <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                        {confirmConfig.title}
                                    </h3>

                                    <p className="text-gray-600 text-sm mb-6 text-center">
                                        {confirmConfig.message}
                                    </p>

                                    <div className="flex gap-3">
                                        <button
                                            onClick={() => {
                                                setShowConfirmModal(false);
                                                if (confirmConfig.onCancel) confirmConfig.onCancel();
                                            }}
                                            className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                        >
                                            {translations[language]?.Cancel}
                                        </button>
                                        <button
                                            onClick={() => {
                                                setShowConfirmModal(false);
                                                if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                            }}
                                            className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                                confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                                    'bg-blue-600 hover:bg-blue-700'
                                                }`}
                                        >
                                            {translations[language]?.Confirm}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {showSignaturePad && pdfForSigning && (
                    <SignaturePad
                        pdfFile={pdfForSigning}
                        onSign={(signaturesArray) => {
                            setShowSignaturePad(false);

                            signDocument(pdfForSigning, signaturesArray).then(async (signedPdf) => {
                                const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
                                const projectId = selectedProject?.id || selectedProject?.project_id;
                                const proposalId = localStorage.getItem("currentProposalId");

                                await apiService.postAddSignaturePDF(
                                    projectId,
                                    proposalId,
                                    "section23",
                                    pdfForSigning
                                );

                                const sectionRes = await apiService.getSectionFile(
                                    projectId,
                                    proposalId,
                                    "section23"
                                );

                                if (sectionRes?.isSignAvailable) {
                                    setPreviewUrl(sectionRes.data[0].file_path);
                                }

                                setPdfForSigning(null);
                            });
                        }}
                        onCancel={() => {
                            setShowSignaturePad(false);
                            setPdfForSigning(null);
                        }}
                    />
                )}
            </div>

        </>
    );
}

export default Section23;